<!-- eslint-disable no-unused-vars -->
<!-- eslint-disable no-unused-vars -->

<template>
  <!-- partial -->
  <div class="main-panel">
    <div class="content-wrapper">
      <div class="row">
        <div class="col-12 grid-margin">
          <div class="card">
            <div class="card-body">
              <form-tag @ClienteEditEvent="submitHandler" name="clienteForm" event="clienteEditEvent" id="cliente-form">
                <div class="row mb-3 d-flex justify-content-center align-item-center">


                  <div class="col-12 col-lg-3 ">
                    <h4 v-if="this.idSolicitud > 0" style="font-size: 20px" class="ms-2 mt-3 mb-4">
                      Solicitud de Crédito
                    </h4>
                    <h4 v-else style="font-size: 20px" class="ms-2 mt-3 mb-4">
                      Nueva Solicitud de Crédito
                    </h4>
                  </div>
                  
                  <div class="col-lg-9 col-12 d-flex align-items-start justify-content-end " style="height: 90%">
                    <input v-if="this.idSolicitud <= 0" type="submit" class="btn btn-dark" value="Guardar" />
                    <div class="btnOptionSolicitud" v-else>
                      <select v-model="reportes" class="form-select w-50" name="reportes"  aria-label="Default select example">
                        <option >Reportes</option>
                        <option  value="reporte1">Exportar Solicitud <i class="fa-solid fa-download"></i></option>
                        <option  value="reporte5">Exportar Nota Cambio de Tasa <i class="fa-solid fa-download"></i></option>
                        <option value="reporte2" v-if="this.solicitud.estado === 'Aprobado' || this.solicitud.estado === 'Desembolsado'" 
                        >Exportar Contrato <i class="fa-solid fa-download"></i></option>
                        <option value="reporte3" v-if="this.solicitud.estado === 'Aprobado' || this.solicitud.estado === 'Desembolsado'" 
                        >Exportar Pagaré <i class="fa-solid fa-download"></i></option>
                        <option value="reporte4" v-if="this.solicitud.estado === 'Aprobado' || this.solicitud.estado === 'Desembolsado'" 
                        >Exportar Avales Solidarios <i class="fa-solid fa-download"></i></option>
                      </select>
                      <button v-if="this.solicitud.estado !== 'Aprobado' && this.solicitud.estado !== 'Desembolsado'"
                        type="submit" class="btn btn-primary d-flex justify-content-center align-item-center">
                        Actualizar <i class="fa-solid fa-floppy-disk ms-2"></i>
                      </button>
                      <button v-else-if="this.userRoles[0].some(role => role === 'Modo Thanos') ||  this.userRoles[0].some(role => role === 'Asesor') " type="submit"
                        class="btn btn-primary d-flex justify-content-center align-item-center">
                        Actualizar <i class="fa-solid fa-floppy-disk ms-2"></i>
                      </button>
                      <div v-if="this.Asesor !== true">
                        <button type="button" v-if="this.solicitud.estado === 'Pendiente'" class="btn btn-warning"
                          data-bs-toggle="modal" data-bs-target="#estadoSolicitud">
                          Estado {{ this.solicitud.estado }}
                        </button>
                        <button type="button"
                          v-else-if="(this.solicitud.estado === 'Aprobado') && (this.Admin || this.Coordinacion)"
                          class="btn btn-success" data-bs-toggle="modal" data-bs-target="#estadoSolicitud">
                          Estado {{ this.solicitud.estado }}
                        </button>
                        <button type="button" v-else-if="this.solicitud.estado === 'Aprobado'" class="btn btn-success"
                          disabled>
                          Estado {{ this.solicitud.estado }}
                        </button>
                        <button type="button"
                          v-else-if="this.solicitud.estado === 'Rechazado' && (this.Admin || this.Coordinacion)"
                          class="btn btn-danger" data-bs-toggle="modal" data-bs-target="#estadoSolicitud">
                          Estado {{ this.solicitud.estado }}
                        </button>
                        <button type="button" v-else-if="this.solicitud.estado === 'Rechazado'" class="btn btn-danger"
                          data-bs-toggle="modal" data-bs-target="#estadoSolicitud" disabled>
                          Estado {{ this.solicitud.estado }}
                        </button>
                        <button type="button" v-else-if="this.solicitud.estado === 'Desembolsado'" class="btn btn-dark"
                          disabled>
                          Estado {{ this.solicitud.estado }}
                        </button>
                      </div>
                    </div>



                  </div>

                </div>
                <div class="accordion" id="accordionPanelsStayOpenExample">
                  <!-- Aqui va datos Solicitante -->
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="data-headingOne">
                      <button class="accordion-button" type="button" data-bs-toggle="collapse"
                        data-bs-target="#datos-collapseOne" aria-expanded="true"
                        aria-controls="panelsStayOpen-collapseOne">
                        <div class="col-6">Datos Solicitante</div>
                        <div id="validar-1" class="d-flex justify-content-end me-3" style="width: 100%"></div>
                      </button>
                    </h2>
                    <div id="datos-collapseOne" class="accordion-collapse collapse show"
                      aria-labelledby="data-headingOne">
                      <div class="accordion-body">

                        <!-- FICHA DE BENEFICIARIO -->
                        <div class="container-fluid p-0 ">
                          <!-- <h4 class="display-4">Ficha de Beneficiario</h4> -->

                            <div class="row">
                          <div v-if="this.idSolicitud <= 0" class="col-12 col-lg-4 mt-1">
                            <p class="ms-3 mb-1">Busca por DNI</p>
                            <input v-model="dni" @input="formatInput" placeholder="Ejemplo: 0801-1998-02195"
                              class="form-control" style="height: 20px" type="text" minlength="15" maxlength="15"
                              id="dni" required />

                              <div v-if="this.cliente && Object.keys(this.cliente).length > 0">
                                <button @click="irASolicitante(this.cliente)" class="btn btn-primary w-100 mt-2">
                                  Actualizar y Validar Beneficiario 
                                </button>
                              </div>
                              <div v-else>
                                 <router-link class="nav-link w-100" to="/solicitante/nuevo">Crear Nuevo
                                  Beneficiario</router-link>
                              </div>

                            <p v-if="this.store.aprobacion.validacion" class="text-success mt-4">
                              Validado <i class="fa-solid fa-circle-check"></i>
                            </p>

                          </div>
                          
                          <div v-if="this.cliente" :class="(this.idSolicitud <= 0)?'info-clientes col-12 col-lg-8 mt-3 mt-lg-0':'' ">
                            <div class="row">
                            <div    class="col-7 mt-2 d-flex flex-column justify-content-center align-item-center">
                            <div class="d-flex justify-content-between justify-content-center align-item-center">
                              {{ this.cliente.nombres }} {{ this.cliente.apellidos }}
                            </div>
                            <strong class="mt-1">{{ this.cliente.dni }}</strong>  
                            
                            <div class="d-flex mt-3 justify-content-between justify-content-center align-item-center extra-info">
                            <p>RTN:</p> <p>{{ this.cliente.rtn }}</p>
                            </div>
                            <div class="d-flex justify-content-between justify-content-center align-item-center extra-info">
                            <p>No Teléfono: </p> <p>{{ this.cliente.celular }}</p>
                            </div>
                            <div class="d-flex justify-content-between justify-content-center align-item-center extra-info">
                            <p>No Teléfono Negocio: </p> <p>{{ this.cliente.telefono }}</p>
                            </div>
                            </div>

                            <div class="col-5 d-flex justify-content-center align-item-center">
                              
                              <!-- <div v-if="this.cliente.foto" class="foto-cliente d-flex justify-content-center align-item-center">
                                <img :src="this.cliente.foto" alt="Foto Cliente" style="width: 100px; height: 100px; object-fit: cover; border-radius: 50%;" />
                              </div> -->
                              <!-- <div v-else class="foto-cliente d-flex justify-content-center align-item-center">
                                <img src="/assets/images/faces/face1.jpg" alt="Foto Cliente" style="width: 100px; height: 100px; object-fit: cover; border-radius: 50%;" />
                              </div> -->
                              <!-- <div class="con-foto">
                                <i class="fa-solid fa-user"></i>
                              </div> -->
                              <!-- {{this.FotoCliente}} -->
                              <div class="sin-foto">
                                <img v-if="this.FotoCliente != ''" :src="'data:image/png;base64,'+this.FotoCliente" alt="Foto Cliente" style=" border-radius: 5px; height: 100%; object-fit: cover;" />

                                <i v-else class="fa-solid fa-user"></i>
                              </div>
                            </div>
                            </div>
                          </div>                           

                          <!-- {{ this.score }} {{ this.claseScore }} -->
                          <button v-if="cliente " class="btn btn-dark ms-3" type="button" @click="viewScore = !viewScore" style="width: 200px; margin-top: 15px;">
                            {{(!viewScore)?'Ver Puntaje de Crédito':'Ocultar Puntaje de Crédito'}}
                          </button>

                          
                          
                          <div v-if="cliente && viewScore" class="row rounded p-3 mt-3 m-5" style="background: #f8f9fa; width: 90%">
                              <h4 class="mt-3 mb-2 ms-5">Puntaje de Crédito</h4>

                            <div  class="col-12 ">
                              <ScoreDetails
                                :puntaje_equifax="cliente.puntaje_equifax"
                                :ingresos_mensuales="cliente.ingresos_mensuales"
                                :dti="cliente.dti"
                                :antiguedad_cantidad="cliente.antiguedad_cantidad"
                                :antiguedad_unidad="cliente.antiguedad_unidad"
                                :garantia="cliente.garantia"
                                :comportamiento="cliente.comportamiento"
                                currency="Lps"
                                v-model:score="this.score"
                                v-model:class="this.claseScore"
                              />

                            </div>

                          <p v-if="cliente && score <= 6" class="text-danger ms-3 mt-3">
                            Puntaje de Crédito necesita ser llenado
                          </p>
                          </div>
                          




                        </div>

                        
                        </div>

                      </div>
                    </div>
                  </div>
                  
                  <!-- {{this.store.aprobacion.validacion}} -->
                  <!-- Aqui va condiciones Credito -->

                  <div class="accordion-item">
                    <h2 class="accordion-header" id="panelsStayOpen-headingTwoMore">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#panelsStayOpen-collapseTwoMore" aria-expanded="false"
                        aria-controls="panelsStayOpen-collapseTwoMore">
                        <div class="col-6">
                          Condiciones del Crédito
                        </div>
                        <div id="validar-2" class="d-flex justify-content-end me-3" style="width: 100%">
                          {{ this.solicitud.producto }}
                        </div>
                      </button>
                    </h2>
                    <div id="panelsStayOpen-collapseTwoMore" class="accordion-collapse collapse"
                      aria-labelledby="panelsStayOpen-headingTwoMore">
                      <div class="accordion-body">

                        <div class="row">

                          <div class="col-12 col-lg-6 mb-3">
                            <label class="col-sm-9 col-form-label"
                              >Selecciona el Producto</label
                            >
                          <div class="col-sm-9 d-flex align-items-center">
                            <select
                              v-model="solicitudCompleta.producto"
                              class="form-select"
                              aria-label="Default select example"
                              :required="(this.modoThanos === true) ? true : true"
                            >
                              <!-- <option value="Escalonado">Escalonado</option> -->
                              <!-- <option value="MIPYME">MIPYME</option>
                              <option value="Crédito Agrícola">Crédito Agrícola</option>
                              <option value="Cadenas Productivas">CADENAS PRODUCTIVAS</option>
                              <option value="Cajas Rurales">CAJAS RURALES , COOPERATIVAS O EMPRESAS DEL SECTOR SOCIAL DE LA ECONOMIA</option>
                              <option value="Credito Salud">CRÉDITO SALUD</option>
                              <option value="Credimur">CREDIMUR</option>
                              <option value="Prestamo Navideño">PRESTAMO NAVIDEÑO</option>-->
                              <!-- <option value="Credi Trabajo">CREDI TRABAJO</option>  -->
                              <!-- <option value="Credi Trabajo 2">CREDI TRABAJO 2</option> -->
                              <option v-if="solicitudCompleta.producto" :value="(solicitudCompleta.producto)?(solicitudCompleta.producto):''">{{ solicitudCompleta.producto }}</option>
                              <option value="MICROCREDITO">MICROCREDITO</option>
                              <option value="AGRICOLA">AGRICOLA</option>
                              <option value="CREAFUTURO">CREAFUTURO</option>
                              <option value="Credi Impulsa">CREDI IMPULSA</option>
                            </select>
                          </div>
                        </div>
                          <div class="col-12 col-lg-6 mb-3">
                            <label class="col-sm-9 col-form-label"
                              >Sucursal</label
                            >
                          <div class="col-sm-9 d-flex align-items-center">
                            <select v-model="solicitud.sucursal" id="sucursal" name="sucursal" class="form-select"
                                          :required="(this.modoThanos === true) ? true : true">
                                          <option v-for="(departamentos, index) in departamentos" :key="index"
                                            :value="departamentos">
                                            {{ departamentos }}
                                          </option>
                                          </select>
                          </div>
                        </div>
                          <!-- <div class="col-12 col-lg-6 mb-3">

                                    <div class="form-group row">
                                      <label class="col-sm-3 col-form-label">sucursal</label>
                                      <div class=" d-flex align-items-center">
 
                                        <select v-model="solicitud.sucursal" id="sucursal" name="sucursal" class="form-select"
                                          :required="(this.modoThanos === true) ? true : true">
                                          <option v-for="(departamentos, index) in departamentos" :key="index"
                                            :value="departamentos">
                                            {{ departamentos }}
                                          </option>
                                        </select>
                                      </div>
                                    </div>
                        </div> -->
                        </div>

                        <!-- Plan pagos -->
                        <div id="contenedor-plan">
                          <div class="header d-flex justify-content-between">
                            <!-- <h3>Generador Plan de Pago</h3> -->

                            <div class="row ">
                              <PlanPago
                                :fechaPago="this.solicitud.fechaPago ? this.solicitud.fechaPago : (new Date()).toISOString().slice(0, 10)"
                                :monto="Number(this.solicitud.monto)" :frecuenciaPago="this.solicitud.frecuenciaPago"
                                :interes="this.solicitud.interes" :plazoPago="Number(this.solicitud.plazoPago || 0)"
                                :producto="this.solicitudCompleta.producto"
                                :periodoGracia="this.solicitud.periodoGracia" :fechaFija="this.solicitud.fechaFija"
                                :frecuenciaPagoGracia="this.solicitud.frecuenciaPagoGracia"
                                :pagosInteres="this.pagosInteres" />
                            </div>
                          </div>

                          <div name="frmPrestamo" id="frmPrestamo">
                            <div v-if="creditrabajo2()" class="control d-flex flex-column">
                              <h4>Producto: {{ this.solicitudCompleta.producto }} </h4>
                              <label class="mb-2"><strong>Monto Credito:</strong> {{
                                this.formatoNumero(this.solicitud.monto) }} {{
                                  this.moneda }}</label>

                              <label for="interes"> <strong> Interés (anual):</strong> {{ this.solicitud.interes }}
                                % ({{ this.formatoNumero(this.montoInteres) }} {{ this.moneda }})</label>
                              <label for="interes"> <strong> Interés (mensual):</strong> {{ this.solicitud.interes / 12
                              }}
                                % </label>
                              <label for="interes"> <strong> Comisión por desembolso: </strong> {{
                                this.comisionDesembolso }} % ({{ this.formatoNumero(this.totalComisionDesembolso) }} {{
                                  this.moneda
                                }})</label>
                              <label for="interes"><strong>Comisión por asistencia técnica: </strong>{{
                                this.comisionAsistenciaTecnica }} % ({{
                                  this.formatoNumero(this.totalComisionAsistenciaTecnica) }} {{
                                  this.moneda }})</label>
                              <label for="interes"><strong>Tasa de seguridad: </strong> {{ this.tasaSeguridad }}
                                % ({{ this.formatoNumero(this.totalTasaSeguridad) }} {{ this.moneda }})</label>

                            </div>


                            <!-- Datos Automaticos de CREAFUTURO -->
                            <div v-if="creaFuturo() == true || microCredito() == true" class="control d-flex flex-column mt-2 mb-3">
                                <div class="row">

                                  <div class="col-12 col-lg-6 d-flex flex-column">
                                    <label class=""><strong>Monto Desembolsar:</strong>
                                    {{this.formatoNumero(this.solicitud.montoDesembolsar) }} {{ this.moneda }}  </label>
                                      <label for="interes"> <strong> Comisión por desembolso: </strong> {{
                                      this.comisionDesembolso }} % ({{ this.formatoNumero(this.totalComisionDesembolso) }}
                                      {{ this.moneda }})</label>
                                    <label for="interes"><strong>Comisión por asistencia técnica: </strong>{{
                                      this.comisionAsistenciaTecnica }} % ({{
                                        this.formatoNumero(this.totalComisionAsistenciaTecnica) }} {{
                                        this.moneda }})</label>
                                    <label for="interes"><strong>Tasa de seguridad: </strong> {{ this.tasaSeguridad }}
                                      % ({{ this.formatoNumero(this.totalTasaSeguridad) }} {{ this.moneda }})</label>
                                    
                                  </div>
                                  <div class="col-12 col-lg-6  d-flex flex-column">
                                    <label for="interes"><strong>Reservas y seguros: </strong> {{ this.reservasSeguros }}
                                      % ({{ this.formatoNumero(this.totalReservasSeguros) }} {{ this.moneda }})</label>
                                    <label for="interes"><strong>Consultas y buró de crédito: </strong> {{ this.consultasBuro}}
                                      % ({{ this.formatoNumero(this.totalConsultasBuro) }} {{ this.moneda }})</label>
                                    <label for="interes"><strong>Cobro de ACH: </strong> {{
                                      this.formatoNumero(this.cobroPorACH) }} {{ this.moneda }}</label>
                                    <label v-if="this.cliente" for="interes"><strong>Banco: </strong> {{
                                      this.cliente?.nombreBanco }}</label>
                                  </div>
                                  
                                  
                                  

                                </div>
                            </div>

                            <div class="row d-flex justify-content-center align-item-center">

                            <div class="control col-12 col-lg-6">
                              <label for="fecha">Fecha: </label>
                              <input type="date" :required="(this.modoThanos === true) ? false : true"
                                class="form-control mb-2" v-model="solicitud.fechaPago" name="fecha" id="fecha"
                                placeholder="fecha">
                            </div>
                            
                            <div v-if="creditrabajo2()" class="control col-12 col-lg-6">

                              <label for="monto">Monto a Desembolsar: </label>
                              <!-- <input type="number"  class="form-control" v-model="solicitud.monto"
                                name="monto" id="monto" placeholder="monto" min="500.00" max="300000.00"> -->
                              {{ this.solicitud.montoDesembolsar }}
                              <input type="text" :required="(this.modoThanos === true) ? false : true"
                                class="form-control" v-model="montoDesembolsar" name="montoDesembolsar"
                                id="montoDesembolsar" placeholder="monto" pattern="\d+(\.\d{1,2})?" min="500"
                                max="300000" @blur="onBlur">

                            </div>
                            <div v-if="creaFuturo()" class="control col-12 col-lg-6">

                              <label for="monto">Monto Credito: </label>
                              <!-- <input type="number"  class="form-control" v-model="solicitud.monto"
                                name="monto" id="monto" placeholder="monto" min="500.00" max="300000.00"> -->

                              <input type="text" :required="(this.modoThanos === true) ? false : true"
                                class="form-control" v-model="this.solicitud.monto" name="montoDesembolsar"
                                id="montoDesembolsar" placeholder="monto" pattern="\d+(\.\d{1,2})?" min="500"
                                max="300000" @blur="onBlur">

                            </div>
                            <div v-else class="control col-12 col-lg-6">

                              <label for="monto">Monto Aprobado: </label>
                              <!-- <input type="number"  class="form-control" v-model="solicitud.monto"
                                name="monto" id="monto" placeholder="monto" min="500.00" max="300000.00"> -->
                              <input type="text" :required="(this.modoThanos === true) ? false : true"
                                class="form-control" v-model="solicitud.monto" name="monto" id="monto"
                                placeholder="monto" pattern="\d+(\.\d{1,2})?" min="500" max="300000">
                            </div>

                            <div class="control col-12 col-lg-6">
                              <label for="periodo">Periodo de pago:</label>

                              <select v-if="creditrabajo2()" v-model="solicitud.frecuenciaPago"
                                :required="(this.modoThanos === true) ? false : true" class="form-control"
                                name="periodo" id="periodo" disabled>
                                <option value="semanal">semanal</option>

                              </select>
                              <select v-else v-model="solicitud.frecuenciaPago"
                                :required="(this.modoThanos === true) ? false : true" class="form-control"
                                name="periodo" id="periodo">
                                <option value="semanal">semanal</option>
                                <option value="quincenal">quincenal</option>
                                <option value="mensual">mensual</option>
                                <option value="al vencimiento">Al Vencimiento</option>
                                <option value="bimensual">bimensual</option>
                                <option value="trimestral">trimestral</option>
                                <option value="semestral">semestral</option>
                                <option value="anual">anual</option>
                              </select>
                            </div>

                            <div v-if="!(creditrabajo2())" class="control col-12 col-lg-6">
                              <label for="interes">Interés (anual): </label>
                              <input v-if="this.microCredito()" type="number" class="form-control" disabled v-model="solicitud.interes"
                                :required="(this.modoThanos === true) ? false : true" name="interes" id="interes"
                                placeholder="interés" min="5" max="100" step=".01">
                              <input v-else type="number" class="form-control" v-model="solicitud.interes"
                                :required="(this.modoThanos === true) ? false : true" name="interes" id="interes"
                                placeholder="interés" min="5" max="100" step=".01">


                            </div>

                            <!-- Plazo -->

                            <div v-if="creditrabajo2()" class="control col-12 col-lg-6">
                              <label for="plazo">Plazo: (Mensual) </label>
                              <input type="number" class="form-control" placeholder="Plazo Pago"
                                :required="(this.modoThanos === true) ? false : true" name="plazo"
                                v-model="solicitud.plazoPago" id="plazo" min="1" max="6" step="1">
                              <p v-if="creditrabajo2() && (solicitud.plazoPago < 1 || solicitud.plazoPago > 6)"
                                class="text-danger">El plazo debe estar entre el rango de 1 a 6 meses</p>
                            </div>

                            <div
                              v-else-if="  this.solicitud.frecuenciaPago == 'semestral' || this.solicitud.frecuenciaPago == 'anual'"
                              class="control col-12 col-lg-6">
                              <label for="periodo">Periodo de pago:</label>
                              <select v-model="solicitud.plazoPago"
                                :required="(this.modoThanos === true) ? false : true" class="form-control" name="plazo"
                                id="plzao">
                                <option value="6">6 Meses</option>
                                <option value="12">12 Meses</option>
                                <option value="18">18 Meses</option>
                                <option value="24">24 Meses</option>
                                <option value="36">36 Meses</option>
                                <option value="48">48 Meses</option>
                                <option value="60">60 Meses</option>
                                <option value="72">72 Meses</option>
                              </select>
                            </div>
                            <div
                              v-else-if="this.solicitud.frecuenciaPago == 'trimestral'"
                              class="control col-12 col-lg-6">
                              <label for="periodo">Periodo de pago:</label>
                              <select v-model="solicitud.plazoPago"
                                :required="(this.modoThanos === true) ? false : true" class="form-control" name="plazo"
                                id="plzao">
                                <option value="3">3 Meses</option>
                                <option value="6">6 Meses</option>
                                <option value="9">9 Meses</option>
                                <option value="12">12 Meses</option>
                                <option value="15">15 Meses</option>
                                <option value="18">18 Meses</option>
                                <option value="21">21 Meses</option>
                                <option value="24">24 Meses</option>
                                <option value="27">27 Meses</option>
                                <option value="30">30 Meses</option>
                                <option value="36">36 Meses</option>
                                <option value="48">48 Meses</option>
                                <option value="60">60 Meses</option>
                                <option value="72">72 Meses</option>
                              </select>
                            </div>
                            <div v-else class="control col-12 col-lg-6">
                              <label for="plazo">Plazo: (Mensual) </label>
                              <input type="number" class="form-control" placeholder="Plazo Pago"
                                :required="(this.modoThanos === true) ? false : true" name="plazo"
                                v-model="solicitud.plazoPago" id="plazo" min="1" step="1">
                            </div>
                            
                            <div class="control col-12 col-lg-6">
                              
                            </div>
                            
                            </div>

                            <div class="row d-flex justify-content-center align-item-center p-5" style="background: #f8f9fa; border-radius: 5px;">
                              
                              <div class=" ps-5 col-12 col-lg-6 d-flex justify-content-center flex-column align-item-center">

                                  <div class="form-check ">
                                    <input v-model="this.solicitud.fechaFija" class="form-check-input" type="checkbox"
                                      value="" id="checkDefault">
                                    <label class="form-check-label" for="checkDefault">
                                      Fecha Fija
                                    </label>
                                  </div>
                                <div class="form-check mt-4">
                                  <input v-model="this.arregloPagoIntereses" class="form-check-input" type="checkbox"
                                    value="" id="checkDefault">
                                  <label class="form-check-label" for="checkDefault">
                                    Arreglo de Pago Intereses
                                  </label>
                                </div>
                                <div  v-if="this.modoThanos" class="form-check  mt-4">
                                  <input v-model="this.solicitud.sinMora" class="form-check-input" type="checkbox"
                                    value="" id="checkDefault">
                                  <label class="form-check-label" for="checkDefault">
                                    Arreglo Mora
                                  </label>
                                </div>
                              </div>
                              <div class=" col-12 col-lg-6">
                                <div>
                                  <label for="periodoGracia">Periodo Gracia: (Cuotas) </label>
                                  <input type="number" class="form-control" placeholder="Periodo Gracia"
                                    :required="(this.modoThanos === true) ? false : false" name="gracia"
                                    v-model="solicitud.periodoGracia" id="gracia" min="0" :max="this.solicitud.plazoPago-1" step="1">
                                </div>
                                <div>
                                  <label for="periodo">Frecuencia de Pago:</label>
                                  <select v-model="solicitud.frecuenciaPagoGracia"
                                    :required="(this.modoThanos === true) ? false : true" class="form-control"
                                    name="periodo" id="periodo">
                                    <option value="semanal">semanal</option>
                                    <option value="quincenal">quincenal</option>
                                    <option value="mensual">mensual</option>
                                    <option value="al vencimiento">Al Vencimiento</option>
                                    <option value="bimensual">bimensual</option>
                                    <option value="trimestral">trimestral</option>
                                    <option value="semestral">semestral</option>
                                    <option value="anual">anual</option>
                                  </select>
                                </div>

                              </div>
                              
                       
                              
                              
                         
                        </div>


                            <div v-if="arregloPagoIntereses" class="arreglo-pago-interes">
                              <p class="display-5 pb-3">Arreglo de pago Intereses</p>
                              <div>
                                <p class="text-success" v-if="validarPagosInteres">Monto Correcto</p>
                                <p class="text-danger" v-else>Necesita Corrección</p>
                              </div>

                              <div>
                                <label for="monto">Monto Interés total: </label>
                                <input type="text" :required="!modoThanos" class="form-control" v-model="montoAPInteres"
                                  name="montoAPInteres" id="montoAPInteres" placeholder="montoAPInteres"
                                  pattern="\d+(\.\d{1,2})?" />

                                <label for="noPagosAPInteres">Cantidad de pagos: </label>
                                <input type="number" :required="!modoThanos" class="form-control"
                                  v-model.number="noPagosAPInteres" name="noPagosAPInteres" id="noPagosAPInteres"
                                  placeholder="noPagosAPInteres" min="1" @change="generarPagosInteres" />
                              </div>

                              <div class="mt-4" v-if="pagosInteres.length > 0">
                                <p class="h5">Detalle de pagos</p>

                                <div v-for="(pago, index) in pagosInteres" :key="index" class="mb-3 border rounded p-3">
                                  <label>Monto del pago {{ index + 1 }}</label>
                                  <input type="number" :required="!modoThanos" class="form-control mb-2"
                                    v-model.number="pago.monto" placeholder="Monto" min="0" step="0.01" />

                                  <label>Fecha del pago {{ index + 1 }}</label>
                                  <input type="date" :required="!modoThanos" class="form-control"
                                    v-model="pago.fecha" />
                                </div>
                              </div>
                            </div>


                            
                          </div>
                        </div>

                        <!-- Modal -->

                        <!-- <div class="modal fade" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false"
                          tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
                          <div class="modal-dialog modal-dialog-scrollable modal-xl">
                            <div class="modal-content">
                              <div class="modal-header">
                                <h1 class="modal-title fs-5" id="staticBackdropLabel">Plan de Pagos</h1>
                                <button type="button" class="btn-close" data-bs-dismiss="modal"
                                  aria-label="Close"></button>
                              </div>
                              <div class="modal-body">
                                <div id="contenedorTabla">
                                  <div class="header">
                                    <h2>Tabla de amortizaciones</h2>
                                  </div>
                                  <table class="table table-striped table-hover">

                                    <thead class="table-dark">
                                      <tr>
                                        <th scope="col">No. Cuota</th>
                                        <th scope="col">Fecha de Pago</th>
                                        <th scope="col">Cuota Total</th>
                                        <th scope="col">Interés</th>
                                        <th scope="col">Capital</th>
                                        <th scope="col">Saldo</th>
                                      </tr>
                                    </thead>
                                    <tbody id="tablaPlanPagos">

                                    </tbody>
                                  </table>
                                  <div id="amortizaciones">

                                  </div>
                                </div>
                              </div>
                              <div class="modal-footer">
                                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cerrar</button>
                              </div>
                            </div>
                          </div>
                        </div> -->


                      </div>
                    </div>
                  </div>
                  <div v-if="this.store.aprobacion.validacion">

                  <!-- Aqui va destino Credito -->
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="panelsStayOpen-headingThree">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#panelsStayOpen-collapseThree" aria-expanded="false"
                        aria-controls="panelsStayOpen-collapseThree">
                        <div class="col-6">
                          Destino del Crédito
                        </div>
                        <div id="validar-3" class="d-flex justify-content-end me-3" style="width: 100%">

                        </div>
                      </button>
                    </h2>
                    <div id="panelsStayOpen-collapseThree" class="accordion-collapse collapse"
                      aria-labelledby="panelsStayOpen-headingThree">
                      <div class="accordion-body">
                        <!-- Acorddion Body -->
                        <div class="form-group row">
                          <div class="col-sm-9 ms-4">
                            <div class="form-check">
                              <input class="form-check-input" type="checkbox" id="emprenderCheckbox"
                                v-model="solicitud.destinoCreditos" value="Emprender un Negocio" />
                              <label class="form-check-label" for="emprenderCheckbox">
                                Emprender un Negocio
                              </label>
                            </div>
                            <div class="form-check">
                              <input class="form-check-input" type="checkbox" id="maquinariaCheckbox"
                                v-model="solicitud.destinoCreditos" value="Comprar maquinaria y equipo" />
                              <label class="form-check-label" for="maquinariaCheckbox">
                                Comprar maquinaria y equipo
                              </label>
                            </div>
                            <div class="form-check">
                              <input class="form-check-input" type="checkbox" id="reabastecerCheckbox"
                                v-model="solicitud.destinoCreditos" value="Reabastecer el negocio" />
                              <label class="form-check-label" for="reabastecerCheckbox">
                                Reabastecer el negocio
                              </label>
                            </div>
                            <div class="form-check">
                              <input class="form-check-input" type="checkbox" id="otrasCheckbox"
                                v-model="solicitud.destinoCreditos" value="Otras" />
                              <label class="form-check-label" for="otrasCheckbox">
                                Otras
                              </label>
                            </div>
                            <div class="mt-3 mb-3">
                              <label for="actividadEconomica" class="form-label">Actividad Económica</label>
                              <select v-model="solicitud.actividadEconomica" id="actividadEconomica"
                                name="actividadEconomica" class="form-select" aria-label="Actividad Económica">
                                <option value="">Seleccione una actividad económica</option>
                                <option value="Comercio">Comercio</option>
                                <option value="Hotelería">Hotelería</option>
                                <option value="Restaurante">Restaurante</option>
                                <option value="Transporte">Transporte</option>
                                <option value="Agricultura">Agricultura</option>
                                <option value="Ganadería">Ganadería</option>
                                <option value="Pesca y Acuicultura">Pesca y Acuicultura</option>
                                <option value="Artesanías">Artesanías</option>
                                <option value="Construcción">Construcción</option>
                              </select>
                            </div>
                          </div>
                        </div>


                        


                      </div>
                    </div>
                  </div>

                  <!-- Aqui va Plan De Inversion -->
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="panelsStayOpen-headingfour">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#panelsStayOpen-collapseFour" aria-expanded="false"
                        aria-controls="panelsStayOpen-collapseFour">
                        <div class="col-6">
                          Plan de inversión
                        </div>
                        <div id="validar-4" class="d-flex justify-content-end me-3" style="width: 100%">

                        </div>
                      </button>
                    </h2>
                    <div id="panelsStayOpen-collapseFour" class="accordion-collapse collapse"
                      aria-labelledby="panelsStayOpen-headingfour">
                      <div class="accordion-body">
                        <div class="row">

                          <table id="tabla" class="table-striped plan-inversión">
                            <thead>
                              <tr>
                                <th>Requerimiento</th>
                                <th>Descripción</th>
                                <th>Valor</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>
                                  <input type="text" class="input-plan" id="req1" placeholder="Escribe el requerimiento"
                                    v-model="solicitud.planInversion.req1" />
                                </td>
                                <td>
                                  <input type="text" class="input-plan" id="desc1" placeholder="Escribe la descripción"
                                    v-model="solicitud.planInversion.desc1" />
                                </td>
                                <td>
                                  <input type="text" class="valor input-plan" id="val1" placeholder="0"
                                    v-model="solicitud.planInversion.val1" />
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <input type="text" class="input-plan" id="req2" placeholder="Escribe el requerimiento"
                                    v-model="solicitud.planInversion.req2" />
                                </td>
                                <td>
                                  <input type="text" class="input-plan" id="desc2" placeholder="Escribe la descripción"
                                    v-model="solicitud.planInversion.desc2" />
                                </td>
                                <td>
                                  <input type="text" class="valor input-plan" id="val2" placeholder="0"
                                    v-model="solicitud.planInversion.val2" />
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <input type="text" class="input-plan" id="req3" placeholder="Escribe el requerimiento"
                                    v-model="solicitud.planInversion.req3" />
                                </td>
                                <td>
                                  <input type="text" class="input-plan" id="desc3" placeholder="Escribe la descripción"
                                    v-model="solicitud.planInversion.desc3" />
                                </td>
                                <td>
                                  <input type="text" class="valor input-plan" id="val3" placeholder="0"
                                    v-model="solicitud.planInversion.val3" />
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <input type="text" class="input-plan" id="req4" placeholder="Escribe el requerimiento"
                                    v-model="solicitud.planInversion.req4" />
                                </td>
                                <td>
                                  <input type="text" class="input-plan" id="desc4" placeholder="Escribe la descripción"
                                    v-model="solicitud.planInversion.desc4" />
                                </td>
                                <td>
                                  <input type="text" class="valor input-plan" id="val4" placeholder="0"
                                    v-model="solicitud.planInversion.val4" />
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <input type="text" class="input-plan" id="req5" placeholder="Escribe el requerimiento"
                                    v-model="solicitud.planInversion.req5" />
                                </td>
                                <td>
                                  <input type="text" class="input-plan" id="desc5" placeholder="Escribe la descripción"
                                    v-model="solicitud.planInversion.desc5" />
                                </td>
                                <td>
                                  <input type="text" class="valor input-plan" id="val5" placeholder="0"
                                    v-model="solicitud.planInversion.val5" />
                                </td>

                              </tr>

                              <tr v-for="(fila, index) in solicitud.filas" :key="index">
                                <!-- Campos de cada fila -->
                                <td>
                                  <input type="text" placeholder="Escribe el requerimiento" class="input-plan"
                                    v-model="solicitud.filas[index].requerimiento" />
                                </td>
                                <td>
                                  <input type="text" placeholder="Escribe la descripción" class="input-plan"
                                    v-model="solicitud.filas[index].descripcion" />
                                </td>
                                <td>
                                  <input type="text" placeholder="0" class="input-plan"
                                    v-model="solicitud.filas[index].valor" />
                                </td>
                              </tr>
                              <tr>
                                <td>Total</td>
                                <td id="total" class="">0</td>
                                <td>{{ sumaTablaInverciones }} lps</td>
                              </tr>
                            </tbody>
                          </table>
                          <button @click="quitarFila" type="button" class="btn btn-primary" style="color: white;">Quitar
                            Fila -</button>
                          <button @click="agregarFila" type="button" class="btn btn-primary"
                            style="color: white;">Agregar
                            Fila +</button>
                          <!-- {{this.solicitud.filas}} -->

                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Aqui va Referencias -->
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="panelsStayOpen-headingTwo">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#panelsStayOpen-collapseTwo" aria-expanded="false"
                        aria-controls="panelsStayOpen-collapseTwo">
                        <div class="col-6">
                          Referencias
                        </div>
                        <div id="validar-5" class="d-flex justify-content-end me-3" style="width: 100%">

                        </div>
                      </button>
                    </h2>
                    <div id="panelsStayOpen-collapseTwo" class="accordion-collapse collapse"
                      aria-labelledby="panelsStayOpen-headingTwo">
                      <div class="accordion-body">
                        <div id="referencias" class="d-flex flex-column"></div>

                        <div class="carta p-2 mt-3 mb-2" id="ref-1">
                          <p class="mb-2">Referencias Familiares</p>
                          <div class="row">
                            <div class="col-3 pad">
                              <label for="nom1">Nombre</label>
                              <input :required="(this.modoThanos === true) ? false : true" class="form-control fm"
                                v-model="solicitud.referencias.nom1" type="text" id="nom1" placeholder="Nombre" />
                            </div>
                            <div class="col-3 pad">
                              <label for="par1">Parentesco</label>
                              <!-- <input required require="true" class="form-control fm" v-model="solicitud.referencias.par1"
                                type="text" id="par1" placeholder="Parentesco" /> -->
                              <select v-model="solicitud.referencias.par1" id="par1" class="form-select"
                                :required="(this.modoThanos === true) ? false : true"
                                aria-label="Default select example">
                                <option value="Padre">Padre</option>
                                <option value="Madre">Madre</option>
                                <option value="Hermano(a)">Hermano(a)</option>
                                <option value="Tío(a)">Tío(a)</option>
                                <option value="Abuelo(a)">Abuelo(a)</option>
                                <option value="Sobrino(a)">Sobrino(a)</option>
                                <option value="Hijo(a)">Hijo(a)</option>
                                <option value="Primo(a)">Primo(a)</option>
                                <option value="Suegro(a)">Suegro(a)</option>
                                <option value="Cuñado(a)">Cuñado(a)</option>
                                <option value="Nuera">Nuera</option>
                                <option value="Yerno">Yerno</option>
                                <option value="Esposo(a)">Esposo(a)</option>
                                <option value="Nieto(a)">Nieto(a)</option>
                                <option value="Amigo(a)">Amigo(a)</option>
                                <option value="Compañero de Trabajo">Compañero de Trabajo</option>
                                <option value="Conocido(a)">Conocido(a)</option>

                              </select>
                            </div>
                            <div class="col-3 pad">
                              <label for="dir1">Dirección</label>
                              <input :required="(this.modoThanos === true) ? false : true" require="true"
                                class="form-control fm" v-model="solicitud.referencias.dir1" type="text" id="dir1"
                                placeholder="Dirección" />
                            </div>
                            <div class="col-3 pad">
                              <label for="cel1">Celular</label>
                              <input :required="(this.modoThanos === true) ? false : true" require="true"
                                class="form-control fm" v-model="solicitud.referencias.cel1" type="number" id="cel1"
                                placeholder="Celular" />
                            </div>
                          </div>
                        </div>
                        <div class="carta p-2 mt-3 mb-2" id="ref-2">
                          <!-- <p class="mb-2">Referencia 2</p> -->
                          <div class="row">
                            <div class="col-3 pad">
                              <label for="nom2">Nombre</label>
                              <input :required="(this.modoThanos === true) ? false : true" require="true"
                                class="form-control fm" v-model="solicitud.referencias.nom2" type="text" id="nom2"
                                placeholder="Nombre" />
                            </div>
                            <div class="col-3 pad">
                              <label for="par2">Parentesco</label>
                              <!-- <input :required="(this.modoThanos===true)?false:true"  require="true" class="form-control fm" v-model="solicitud.referencias.par2"
                                type="text" id="par2" placeholder="Parentesco" /> -->
                              <select v-model="solicitud.referencias.par2" id="par2"
                                :required="(this.modoThanos === true) ? false : true" class="form-select"
                                aria-label="Default select example">
                                <option value="Padre">Padre</option>
                                <option value="Madre">Madre</option>
                                <option value="Hermano(a)">Hermano(a)</option>
                                <option value="Tío(a)">Tío(a)</option>
                                <option value="Abuelo(a)">Abuelo(a)</option>
                                <option value="Sobrino(a)">Sobrino(a)</option>
                                <option value="Hijo(a)">Hijo(a)</option>
                                <option value="Primo(a)">Primo(a)</option>
                                <option value="Suegro(a)">Suegro(a)</option>
                                <option value="Cuñado(a)">Cuñado(a)</option>
                                <option value="Nuera">Nuera</option>
                                <option value="Yerno">Yerno</option>
                                <option value="Esposo(a)">Esposo(a)</option>
                                <option value="Nieto(a)">Nieto(a)</option>
                                <option value="Amigo(a)">Amigo(a)</option>
                                <option value="Compañero de Trabajo">Compañero de Trabajo</option>
                                <option value="Conocido(a)">Conocido(a)</option>


                              </select>
                            </div>
                            <div class="col-3 pad">
                              <label for="dir2">Dirección</label>
                              <input :required="(this.modoThanos === true) ? false : true" require="true"
                                class="form-control fm" v-model="solicitud.referencias.dir2" type="text" id="dir2"
                                placeholder="Dirección" />
                            </div>
                            <div class="col-3 pad">
                              <label for="cel2">Celular</label>
                              <input :required="(this.modoThanos === true) ? false : true" require="true"
                                class="form-control fm" v-model="solicitud.referencias.cel2" type="number" id="cel2"
                                placeholder="Celular" />
                            </div>
                          </div>
                        </div>
                        <div class="carta p-2 mt-3 mb-2" id="ref-3">
                          <p class="mb-2">Referencias Personales</p>
                          <div class="row">
                            <div class="col-3 pad">
                              <label for="nom3">Nombre</label>
                              <input :required="(this.modoThanos === true) ? false : true" require="true"
                                class="form-control fm" v-model="solicitud.referencias.nom3" type="text" id="nom3"
                                placeholder="Nombre" />
                            </div>
                            <div class="col-3 pad">
                              <label for="par3">Parentesco</label>
                              <!-- <input :required="(this.modoThanos===true)?false:true"  require="true" class="form-control fm" v-model="solicitud.referencias.par3"
                                type="text" id="par3" placeholder="Parentesco" /> -->
                              <select v-model="solicitud.referencias.par3"
                                :required="(this.modoThanos === true) ? false : true" class="form-select" id="par3"
                                aria-label="Default select example">
                                <option value="Amigo(a)">Amigo(a)</option>
                                <option value="Compañero de Trabajo">Compañero de Trabajo</option>
                                <option value="Conocido(a)">Conocido(a)</option>

                              </select>
                            </div>
                            <div class="col-3 pad">
                              <label for="dir3">Dirección</label>
                              <input :required="(this.modoThanos === true) ? false : true" require="true"
                                class="form-control fm" v-model="solicitud.referencias.dir3" type="text" id="dir3"
                                placeholder="Dirección" />
                            </div>
                            <div class="col-3 pad">
                              <label for="cel3">Celular</label>
                              <input :required="(this.modoThanos === true) ? false : true" require="true"
                                class="form-control fm" v-model="solicitud.referencias.cel3" type="number" id="cel3"
                                placeholder="Celular" />
                            </div>
                          </div>
                        </div>
                        <div class="carta p-2 mt-3 mb-2" id="ref-4">
                          <!-- <p class="mb-2">Referencia 4</p> -->
                          <div class="row">
                            <div class="col-3 pad">
                              <label for="nom4">Nombre</label>
                              <input :required="(this.modoThanos === true) ? false : true" require="true"
                                class="form-control fm" v-model="solicitud.referencias.nom4" type="text" id="nom4"
                                placeholder="Nombre" />
                            </div>
                            <div class="col-3 pad">
                              <label for="par4">Parentesco</label>
                              <!-- <input :required="(this.modoThanos===true)?false:true"  require="true" class="form-control fm" v-model="solicitud.referencias.par4"
                                type="text" id="par4" placeholder="Parentesco" /> -->
                              <select v-model="solicitud.referencias.par4"
                                :required="(this.modoThanos === true) ? false : true" class="form-select" id="par4"
                                aria-label="Default select example">
                                <option value="Amigo(a)">Amigo(a)</option>
                                <option value="Compañero de Trabajo">Compañero de Trabajo</option>
                                <option value="Conocido(a)">Conocido(a)</option>
                              </select>
                            </div>
                            <div class="col-3 pad">
                              <label for="dir4">Dirección</label>
                              <input :required="(this.modoThanos === true) ? false : true" require="true"
                                class="form-control fm" v-model="solicitud.referencias.dir4" type="text" id="dir4"
                                placeholder="Dirección" />
                            </div>
                            <div class="col-3 pad">
                              <label for="cel4">Celular</label>
                              <input :required="(this.modoThanos === true) ? false : true" require="true"
                                class="form-control fm" v-model="solicitud.referencias.cel4" type="number" id="cel4"
                                placeholder="Celular" />
                            </div>
                          </div>
                        </div>

                        <div class="mt-4 pt-3 border-top">
                          <div class="d-flex justify-content-between align-items-center flex-wrap gap-2">
                            <div>
                              <h5 class="mb-1">Referencias adicionales</h5>
                              <p class="text-muted">Agrega referencias extra sin cambiar las referencias actuales.</p>
                            </div>
                            <button type="button" class="btn btn-primary" :disabled="referenciasExtraBloqueadas"
                              @click="agregarReferenciaExtra">
                              Agregar referencia +
                            </button>
                          </div>

                          <p v-if="!solicitud.referenciasExtra || solicitud.referenciasExtra.length === 0"
                            class="text-muted mt-3">
                            No hay referencias adicionales agregadas.
                          </p>

                          <div v-for="(referenciaExtra, index) in solicitud.referenciasExtra"
                            :key="referenciaExtra.id || index" class="carta referencia-extra p-2 mt-3 mb-2">
                            <div class="d-flex justify-content-between align-items-center mb-2">
                              <p class="mb-0">Referencia adicional {{ index + 1 }}</p>
                              <button v-if="Admin" type="button" class="btn btn-danger btn-sm"
                                :disabled="referenciasExtraBloqueadas" @click="quitarReferenciaExtra(index)">
                                Eliminar
                              </button>
                            </div>
                            <div class="row">
                              <div class="col-12 col-lg-2 pad">
                                <label :for="'tipoReferenciaExtra' + index">Tipo</label>
                                <select class="form-select" :id="'tipoReferenciaExtra' + index"
                                  v-model="referenciaExtra.tipoReferencia" :disabled="referenciasExtraBloqueadas"
                                  @change="referenciaExtra.parentescoORelacion = ''">
                                  <option value="">Seleccione</option>
                                  <option value="Familiar">Familiar</option>
                                  <option value="Personal">Personal</option>
                                </select>
                              </div>
                              <div class="col-12 col-lg-3 pad">
                                <label :for="'nombreReferenciaExtra' + index">Nombre completo</label>
                                <input class="form-control fm" :id="'nombreReferenciaExtra' + index"
                                  v-model="referenciaExtra.nombreCompleto" type="text" placeholder="Nombre completo"
                                  :disabled="referenciasExtraBloqueadas" />
                              </div>
                              <div class="col-12 col-lg-2 pad">
                                <label :for="'parentescoReferenciaExtra' + index">Parentesco o relacion</label>
                                <select class="form-select" :id="'parentescoReferenciaExtra' + index"
                                  v-model="referenciaExtra.parentescoORelacion"
                                  :disabled="referenciasExtraBloqueadas || !referenciaExtra.tipoReferencia">
                                  <option value="">Seleccione</option>
                                  <option v-for="opcion in opcionesParentescoReferenciaExtra(referenciaExtra.tipoReferencia)"
                                    :key="opcion" :value="opcion">
                                    {{ opcion }}
                                  </option>
                                </select>
                              </div>
                              <div class="col-12 col-lg-3 pad">
                                <label :for="'direccionReferenciaExtra' + index">Direccion</label>
                                <input class="form-control fm" :id="'direccionReferenciaExtra' + index"
                                  v-model="referenciaExtra.direccion" type="text" placeholder="Direccion"
                                  :disabled="referenciasExtraBloqueadas" />
                              </div>
                              <div class="col-12 col-lg-2 pad">
                                <label :for="'telefonoReferenciaExtra' + index">Telefono</label>
                                <input class="form-control fm" :id="'telefonoReferenciaExtra' + index"
                                  v-model="referenciaExtra.telefono" type="tel" placeholder="Telefono"
                                  :disabled="referenciasExtraBloqueadas" />
                              </div>
                            </div>
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                  <!-- Aqui va Grupo Solidario -->
                  <!-- <grupoSolidarioVue  v-if="validarGrupo"/> -->

                  <!-- Aqui va Evaluacion de Calidad -->
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="panelsStayOpen-headingsix">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#panelsStayOpen-collapseSix" aria-expanded="false"
                        aria-controls="panelsStayOpen-collapseSix">
                        <div class="col-6">
                          Evaluación de Calidad Y Condiciones de Vida
                        </div>
                        <div id="validar-6" class="d-flex justify-content-end me-3" style="width: 100%">

                        </div>
                      </button>
                    </h2>
                    <div id="panelsStayOpen-collapseSix" class="accordion-collapse collapse"
                      aria-labelledby="panelsStayOpen-headingsix">
                      <div class="accordion-body">
                        <div class="row">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">¿Tiempo de residir en la vivienda?</label>
                            <div class="col-sm-9 d-flex align-items-center">
                              <input :required="(this.modoThanos === true) ? false : true" id="tiempoVivienda"
                                require="true" v-model="solicitud.tiempoVivienda" type="text" class="form-control" />
                            </div>
                          </div>
                        </div>

                        <div class="row">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Material que predomina en vivienda</label>
                            <div class="col-sm-9 d-flex align-items-center">
                              <select :required="(this.modoThanos === true) ? false : true" id="materialVivienda"
                                require="true" v-model="solicitud.materialVivienda" class="form-select"
                                aria-label="Default select example">
                                <option value="Ladrillo">Ladrillo</option>
                                <option value="Adobe">Adobe</option>
                                <option value="Madera">Madera</option>
                                <option value="Bloque">Bloque</option>
                                <option value="Otros">Otros</option>
                              </select>
                            </div>
                          </div>
                        </div>

                        <div class="row">
                          Servicios públicos que tiene en la vivienda
                          <div class="form-group row">
                            <div class="col-sm-9 ms-4">
                              <div class="form-check">
                                <input class="form-check-input" type="checkbox" value="energia electrica"
                                  v-model="solicitud.serviciosPublico" id="energiaElectrica" require="true" />
                                <label class="form-check-label" for="energiaElectrica">
                                  Energía Eléctrica
                                </label>
                              </div>
                              <div class="form-check">
                                <input class="form-check-input" type="checkbox" value="red de agua potable"
                                  v-model="solicitud.serviciosPublico" id="aguaPotable" require="true" />
                                <label class="form-check-label" for="aguaPotable" require="true">
                                  Red de agua potable
                                </label>
                              </div>
                              <div class="form-check">
                                <input class="form-check-input" type="checkbox" value="red de aguas negras"
                                  v-model="solicitud.serviciosPublico" id="aguasNegras" require="true" />
                                <label class="form-check-label" for="aguasNegras" require="true">
                                  Red de aguas negras
                                </label>
                              </div>
                              <div class="form-check">
                                <input class="form-check-input" type="checkbox" value="pozo septico"
                                  v-model="solicitud.serviciosPublico" id="pozoSeptico" require="true" />
                                <label class="form-check-label" for="pozoSeptico" require="true">
                                  Pozo Séptico/Letrina/Otro
                                </label>
                              </div>
                              <div class="form-check">
                                <input class="form-check-input" type="checkbox" value="telefono fijo"
                                  v-model="solicitud.serviciosPublico" id="telefonoFijo" require="true" />
                                <label class="form-check-label" for="telefonoFijo">
                                  Teléfono Fijo
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="row">
                          <TextInputForm label="¿Cuántas personas habitan en la vivienda?" name="personas-vivienda"
                            id="personasVivienda" v-model="solicitud.noPersonasVivivenda" type="number" />
                          <TextInputForm require="true" label="¿Cuántas familias viven?" name="familias" id="familias"
                            v-model="solicitud.noFamilias" type="number" />
                        </div>

                        <div class="row">
                          <TextInputForm require="true" label="¿Cuántas trabajan?" name="trabajan" id="trabajan"
                            v-model="solicitud.noTrabajan" type="number" />
                        </div>

                        <div class="row">
                          <TextInputForm label="¿Cuántas son dependientes?" require="true" name="dependientes"
                            id="dependientes" v-model="solicitud.noDependientes" type="number" />
                          <TextInputForm label="¿Cuántas buscan empleo?" require="true" name="buscan-empleo"
                            id="buscanEmpleo" v-model="solicitud.noBuscanEmpleo" type="number" />
                        </div>
                      </div>
                    </div>

                  </div>

                  <!-- Aqui va Grupos Especiales -->
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="panelsStayOpen-headingseven">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#panelsStayOpen-collapseSeven" aria-expanded="false"
                        aria-controls="panelsStayOpen-collapseSeven">
                        <div class="col-6">
                          Sector y Grupos Especiales
                        </div>
                        <div id="validar-7" class="d-flex justify-content-end me-3" style="width: 100%"></div>
                      </button>
                    </h2>
                    <div id="panelsStayOpen-collapseSeven" class="accordion-collapse collapse"
                      aria-labelledby="panelsStayOpen-headingseven">

                      <div class="accordion-body">
                        <p class="mt-3">Sector</p>

                        <div class=" row">
                          <div class="col-sm-6 ms-4 col-6">
                            <div class="form-check ">
                              <input class="form-check-input" type="checkbox" value="Adulto Mayor"
                                v-model="solicitud.sector" id="flexCheckDefault" />
                              <label class="form-check-label" for="flexCheckDefault">
                                Adulto Mayor
                              </label>
                            </div>
                            <div class="form-check">
                              <input class="form-check-input" type="checkbox" value="Afrohondureños"
                                v-model="solicitud.sector" id="flexCheckChecked" />
                              <label class="form-check-label" for="flexCheckChecked">
                                Afrohondureños
                              </label>
                            </div>
                            <div class="form-check">
                              <input class="form-check-input" type="checkbox" value="Discapacitados"
                                v-model="solicitud.sector" id="flexCheckChecked" />
                              <label class="form-check-label" for="flexCheckChecked">
                                Discapacitados
                              </label>
                            </div>
                            <div class="form-check">
                              <input class="form-check-input" type="checkbox" value="Extema Pobreza"
                                v-model="solicitud.sector" id="flexCheckChecked" />
                              <label class="form-check-label" for="flexCheckChecked">
                                Extema Pobreza
                              </label>
                            </div>
                            <div class="form-check">
                              <input class="form-check-input" type="checkbox" value="Jóvenes" v-model="solicitud.sector"
                                id="flexCheckChecked" />
                              <label class="form-check-label" for="flexCheckChecked">
                                Jóvenes
                              </label>
                            </div>
                            <div class="form-check">
                              <input class="form-check-input" type="checkbox" value="Migrante Retornado"
                                v-model="solicitud.sector" id="flexCheckChecked" />
                              <label class="form-check-label" for="flexCheckChecked">
                                Migrante Retornado
                              </label>
                            </div>
                            <div class="form-check">
                              <input class="form-check-input" type="checkbox" value="Mujer Campesina"
                                v-model="solicitud.sector" id="flexCheckChecked" />
                              <label class="form-check-label" for="flexCheckChecked">
                                Mujer Campesina
                              </label>
                            </div>
                            <div class="form-check">
                              <input class="form-check-input" type="checkbox"
                                value="Mujeres en Situación de Vulnerabilidad" v-model="solicitud.sector"
                                id="flexCheckChecked" />
                              <label class="form-check-label" for="flexCheckChecked">
                                Mujeres en Situación de Vulnerabilidad
                              </label>
                            </div>
                            <div class="form-check">
                              <input class="form-check-input" type="checkbox" value="Pobreza" v-model="solicitud.sector"
                                id="flexCheckChecked" />
                              <label class="form-check-label" for="flexCheckChecked">
                                Pobreza
                              </label>
                            </div>
                          </div>
                        </div>
                        <!-- Grupos Especiales -->
                        <p class="mt-3">Grupos Especiales</p>

                        <div class=" row ms-2">
                          <div class="col-sm-6 col-6 ">
                            <div class="form-check">
                              <input class="form-check-input" type="checkbox" value="Pueblos Indígenas"
                                v-model="solicitud.gruposEspeciales" id="flexCheckDefault" />
                              <label class="form-check-label" for="flexCheckDefault">
                                Pueblos Indígenas
                              </label>
                            </div>
                            <div class="form-check">
                              <input class="form-check-input" type="checkbox" value="DINIS"
                                v-model="solicitud.gruposEspeciales" id="flexCheckChecked" />
                              <label class="form-check-label" for="flexCheckChecked">
                                DINIS
                              </label>
                            </div>
                            <div class="form-check">
                              <input class="form-check-input" type="checkbox" value="Crédito del SSE"
                                v-model="solicitud.gruposEspeciales" id="flexCheckChecked" />
                              <label class="form-check-label" for="flexCheckChecked">
                                Crédito del SSE
                              </label>
                            </div>
                            <div class="form-check">
                              <input class="form-check-input" type="checkbox" value="Tu Banca Joven"
                                v-model="solicitud.gruposEspeciales" id="flexCheckChecked" />
                              <label class="form-check-label" for="flexCheckChecked">
                                Tu Banca Joven
                              </label>
                            </div>
                            <div class="form-check">
                              <input class="form-check-input" type="checkbox" value="Fundeimh"
                                v-model="solicitud.gruposEspeciales" id="flexCheckChecked" />
                              <label class="form-check-label" for="flexCheckChecked">
                                Fundeimh
                              </label>
                            </div>
                            <div class="form-check">
                              <input class="form-check-input" type="checkbox" value="Bici Solidaria"
                                v-model="solicitud.gruposEspeciales" id="flexCheckChecked" />
                              <label class="form-check-label" for="flexCheckChecked">
                                Bici Solidaria
                              </label>
                            </div>
                            <div class="form-check">
                              <input class="form-check-input" type="checkbox" value="Anmpih"
                                v-model="solicitud.gruposEspeciales" id="flexCheckChecked" />
                              <label class="form-check-label" for="flexCheckChecked">
                                Anmpih
                              </label>
                            </div>
                            <div class="form-check">
                              <input class="form-check-input" type="checkbox" value="Credi-Taxi"
                                v-model="solicitud.gruposEspeciales" id="flexCheckChecked" />
                              <label class="form-check-label" for="flexCheckChecked">
                                Credi-Taxi
                              </label>
                            </div>
                            <div class="form-check">
                              <input class="form-check-input" type="checkbox" value="Credi-Salón"
                                v-model="solicitud.gruposEspeciales" id="flexCheckChecked" />
                              <label class="form-check-label" for="flexCheckChecked">
                                Credi-Salón
                              </label>
                            </div>
                            <div class="form-check">
                              <input class="form-check-input" type="checkbox" value="Credi-Babería"
                                v-model="solicitud.gruposEspeciales" id="flexCheckChecked" />
                              <label class="form-check-label" for="flexCheckChecked">
                                Credi-Babería
                              </label>
                            </div>
                            <div class="form-check">
                              <input class="form-check-input" type="checkbox" value="Credi-Pulpería"
                                v-model="solicitud.gruposEspeciales" id="flexCheckChecked" />
                              <label class="form-check-label" for="flexCheckChecked">
                                Credi-Pulpería
                              </label>
                            </div>
                          </div>
                          <div class="col-sm-6 col-6">
                            <div class="form-check">
                              <input class="form-check-input" type="checkbox" value="DINAFROH"
                                v-model="solicitud.gruposEspeciales" id="flexCheckDefault" />
                              <label class="form-check-label" for="flexCheckDefault">
                                DINAFROH
                              </label>
                            </div>
                            <div class="form-check">
                              <input class="form-check-input" type="checkbox" value="Credi-Feria"
                                v-model="solicitud.gruposEspeciales" id="flexCheckChecked" />
                              <label class="form-check-label" for="flexCheckChecked">
                                Credi-Feria
                              </label>
                            </div>
                            <div class="form-check">
                              <input class="form-check-input" type="checkbox" value="Progresa"
                                v-model="solicitud.gruposEspeciales" id="flexCheckChecked" />
                              <label class="form-check-label" for="flexCheckChecked">
                                Progresa
                              </label>
                            </div>
                            <div class="form-check">
                              <input class="form-check-input" type="checkbox" value="Reservistas"
                                v-model="solicitud.gruposEspeciales" id="flexCheckChecked" />
                              <label class="form-check-label" for="flexCheckChecked">
                                Reservistas
                              </label>
                            </div>
                            <div class="form-check">
                              <input class="form-check-input" type="checkbox" value="Caja Rural"
                                v-model="solicitud.gruposEspeciales" id="flexCheckChecked" />
                              <label class="form-check-label" for="flexCheckChecked">
                                Caja Rural
                              </label>
                            </div>
                            <div class="form-check">
                              <input class="form-check-input" type="checkbox" value="Projoven"
                                v-model="solicitud.gruposEspeciales" id="flexCheckChecked" />
                              <label class="form-check-label" for="flexCheckChecked">
                                Projoven
                              </label>
                            </div>
                            <div class="form-check">
                              <input class="form-check-input" type="checkbox" value="CICESCT"
                                v-model="solicitud.gruposEspeciales" id="flexCheckChecked" />
                              <label class="form-check-label" for="flexCheckChecked">
                                CICESCT
                              </label>
                            </div>
                            <div class="form-check">
                              <input class="form-check-input" type="checkbox" value="Ayuda Solidaria"
                                v-model="solicitud.gruposEspeciales" id="flexCheckChecked" />
                              <label class="form-check-label" for="flexCheckChecked">
                                Ayuda Solidaria
                              </label>
                            </div>
                            <div class="form-check">
                              <input class="form-check-input" type="checkbox" value="Asonapvsidah"
                                v-model="solicitud.gruposEspeciales" id="flexCheckChecked" />
                              <label class="form-check-label" for="flexCheckChecked">
                                Asonapvsidah
                              </label>
                            </div>
                            <div class="form-check">
                              <input class="form-check-input" type="checkbox" value="Ciudad Mujer"
                                v-model="solicitud.gruposEspeciales" id="flexCheckChecked" />
                              <label class="form-check-label" for="flexCheckChecked">
                                Ciudad Mujer
                              </label>
                            </div>
                            <div class="form-check">
                              <input class="form-check-input" type="checkbox" value="Senaeh"
                                v-model="solicitud.gruposEspeciales" id="flexCheckChecked" />
                              <label class="form-check-label" for="flexCheckChecked">
                                Senaeh
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Grupo Solidarios -->
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="panelsStayOpen-headingOnea2">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#panelsStayOpen-collapseLast2" aria-expanded="false"
                        aria-controls="panelsStayOpen-collapseLast2">
                        <div class="col-6">Grupo Solidario</div>
                        <div id="validar-8" class="d-flex justify-content-end me-3" style="width: 100%"></div>
                      </button>
                    </h2>
                    <div id="panelsStayOpen-collapseLast2" class="accordion-collapse collapse"
                      aria-labelledby="panelsStayOpen-headingOne2">
                      <div class="accordion-body">

                        <div class="row">
                          <div class="form-group row">
                            <label class="col-sm-2 col-form-label">Nombre Grupo Solidario</label>
                            <div class="col-sm-9 d-flex align-items-center">
                              <input id="tiempoVivienda" v-model="solicitud.nombreGrupoSolidario" type="text"
                                class="form-control" />
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <label class="col-sm-3 col-form-label">Integrantes por DNI</label>
                          <p>Ingresa el DNI de los integrantes sin guiones</p>
                          <div class="form-group row">

                            <!-- Integrante 1 -->
                            <div class="col-sm-4 d-flex align-items-center">
                              <p class="me-3">Dni: </p>
                              <input id="int1gs" placeholder="integrante 1"
                                v-model="solicitud.integrantesGruposSolidario.int1" type="text" class="form-control" />
                            </div>
                            <div class="col-sm-5 d-flex align-items-center">
                              <i class="me-4">{{ this.nomInt1 }}</i>
                              <i v-if="(this.solicitud.integrantesGruposSolidario.int1 === this.solicitud.coordinadorGrupoSolidario) && (this.nomInt1)"
                                class="fa-solid fa-star"></i>
                            </div>
                            <div v-if="(this.nomInt1)" class="col-sm-3 d-flex align-items-center">
                              <button class="btn btn-primary" type="button"
                                @click="seleccionarCoordinador(solicitud.integrantesGruposSolidario.int1, 1)">Seleccionar
                                Coordinador</button>
                            </div>
                            <div class="col-sm-4 d-flex align-items-center">
                              <p class="me-3">Monto:</p>

                              <input placeholder="Monto integrante 1"
                                v-model="solicitud.integrantesGruposSolidario.monto1" type="text"
                                class="form-control" />
                            </div>
                            <div class="col-sm-4 d-flex align-items-center">
                              <p class="me-3">Cuota: </p>
                              <input placeholder="Cuota integrante 1"
                                v-model="solicitud.integrantesGruposSolidario.cuota1" type="text"
                                class="form-control" />
                            </div>

                          </div>

                          <!-- Integrante 2 -->
                          <div class="form-group row">

                            <div class="col-sm-4 d-flex align-items-center">
                              <p class="me-3">Dni: </p>
                              <input id="int2gs" placeholder="integrante 2"
                                v-model="solicitud.integrantesGruposSolidario.int2" type="text" class="form-control" />
                            </div>
                            <div class="col-sm-5 d-flex align-items-center">
                              <i class="me-4">{{ this.nomInt2 }}</i>
                              <i v-if="(this.solicitud.integrantesGruposSolidario.int2 === this.solicitud.coordinadorGrupoSolidario) && (this.nomInt2)"
                                class="fa-solid fa-star"></i>
                            </div>
                            <div v-if="(this.nomInt2)" class="col-sm-3 d-flex align-items-center">
                              <button class="btn btn-primary" type="button"
                                @click="seleccionarCoordinador(solicitud.integrantesGruposSolidario.int2, 2)">Seleccionar
                                Coordinador</button>
                            </div>
                            <div class="col-sm-4 d-flex align-items-center">
                              <p class="me-3">Monto:</p>
                              <input placeholder="Monto integrante 2"
                                v-model="solicitud.integrantesGruposSolidario.monto2" type="text"
                                class="form-control" />
                            </div>

                            <div class="col-sm-4 d-flex align-items-center">
                              <p class="me-3">Cuota: </p>
                              <input placeholder="Cuota integrante 2"
                                v-model="solicitud.integrantesGruposSolidario.cuota2" type="text"
                                class="form-control" />
                            </div>

                          </div>

                          <!-- Integrante 3 -->
                          <div class="form-group row">

                            <div class="col-sm-4 d-flex align-items-center">
                              <p class="me-3">Dni: </p>
                              <input id="int3gs" placeholder="integrante 3"
                                v-model="solicitud.integrantesGruposSolidario.int3" type="text" class="form-control" />
                            </div>
                            <div class="col-sm-5 d-flex align-items-center">
                              <i class="me-4">{{ this.nomInt3 }}</i>
                              <i v-if="(this.solicitud.integrantesGruposSolidario.int3 === this.solicitud.coordinadorGrupoSolidario) && (this.nomInt3)"
                                class="fa-solid fa-star"></i>
                            </div>
                            <div v-if="(this.nomInt3)" class="col-sm-3 d-flex align-items-center">
                              <button class="btn btn-primary" type="button"
                                @click="seleccionarCoordinador(solicitud.integrantesGruposSolidario.int3, 1)">Seleccionar
                                Coordinador</button>

                            </div>
                            <div class="col-sm-4 d-flex align-items-center">
                              <p class="me-3">Monto:</p>

                              <input placeholder="Monto integrante 3"
                                v-model="solicitud.integrantesGruposSolidario.monto3" type="text"
                                class="form-control" />
                            </div>
                            <div class="col-sm-4 d-flex align-items-center">
                              <p class="me-3">Cuota: </p>
                              <input placeholder="Cuota integrante 3"
                                v-model="solicitud.integrantesGruposSolidario.cuota3" type="text"
                                class="form-control" />
                            </div>
                          </div>
                          <!-- Integrante 4 -->
                          <div class="form-group row">

                            <div class="col-sm-4 d-flex align-items-center">
                              <p class="me-3">Dni: </p>
                              <input id="int4gs" placeholder="integrante 4"
                                v-model="solicitud.integrantesGruposSolidario.int4" type="text" class="form-control" />
                            </div>
                            <div class="col-sm-5 d-flex align-items-center">
                              <i class="me-4">{{ this.nomInt4 }}</i>
                              <i v-if="(this.solicitud.integrantesGruposSolidario.int4 === this.solicitud.coordinadorGrupoSolidario) && (this.nomInt4)"
                                class="fa-solid fa-star"></i>
                            </div>
                            <div v-if="(this.nomInt4)" class="col-sm-3 d-flex align-items-center">
                              <button class="btn btn-primary" type="button"
                                @click="seleccionarCoordinador(solicitud.integrantesGruposSolidario.int4, 1)">Seleccionar
                                Coordinador</button>
                            </div>

                            <div class="col-sm-4 d-flex align-items-center">
                              <p class="me-3">Monto:</p>

                              <input placeholder="Monto integrante 4"
                                v-model="solicitud.integrantesGruposSolidario.monto4" type="text"
                                class="form-control" />
                            </div>
                            <div class="col-sm-4 d-flex align-items-center">
                              <p class="me-3">Cuota: </p>
                              <input placeholder="Cuota integrante 4"
                                v-model="solicitud.integrantesGruposSolidario.cuota4" type="text"
                                class="form-control" />
                            </div>

                          </div>
                          <!-- Integrante 5 -->
                          <div class="form-group row">

                            <div class="col-sm-4 d-flex align-items-center">
                              <p class="me-3">Dni: </p>
                              <input id="int5gs" placeholder="integrante 5"
                                v-model="solicitud.integrantesGruposSolidario.int5" type="text" class="form-control" />
                            </div>
                            <div class="col-sm-5 d-flex align-items-center">
                              <i class="me-4">{{ this.nomInt5 }}</i>
                              <i v-if="(this.solicitud.integrantesGruposSolidario.int5 === this.solicitud.coordinadorGrupoSolidario) && (this.nomInt5)"
                                class="fa-solid fa-star"></i>
                            </div>
                            <div v-if="(this.nomInt5)" class="col-sm-3 d-flex align-items-center">
                              <button class="btn btn-primary" type="button"
                                @click="seleccionarCoordinador(solicitud.integrantesGruposSolidario.int5, 1)">Seleccionar
                                Coordinador</button>
                            </div>
                            <div class="col-sm-4 d-flex align-items-center">
                              <p class="me-3">Monto:</p>

                              <input placeholder="Monto integrante 5"
                                v-model="solicitud.integrantesGruposSolidario.monto5" type="text"
                                class="form-control" />
                            </div>
                            <div class="col-sm-4 d-flex align-items-center">
                              <p class="me-3">Cuota: </p>
                              <input placeholder="Cuota integrante 5"
                                v-model="solicitud.integrantesGruposSolidario.cuota5" type="text"
                                class="form-control" />
                            </div>

                          </div>
                        </div>


                      </div>
                    </div>
                  </div>


                  <!-- Garantías -->
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="panelsStayOpen-headingOne">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#panelsStayOpen-collapseLast" aria-expanded="true"
                        aria-controls="panelsStayOpen-collapseLast">
                        <div class="col-6">Garantía</div>
                        <div id="validar-8" class="d-flex justify-content-end me-3" style="width: 100%"></div>
                      </button>
                    </h2>
                    <div id="panelsStayOpen-collapseLast" class="accordion-collapse collapse"
                      aria-labelledby="panelsStayOpen-headingOne">
                      <div class="accordion-body">
                        {{ this.solicitudCompleta.producto }}
                        <div class=" mt-4">
                          <label for="garantia" class="mb-3">Selecciona una garantía:</label>
                          <select :required="(this.modoThanos === true) ? false : true" v-model="solicitud.garantia"
                            :value="solicitud.garantia" class="form-control mb-3" id="garantia" name="garantia">
                            <option value="Garantía Fiduciaria">Garantía Fiduciaria</option>
                            <option value="Aval Comerciante">Aval Comerciante </option>
                            <option value="Garantía Mobiliaria">Garantía Mobiliaria</option>
                            <option value="Garantía Prendaria">Garantía Prendaria </option>
                            <option value="Garantía Hipotecaria">Garantía Hipotecaria </option>
                            <option value="Grupo Solidario">Grupo Solidario </option>
                          </select>
                        </div>
                        {{ solicitud.garantia }}
                        <div id="info_garantia"></div>
                      </div>
                    </div>
                  </div>
                  <!-- Gestión de Archivos -->
                  <div v-if="this.$route.params.solicitudId > 0" class="accordion-item" >
                    <h2 class="accordion-header" id="panelsStayOpen-headingOne9">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#panelsStayOpen-collapseLast9" aria-expanded="true"
                        aria-controls="panelsStayOpen-collapseLast9">
                        <div class="col-6">Gestión de archivos y Validación de documentos</div>
                        <div id="validar-8" class="d-flex justify-content-end me-3" style="width: 100%"></div>
                      </button>
                    </h2>
                    <div id="panelsStayOpen-collapseLast9" class="accordion-collapse collapse"
                      aria-labelledby="panelsStayOpen-headingOne9">
                      <div  class="accordion-body">

                        <!-- Aqui abre la gestion de archivos -->
                      <a :href="'/archivos/' + this.$route.params.solicitudId" class="folder" target="_blank">
                        <i class="fa-solid fa-folder-open"></i>
                      </a>
                      <div class="d-flex justify-content-between align-items-center mt-2">
                        <h4 class="pt-2">Validación de Archivos</h4> 
                        <button class="btn btn-primary d-flex align-items-center " @click="reloadInfoArchivos(this.$route.params.solicitudId)" type="button" >
                          Recargar <i class=" ms-2 fa-solid fa-rotate-right"></i>
                        </button>
                      </div>
                      <div v-if="this.readyArchivos" class="mt-2">
                      <!-- {{this.contadorArchivos}} -->

                        <div class="d-flex">
                          Fotografía del DNI 
                          <div v-if="this.contadorArchivos.dni > 0">
                            <i class="fa-solid fa-circle-check ms-2" style="color:green;"></i>
                          </div>
                          <div v-else>
                            <i class="fa-solid fa-circle-xmark ms-2" style="color:red;"></i>
                          </div>
                        </div>
                        <div class="d-flex">
                          Fachada del Negocio
                          <div v-if="this.contadorArchivos.fachada > 0">
                            <i class="fa-solid fa-circle-check ms-2" style="color:green;" ></i>
                          </div>
                          <div v-else>
                            <i class="fa-solid fa-circle-xmark ms-2" style="color:red;"></i>
                          </div>
                        </div>
                        <div class="d-flex">
                          Fachada de la Casa
                          <div v-if="this.contadorArchivos.fachadacasa > 0">
                            <i class="fa-solid fa-circle-check ms-2" style="color:green;"></i>
                          </div>
                          <div v-else>
                            <i class="fa-solid fa-circle-xmark ms-2" style="color:red;"></i>
                          </div>
                        </div>
                        <!-- <div class="d-flex">
                          Validacion de asesor(FIRMA)
                          <div v-if="this.autorizadofirma">
                            <i class="fa-solid fa-circle-check ms-2" style="color:green;"></i>
                          </div>
                          <div v-else>
                            <i class="fa-solid fa-circle-xmark ms-2" style="color:red;"></i>
                          </div>
                        </div> -->
                        
                        
                        
                      </div>

                      <div class="nota">
                        <p class="mt-3">Nota: Mientras no se encuentren los archivos obligatorio no se puede continuar con la aprobación del crédito</p>
                      </div>

                      <!-- <div class="contenedor mt-3 ">

                        <div class="row">
                          <h4 class="display-4">Autorización por Firma</h4>
                          <p>Por favor, capture su firma digital para continuar con el proceso de aprobación del crédito.</p>
                          <p>Una vez capturada, la firma se guardará y se mostrará a continuación.</p>
                        </div>

                        <button @click="exportarSolicitudPDF('FIRMA')" type="button" class="btn btn-secondary mt-3">
                        Iniciar proceso de firmado <i class="fa-solid fa-download"></i>
                      </button> -->
                        <!-- <div class="row mt-2">

                        <div v-if="!this.autorizadofirma" class="col-12 col-md-6">
                        <ComponenteFirma
                          @firmaGuardada="guardarFirma"
                          @firmaVacia="mostrarAlerta"
                          :idSolicitud="this.$route.params.solicitudId"
                        />
                        </div>

                        <div class="col-12 col-md-6" v-if="firmaBase64">
                          <h3 class="display-4">Firma capturada:</h3>
                          <img :src="firmaBase64" alt="Firma digital" />
                        </div>
                        </div> -->
                      <!-- </div> -->


                      </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="panelsStayOpen-headingSummaryTable">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#panelsStayOpen-collapseSummaryTable" aria-expanded="false"
                        aria-controls="panelsStayOpen-collapseSummaryTable">
                        <div class="col-6">
                          Resumen del Crédito
                        </div>
                        <div id="validar-2" class="d-flex justify-content-end me-3" style="width: 100%">

                        </div>
                      </button>
                    </h2>
                    <div id="panelsStayOpen-collapseSummaryTable" class="accordion-collapse collapse"
                      aria-labelledby="panelsStayOpen-headingSummaryTable">
                      <div class="accordion-body">
                        <div class="container" id="content">
                          <hr>
                          <table class="datos-table">

                            <tr>
                              <td> <b>Nombre:</b> </td>
                              <td>{{ this.cliente?.nombres }} {{ this.cliente?.apellidos }}</td>
                              <td><b>ID Beneficiario:</b> </td>
                              <td>{{ this.cliente?.dni }}</td>
                            </tr>
                            <tr>
                              <td><b>Producto:</b> </td>
                              <td>{{ this.solicitud?.producto }}</td>
                              <td><b>Número de préstamo:</b> </td>
                              <td>AHDE-{{ this.solicitud?.id }}</td>
                            </tr>
                            <tr>
                              <td> <b> IFI: </b> </td>
                              <td>{{ this.cliente?.nombreBanco }}</td>
                              <td><b>Cuenta depósito:</b> </td>
                              <td>{{ this.cliente?.noCuentaBanco }}</td>
                            </tr>
                          </table>
                          <hr />
                          <table class="datos-prestamo-table custom-table">
                            <tr>
                              <td><b>Fecha Apertura:</b></td>
                              <!-- <td colspan="1">{{ new Date(this.solicitud?.fechaPago).toLocaleDateString('en-GB') }}</td> -->
                              <td colspan="1">{{ new Date(this.solicitud?.fechaPago).toLocaleDateString('en-GB', {
                                timeZone: 'UTC'
                              }) }}</td>

                              <td><b>Monto Aprobado:</b></td>
                              <td>{{ formatoNumero(this.solicitud.monto) }} {{ this.moneda }}</td>

                              <td></td>
                            </tr>
                            <tr>
                              <td><b>Tasa Interes:</b></td>
                              <td>{{ this.solicitud?.interes }}%</td>
                              <td><b>Plazo (meses):</b></td>
                              <td>{{ this.solicitud?.plazoPago }}</td>
                              <td></td>
                            </tr>
                            <tr>
                              <td><b>Forma de pago:</b></td>
                              <td>{{ this.solicitud?.frecuenciaPago }}</td>
                              <td><b>Moneda:</b></td>
                              <td>Lempiras</td>
                              <td></td>
                            </tr>
                            <tr v-if="this.solicitud.producto === 'Credi Trabajo'">
                              <td><b> Total Interes: </b></td>
                              <td>{{ (this.solicitud?.monto * ((this.solicitud?.interes / 12) /
                                100) * this.solicitud.plazoPago).toLocaleString('en-US', minimumFractionDigits = 2,
                                  maximumFractionDigits = 2) }}</td>
                              <td></td>
                              <td></td>
                              <td></td>
                            </tr>

                            <tr>
                              <td colspan="1"><b>Tipo de cálculo:</b></td>
                              <td>Cuota Nivelada</td>
                              <td><b>Periodo Base:</b></td>
                              <td>360</td>
                              <td></td>
                            </tr>


                          </table>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>


                </div>
              </form-tag>
              <!-- MODAL PARA CAMBIAR ESTADO DE LA SOLICITUD -->
              <div class="modal fade" id="estadoSolicitud" tabindex="-1" aria-labelledby="exampleModalLabel"
                aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered">
                  <div class="modal-content">
                    <div class="modal-header">
                      <h5 class="modal-title" id="exampleModalLabel">Estado de la Solicitud</h5>
                      <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    
                    <EstadoSolicitud ref="estadoComp" :idSolicitud="idSolicitud" :autorizadoFirma="this.autorizadofirma" />

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- content-wrapper ends -->
    <!-- partial:../../partials/_footer.html -->
    <footer class="footer">
      <div class="d-sm-flex justify-content-center justify-content-sm-between">
        <span class="text-muted text-center text-sm-left d-block d-sm-inline-block">Copyright ©
          AHDECO 2023</span>

      </div>
    </footer>
    <!-- partial -->
  </div>
</template>

<script>
import Security from "../security";
import FormTag from "@/components/forms/Form-Tag-Pagos.vue";
import { solicitudCompleta } from "../solicitud";
import router from "../../router/index.js";
import Swal from "sweetalert2";
import TextInputForm from '../forms/Text-Input-Forms.vue';
import EstadoSolicitud from "../forms/EstadoSolicitud.vue";
// import direccionData from './direccionData.json';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { exportacionContratos } from './ExportacionContratos'
import { exportacionPagares } from './ExportacionPagare'
import { exportacionFianza } from './ExportacionFianza'
import PlanPago from "../PlanPago.vue";
import { store } from '../store';
// import CreditScoreGauge from "../score/CreditScoreGauge.vue";
import ScoreDetails from "../score/ScoreDetails.vue";
// import PlanPagos from '../plan-pagos.vue';
//import ComponenteFirma from '../SignaturePad.vue'

// ScoreDetails
export default {
  name: "NuevaSolicitud",
  components: {
    "form-tag": FormTag,
    // "plan-pagos": PlanPagos,
    TextInputForm,
    EstadoSolicitud,
    PlanPago,
    ScoreDetails,
    // CreditScoreGauge,
    //ComponenteFirma,
  },
  data() {
    return {
      dniAnterior: "",

      viewScore: true,
      clase: "",
      puntaje: 70,
      FotoCliente: "",
      score: 0,
      claseScore: "",
      // Firma

      firmaBase64: null,
      autorizadofirma: false,

      store,
      // Firma

      reportes:"Reportes",

      // Arreglo de Pago Intereses
      arregloPagoIntereses: false,
 
      montoAPInteres: 0.0,
      noPagosAPInteres: 0,
      pagosInteres: [],

      exportacionContratos,
      exportacionPagares,
      exportacionFianza,
      // departamentos: [],
      departamentoSeleccionado: null,
      planPagoToPrint: [],
      comisionDesembolso: 0.0,
      montoComisionDesembolso: 0.0,
      totalComisionDesembolso: 0.0,
      totalReservasSeguros: 0.0,
      comisionAsistenciaTecnica: 0.0,
      totalComisionAsistenciaTecnica: 0.0,
      tasaSeguridad: 0.00,
      reservasSeguros: 0.0,
      consultasBuro: 0.0,
      totalTasaSeguridad: 0.0,
      totalConsultasBuro: 0.0,
      cobroPorACH: 40.0,
      montoNeto: 0,
      montoInteres: 0.0,
      idSolicitud: 0,
      validarAcordion: "",
      solicitudCompleta,
      fechaNacimiento: "",
      edadsoli: "",
      estadoCivil: "",
      final: false,
      noReferencias: 1,
      dni: "",
     contadorArchivos: {},
             readyArchivos: false,

      cliente: {},
      gruposSolidariosArray: [],
      fechaVencimiento: '',
      solicitud: {
        ID: 0,
        clienteId: 0,
        producto: "",
        destinoCreditos: [],
        actividadEconomica: "",
        tiempoVivienda: "",
        materialVivienda: "",
        noPersonasVivivenda: "",
        noFamilias: "",
        noTrabajan: "",
        serviciosPublico: [],
        frecuenciaPagoGracia: "",
        noDependientes: "",

        noBuscanEmpleo: "",
        planInversion: {
          req1: "",
          req2: "",
          req3: "",
          req4: "",
          req5: "",
          desc1: "",
          desc2: "",
          desc3: "",
          desc4: "",
          desc5: "",
          val1: 0,
          val2: 0,
          val3: 0,
          val4: 0,
          val5: 0,
        },
        filas: [],
        indexFilas: 0,
        referencias: {
          nom1: "",
          nom2: "",
          nom3: "",
          nom4: "",
          par1: "",
          par2: "",
          par3: "",
          par4: "",
          dir1: "",
          dir2: "",
          dir3: "",
          dir4: "",
          cel1: 0,
          cel2: 0,
          cel3: 0,
          cel4: 0,
        },
        referenciasExtra: [],
        sector: [],
        gruposEspeciales: [],
        idGrupoSolidario: 0,

        pagosInteres: [],
        validarPagosInteres: false,

        fechaPago: (new Date()).toISOString().slice(0, 10),
        monto: '0',
        montoDesembolsar: '0.0',
        frecuenciaPago: "",
        interes: 12,
        tipoPlazo: "mensual",
        plazoPago: '',
        fechaFija: false,
        garantia: '',
        estado: '',
        sucursal: "",
   

        nombreGrupoSolidario: '',
        integrantesGruposSolidario: {
          int1: "",
          monto1: "",
          cuota1: "",
          nombre1: "",
          rtn1: "",
          infoBeneficiario1: {},

          int2: "",
          monto2: "",
          cuota2: "",
          nombre2: "",
          rtn2: "",
          infoBeneficiario2: {},

          int3: "",
          monto3: "",
          cuota3: "",
          nombre3: "",
          rtn3: "",
          infoBeneficiario3: {},

          int4: "",
          monto4: "",
          cuota4: "",
          nombre4: "",
          rtn4: "",
          infoBeneficiario4: {},

          int5: "",
          monto5: "",
          cuota5: "",
          nombre5: "",
          rtn5: "",
          infoBeneficiario5: {},

        },
        coordinadorGrupoSolidario: '',
      },
      montoDesembolsar: "",
      moneda: 'lps',
      // comisionDesembolso: 0,
      // comisionAsistenciaTecnica: 0,
      // tasaSeguridad: 0,
      userRoles: [],
      Asesor: false,
      cuotaSolicitud: 0,

      // Grupo Solidario Nombres

      nomInt1: "",
      nomInt2: "",
      nomInt3: "",
      nomInt4: "",
      nomInt5: "",


      SumaCuotaTotal: 0,
      SumaInteres: 0,
      SumaCapital: 0,
      SumaSaldo: 0,

      sinMora: false,

      // Roles
      roles: ['Coordinacion', 'Admin', 'Finanzas', 'Asesor', 'Cordinador Sucursal', 'Consultor'],
      Finanzas: false,
      Admin: false,
      Coordinacion: false,
      coordinadorSucursal: false,
      modoThanos: false,
      Consultor: false,
    };
  },
  beforeMount() {

    
    
    this.idSolicitud = this.$route.params.solicitudId
  if(this.idSolicitud > 0){
    store.aprobacion.validacion = true;
  }
    // this.departamentos = direccionData[0].departamentos
    this.departamentos = ['FRANCISCO MORAZAN', 'EL PARAISO', 'ATLANTIDA', 'COPAN', 'LEMPIRA', 'OCOTEPEQUE', 'OLANCHO', 'SANTA BARBARA', 'COMAYAGUA AGRICOLA',
      'OLANCHO AGRICOLA', 'ATLANTIDA AGRICOLA', 'CHOLUTECA AGRICOLA', 'COLON AGRICOLA', 'EL PARAISO AGRICOLA', 'FRANCISCO MORAZAN AGRICOLA', 'INTIBUCA AGRICOLA', 'LEMPIRA AGRICOLA', 'LEMPIRA/TOMALA', 'LEMPIRA/ERANDIQUE', 'YORO AGRICOLA']

    this.userRoles = Security.getUserRoles();
    // console.log(this.userRoles);
    this.roles.forEach(element => {

      if (this.userRoles[0]?.some(role => role.includes(element)) === true) {
        this[element] = true;
      } else if (this.userRoles[0]?.some(role => role.includes('Coordinador Sucursal')) === true) {
        this.coordinadorSucursal = true;
        // console.log('coordinador sucursal en true')
      } else if (this.userRoles[0]?.some(role => role.includes('Modo Thanos')) === true) {
        this.modoThanos = true;
        // console.log('Modo thanos en true')
      }
      /*       if (this.userRoles[0]?.some(role => role.includes('Coordinador Sucursal')) === true) {
            } */


    });

    // Obtener GrupoSolidario por edit is id > 0
    if (this.idSolicitud > 0) {
      //editing a solicitante
      fetch(
        process.env.VUE_APP_API_URL +
        "/admin/solicitud/" +
        this.$route.params.solicitudId,
        Security.requestOptions("")
      )
        .then((response) => response.json())
        .then((data) => {
          if (data.error) {
            this.$emit("error", data.message);
          } else {
            // this.Grupo = data.data;
            console.log("Dataa:", data.data[0].cliente);  
            
            if (!this.creditrabajo2() && !this.creaFuturo()) {

              let currentSol = data.data.find((sol) => sol.id == this.$route.params.solicitudId)
              this.solicitud = currentSol
              this.solicitud.referenciasExtra = Array.isArray(currentSol.referenciasExtra) ? currentSol.referenciasExtra : []
              this.gruposSolidariosArray = data.data
              this.solicitud.fechaPago = currentSol.fechaPago
              this.solicitud.frecuenciaPago = currentSol.frecuenciaPago.toLowerCase()
              this.cliente = currentSol.cliente
              // solicitudCompleta.nombreGrupoSolidario = data.data.nombreGrupoSolidario
              // solicitudCompleta.integrantes = data.data.clientes
              // this.dni = data.data.dni;
              // this.cliente.estado = data.data.estado;
              this.solicitudCompleta.producto = (this.solicitud.producto)
              this.comisionAsistenciaTecnica = 3.50
              this.comisionDesembolso = 2.50
              this.tasaSeguridad = 0.40
              this.montoDesembolsar = this.solicitud.montoDesembolsar
              if(this.creaFuturo()){
              console.log("Es Crea Futuro")
                this.onBlur()
              }
              this.totalComisionDesembolso = this.solicitud.monto * (this.comisionDesembolso / 100)
              this.totalComisionAsistenciaTecnica = this.solicitud.monto * (this.comisionAsistenciaTecnica / 100)
              this.totalTasaSeguridad = this.solicitud.monto * (this.tasaSeguridad / 100)
              this.montoNeto = this.solicitud.monto - this.totalComisionDesembolso - this.totalComisionAsistenciaTecnica - this.totalTasaSeguridad
              // this.fechaPago = this.solicitud.fechaPago.length < 10 ? ((new Date()).toISOString().slice(0,10)) : this.solicitud.fechaPago
              this.fechaPago = (new Date()).toISOString().slice(0, 10)
              console.log(this.solicitud)

              
              this.FotoBenficiario(this.cliente.dni)
              // Pago Intereses
              // Logica para calcular el monto y la cantidad de pagos de intereses

              if (this.solicitud.pagosInteres == null) {
                this.solicitud.pagosInteres = []
              } else { 

                this.pagosInteres = this.solicitud.pagosInteres
              }
              if (this.pagosInteres.length > 0) {
                this.arregloPagoIntereses = true

                for (let i = 0; i < this.solicitud.pagosInteres.length; i++) {
                  const element = this.solicitud.pagosInteres[i];

                  this.montoAPInteres += element.monto
                  this.noPagosAPInteres += 1

                  this.solicitud.pagosInteres[i].fecha = this.convertirISOaFechaCorta(this.solicitud.pagosInteres[i].fecha)

                }
              }

              this.montoAPInteres= this.montoAPInteres.toFixed(2)


               console.log("Solicitud Completa en Nueva Solicitud:", this.solicitud);
    this.cuotaSolicitud = this.obtenerCuotaTotal({
      monto: this.solicitud.monto,
      frecuenciaPago: this.solicitud.frecuenciaPago,
      interesAnual: this.solicitud.interes,
      plazo: this.solicitud.plazoPago,
      producto: this.solicitud.producto,
      periodoGracia: this.solicitud.periodoGracia || 0
    });
    console.log("Cuota:", this.cuotaSolicitud);


            } else {

              console.log("Data", data.data);

            }

            this.getCountArchivos(this.solicitud.id);
            this.getFirma(this.solicitud.id);
          }
        });
    } else if (solicitudCompleta.producto == "") {
      // router.push("/solicitud");
      // location.reload();
      // window.location.href = "/solicitud";
      this.solicitudCompleta.producto = "MICROCREDITO";
    }
    // if (this.validarMiPyme) {
    //   this.solicitudCompleta.integranteSolicitud+2
    // }
    if (this.creditrabajo2) {
      this.solicitud.frecuenciaPago = 'semanal'
    }

    
    
  },
  mounted() {
    Security.requireToken();


    const valorInputs = document.querySelectorAll(".valor");
    const totalCell = document.getElementById("total");

    // Actualiza el total cuando se cambian los valores

    
    function actualizarTotal() {
      if(store.aprobacion.validacion ){
      let total = 0;
      valorInputs.forEach((input) => {
        total += parseFloat(input.value) || 0;
      });
      totalCell.textContent = total;
    }
    }
    // Escucha eventos de cambio en los inputs de valor
    valorInputs.forEach((input) => {
      input.addEventListener("input", actualizarTotal);
    });

    // Inicializa el total
    actualizarTotal();
    this.cliente =
      this.solicitudCompleta.integrantes[
      this.solicitudCompleta.integranteSolicitud
      ];

    if (this.cliente && Object.keys(this.cliente).length > 0) {
        this.dni = this.formatDNI(this.cliente.dni) ;
        // this.dni = this.cliente.dni;
      }

      const modalEl = document.getElementById('estadoSolicitud');
      if (modalEl) {
        modalEl.addEventListener('show.bs.modal', () => {
          if (this.$refs.estadoComp?.getCountArchivos) {
            this.$refs.estadoComp.getCountArchivos(this.idSolicitud);
          }
        });
      }
      
  },
  updated(){
    
  },
  methods: {
    crearReferenciaExtra() {
      return {
        id: 0,
        idSolicitud: Number(this.solicitud?.id || this.idSolicitud || 0),
        tipoReferencia: "",
        nombreCompleto: "",
        parentescoORelacion: "",
        direccion: "",
        telefono: "",
      };
    },
    agregarReferenciaExtra() {
      if (!Array.isArray(this.solicitud.referenciasExtra)) {
        this.solicitud.referenciasExtra = [];
      }
      this.solicitud.referenciasExtra.push(this.crearReferenciaExtra());
    },
    quitarReferenciaExtra(index) {
      if (!this.Admin) {
        return;
      }
      if (!Array.isArray(this.solicitud.referenciasExtra)) {
        return;
      }
      this.solicitud.referenciasExtra.splice(index, 1);
    },
    opcionesParentescoReferenciaExtra(tipoReferencia) {
      const tipo = String(tipoReferencia || "").toLowerCase();
      const opcionesFamiliares = [
        "Padre",
        "Madre",
        "Hermano(a)",
        "Tío(a)",
        "Abuelo(a)",
        "Sobrino(a)",
        "Hijo(a)",
        "Primo(a)",
        "Suegro(a)",
        "Cuñado(a)",
        "Nuera",
        "Yerno",
        "Esposo(a)",
        "Nieto(a)",
        "Amigo(a)",
        "Compañero de Trabajo",
        "Conocido(a)",
      ];
      const opcionesPersonales = [
        "Amigo(a)",
        "Compañero de Trabajo",
        "Conocido(a)",
      ];

      if (tipo === "familiar") {
        return opcionesFamiliares;
      }
      if (tipo === "personal") {
        return opcionesPersonales;
      }
      return [];
    },
    referenciaExtraTieneDatos(referenciaExtra) {
      if (!referenciaExtra) {
        return false;
      }
      return [
        referenciaExtra.tipoReferencia,
        referenciaExtra.nombreCompleto,
        referenciaExtra.parentescoORelacion,
        referenciaExtra.direccion,
        referenciaExtra.telefono,
      ].some((valor) => String(valor || "").trim() !== "");
    },
    normalizarReferenciasExtra() {
      if (!Array.isArray(this.solicitud.referenciasExtra)) {
        return [];
      }
      return this.solicitud.referenciasExtra
        .filter((referenciaExtra) => this.referenciaExtraTieneDatos(referenciaExtra))
        .map((referenciaExtra) => ({
          id: Number(referenciaExtra.id || 0),
          idSolicitud: Number(referenciaExtra.idSolicitud || this.solicitud.id || this.idSolicitud || 0),
          tipoReferencia: String(referenciaExtra.tipoReferencia || "").trim(),
          nombreCompleto: String(referenciaExtra.nombreCompleto || "").trim(),
          parentescoORelacion: String(referenciaExtra.parentescoORelacion || "").trim(),
          direccion: String(referenciaExtra.direccion || "").trim(),
          telefono: String(referenciaExtra.telefono || "").trim(),
        }));
    },
    esEdicionSolicitudActual() {
      return Number(this.solicitud?.id || this.solicitud?.ID || this.$route.params.solicitudId || 0) > 0;
    },
    sincronizarSolicitudGuardada(data, payload) {
      const referenciasGuardadas = data?.data?.referenciasExtra;
      const solicitudGuardada = { ...payload };
      delete solicitudGuardada.idUsuario;

      this.solicitud = {
        ...this.solicitud,
        ...solicitudGuardada,
        referenciasExtra: Array.isArray(referenciasGuardadas)
          ? referenciasGuardadas
          : (payload.referenciasExtra || []),
      };
    },
    obtenerTasaInteresMicro(){

      switch (this.claseScore) {
        case "A":
          this.solicitud.interes = 26;
         
          break;
        case "B":
          this.solicitud.interes = 28;
       
          break;
        case "C":
          this.solicitud.interes = 31;
         
          break;
        case "D":
          this.solicitud.interes = 34;
         
          break;
        case "E":
          this.solicitud.interes = 36;
        
          break;
        default:
          this.solicitud.interes = 36;
          
      }
    },
    guardarFirma(firma) {
      this.firmaBase64 = firma
      console.log('Firma Base64:', firma)
      // Aquí puedes hacer un fetch para guardar en backend si quieres
    },
    mostrarAlerta() {
      alert('La firma está vacía.')
    },
    obtenerCuotaTotal({
  monto,
  frecuenciaPago,
  interesAnual,     // ejemplo: 24 (para 24%)
  plazo,            // tu "plazoPago"
  producto,
  periodoGracia = 0 // numero de cuotas en gracia (según tu lógica actual)
}) {
  const tasaAnual = interesAnual / 100;

  let periodo = 12;
  let diasPeriodo = 30.0;
  let noCuotas = plazo;

  switch (this.limpiarYMinusc(frecuenciaPago)) {
    case "mensual":
      noCuotas = plazo;
      periodo = 12;
      diasPeriodo = 30.0;
      break;

    case "quincenal":
      noCuotas = plazo * 2;
      periodo = 24;
      diasPeriodo = 15.0;
      break;

    case "semanal":
      noCuotas = this.esCrediTrabajo(producto) ? (plazo * 4) : (plazo * 4.3333333333);
      noCuotas = Math.round(noCuotas);
      periodo = 52.1;
      diasPeriodo = 7.0;
      break;

    case "alvencimiento":
      noCuotas = 1;
      periodo = (30 / (plazo * 30)) * 12;
      diasPeriodo = plazo * 30;
      break;

    case "bimensual":
      noCuotas = plazo / 2;
      periodo = 6;
      diasPeriodo = 60.0;
      break;

    case "trimestral":
      noCuotas = plazo / 3;
      periodo = 4;
      diasPeriodo = 90.0;
      break;

    case "semestral":
      noCuotas = plazo / 6;
      periodo = 2;
      diasPeriodo = 180.0;
      break;

    case "anual":
      noCuotas = plazo / 12;
      periodo = 1;
      diasPeriodo = 360.0;
      break;

    default:
      console.log("Periodo de pago no válido");
      return 0;
  }

  // Caso especial: CrediTrabajo / Credi Trabajo 2 => cuota = capital/noCuotas
  if (this.comprobarCrediTrabajo(producto) === true || producto === "Credi Trabajo 2") {
    noCuotas = Math.round(noCuotas);
    return monto / noCuotas;
  }

  // Cuota nivelada normal (con ajuste por periodo de gracia como en tu código)
  let periodosParaCuota = plazo;
  if (periodoGracia > 0) {
    periodosParaCuota = plazo - (periodoGracia * 12 / periodo);
  }

  return this.CalculaCuotaNivelada(
    monto,
    tasaAnual,
    periodosParaCuota,
    periodo,
    diasPeriodo
  );
},
comprobarCrediTrabajo(producto) {

            if (producto === 'Credi Trabajo' || producto === 'Credi Trabajo' || producto === 'Creditrabajo ' || producto === 'credi trabajo' || producto === 'CREDI TRABAJO' || producto === 'CREDITRABAJO' || producto === 'creditrabajo' || producto === 'CREDITRABAJO ' || producto === 'creditrabajo ' || producto === 'Creditrabajo ' || producto === 'Credi Trabajo ' || producto === ' Credi trabajo' || producto === 'credi trabajo ' || producto === 'Credi trabajo' || producto === ' credi trabajo') {
                return true
            } else {
                return false
            }
        },

    generarPagosInteres() {
      // Reinicia el arreglo según la cantidad indicada
      this.pagosInteres = Array.from({ length: this.noPagosAPInteres }, () => ({
        monto: null,
        fecha: ''
      }));
    },
      irASolicitante( cliente) {
        if (cliente != undefined) {
        console.log('Cliente ID:', cliente.id);
        this.store.aprobacion.id = cliente.id;
        this.store.aprobacion.validacion = false;
        this.$router.push(`/solicitante/${cliente.id}`);
      } else {
        console.warn('ID de cliente no disponible');
      }
    },
    dateFormat(param) {
      // const date = new Date(param)

      // const dia = (param)?.slice(8, 10)
      // const mes = date.toLocaleDateString('es-ES', { month: 'long' })
      // const anio = date.getFullYear()
      // const dateFormated = `${dia}/${mes.slice(0, 3)}/${anio}`
      // return dateFormated
      // Fecha en formato ISO 8601
      // Fecha en formato ISO 8601
      var fechaISO = param;


      // Crear un objeto Date con la fecha proporcionada
      var fecha = new Date(fechaISO);

      // Obtener el día del mes (agregando un cero inicial si es necesario)
      var dia = ('0' + fecha.getUTCDate()).slice(-2);

      // Obtener el mes (agregando un cero inicial si es necesario)
      var mes = ('0' + (fecha.getUTCMonth() + 1)).slice(-2);

      // Obtener el año
      var anio = fecha.getUTCFullYear();

      // Formatear la fecha según tus necesidades
      var fechaFormateada = dia + '/' + mes + '/' + anio;

      console.log(fechaFormateada); // Salida: 01/12/2023

      return fechaFormateada;

    },
    convertirISOaFechaCorta(fechaISO) {
      const fecha = new Date(fechaISO);
      const año = fecha.getUTCFullYear();
      const mes = String(fecha.getUTCMonth() + 1).padStart(2, '0');
      const dia = String(fecha.getUTCDate()).padStart(2, '0');
      return `${año}-${mes}-${dia}`;
    },
    obtenerCoordinador() {
      if (this.solicitud.coordinadorGrupoSolidario)

        switch (this.solicitud.coordinadorGrupoSolidario) {
          case this.solicitud.integrantesGruposSolidario.int1:
            return this.nomInt1
          case this.solicitud.integrantesGruposSolidario.int2:
            return this.nomInt2
          case this.solicitud.integrantesGruposSolidario.int3:
            return this.nomInt3
          case this.solicitud.integrantesGruposSolidario.int4:
            return this.nomInt4
          case this.solicitud.integrantesGruposSolidario.int5:
            return this.nomInt5
          default:
            return ""


        }
    },
    formatoNumero(numero) {
      return new Intl.NumberFormat("en-US").format(numero)
    },
    seleccionarCoordinador(dni, integrante) {

      console.log(dni, integrante);
      this.solicitud.coordinadorGrupoSolidario = dni
    },
    creditrabajo2() {
      return this.solicitudCompleta.producto === 'Credi Trabajo 2'

    },
    creaFuturo() {
      return this.solicitudCompleta.producto === 'CREAFUTURO'

    },
    microCredito() {
      return this.solicitudCompleta.producto === 'MICROCREDITO'

    },
    onBlur() {
      //Funcion para calcular el monto del credito



      if (this.montoDesembolsar > 0 || this.solicitud.monto > 0) {
        // Crea Futuro
        if (this.creaFuturo()) {
          // this.solicitud.interes = 12
          this.comisionDesembolso = 3.5
          this.comisionAsistenciaTecnica = 4.5
          this.tasaSeguridad = 0.2
          this.reservasSeguros = 1.6
          this.consultasBuro = 0.2

          this.totalComisionDesembolso = (this.comisionDesembolso / 100) * this.solicitud.monto
          this.totalComisionAsistenciaTecnica = (this.comisionAsistenciaTecnica / 100) * this.solicitud.monto

          this.tasaSeguridad = 0.2
          this.totalTasaSeguridad = (0.2 / 100) * this.solicitud.monto
          this.totalReservasSeguros = (this.reservasSeguros / 100) * this.solicitud.monto
          this.totalConsultasBuro = (this.consultasBuro / 100) * this.solicitud.monto
          this.totalComisionDesembolso = this.totalComisionDesembolso.toFixed(2)
          this.totalComisionAsistenciaTecnica = this.totalComisionAsistenciaTecnica.toFixed(2)

          // const montoDesembolsar = parseInt(this.montoDesembolsar, 10);
          const totalComisionDesembolso = this.totalComisionDesembolso;
          const totalTasaSeguridad = this.totalTasaSeguridad;
          const totalComisionAsistenciaTecnica = this.totalComisionAsistenciaTecnica;
          // const cobroPorACH = 40.00;

          if (this.cliente?.nombreBanco === 'Banco de Desarrollo Rural Honduras') {
            this.cobroPorACH = 0.00
          }
          this.solicitud.montoDesembolsar = (this.solicitud.monto - totalComisionDesembolso - totalTasaSeguridad - totalComisionAsistenciaTecnica - this.cobroPorACH - this.totalReservasSeguros - this.totalConsultasBuro).toFixed(2);
          this.montoDesembolsar = this.solicitud.montoDesembolsar

        } else if (this.microCredito()) {
          // this.solicitud.interes = 12
          this.comisionDesembolso = 6.0
          this.comisionAsistenciaTecnica = 8.0
          this.tasaSeguridad = 0.2
          this.reservasSeguros = 1.6
          this.consultasBuro = 0.2

          this.totalComisionDesembolso = (this.comisionDesembolso / 100) * this.solicitud.monto
          this.totalComisionAsistenciaTecnica = (this.comisionAsistenciaTecnica / 100) * this.solicitud.monto

          this.tasaSeguridad = 0.2
          this.totalTasaSeguridad = (0.2 / 100) * this.solicitud.monto
          this.totalReservasSeguros = (this.reservasSeguros / 100) * this.solicitud.monto
          this.totalConsultasBuro = (this.consultasBuro / 100) * this.solicitud.monto
          this.totalComisionDesembolso = this.totalComisionDesembolso.toFixed(2)
          this.totalComisionAsistenciaTecnica = this.totalComisionAsistenciaTecnica.toFixed(2)

          // const montoDesembolsar = parseInt(this.montoDesembolsar, 10);
          const totalComisionDesembolso = this.totalComisionDesembolso;
          const totalTasaSeguridad = this.totalTasaSeguridad;
          const totalComisionAsistenciaTecnica = this.totalComisionAsistenciaTecnica;
          // const cobroPorACH = 40.00;

          if (this.cliente?.nombreBanco === 'Banco de Desarrollo Rural Honduras') {
            this.cobroPorACH = 0.00
          }
          this.solicitud.montoDesembolsar = (this.solicitud.monto - totalComisionDesembolso - totalTasaSeguridad - totalComisionAsistenciaTecnica - this.cobroPorACH - this.totalReservasSeguros - this.totalConsultasBuro).toFixed(2);
          this.montoDesembolsar = this.solicitud.montoDesembolsar

        } else {
          if (this.solicitud.plazoPago > 0 && this.solicitud.plazoPago < 7 && this.creditrabajo2()) {
            console.log("Entra en Creditrabajo 2 Pago");
            
            this.totalComisionDesembolso = (4.5 / 100) * this.montoDesembolsar
            this.totalComisionAsistenciaTecnica = (4.0 / 100) * this.montoDesembolsar

            this.totalTasaSeguridad = (0.4 / 100) * this.montoDesembolsar

            this.montoInteres = (((this.montoDesembolsar * (5 / 100)) * this.solicitud.plazoPago) - (this.totalComisionAsistenciaTecnica + this.totalComisionDesembolso))
            // this.solicitud.monto = this.montoDesembolsar + this.montoInteres
            this.totalComisionDesembolso = parseInt(this.totalComisionDesembolso, 10).toFixed(2)
            this.totalComisionAsistenciaTecnica = parseInt(this.totalComisionAsistenciaTecnica, 10).toFixed(2)
            // Convertir los valores a enteros antes de sumarlos
            const montoDesembolsar = parseInt(this.montoDesembolsar, 10);
            const montoInteres = parseInt(this.montoInteres, 10);
            const totalComisionDesembolso = parseInt(this.totalComisionDesembolso, 10);
            const totalTasaSeguridad = parseInt(this.totalTasaSeguridad, 10);
            const totalComisionAsistenciaTecnica = parseInt(this.totalComisionAsistenciaTecnica, 10);

            // Asignar la suma a solicitud.monto
            this.solicitud.monto = (montoDesembolsar + montoInteres + totalComisionDesembolso + totalTasaSeguridad + totalComisionAsistenciaTecnica).toFixed(2);

            console.log("El campo de interés perdió el foco. Valor actual: " + this.totalComisionDesembolso);

          }
        }
      }


      // Lógica adicional que deseas ejecutar cuando se sale del input
    },
    quitarFila() {
      // Agregar una nueva fila al arreglo de filas
      if (this.solicitud.filas.length > 0) {
        // Eliminar la última fila del arreglo de filas
        this.solicitud.filas.pop();
      }
    },
    agregarFila() {
      // Agregar una nueva fila al arreglo de filas
      this.solicitud.filas.push({ requerimiento: '', descripcion: '', valor: 0 });
    },
    async exportarSolicitudPDF(tipoExportar) {
      const doc = new jsPDF()
      const text = 'SOLICITUD DE CRÉDITO SUBSIGUIENTE';
      // const textWidth = doc.getTextWidth(text);
      // const centerX = (doc.internal.pageSize.width - textWidth) / 2;
      const y = 20;
      var tableHeight

      // Calcula las dimensiones del documento
      const docWidth = doc.internal.pageSize.getWidth();
      // Agrega una imagen al documento
      const img = new Image();
      img.src = require('@/assets/header.png'); // Reemplaza 'mi_imagen.jpg' con el nombre de tu imagen
      // Calcula las dimensiones de la imagen para que ocupe todo el ancho de la página
      const imgWidth = docWidth;
      // const imgHeight = (img.height * imgWidth) / img.width;
      // doc.addImage(img, 'PNG', 10, 10, 300, 200); // Ajusta las coordenadas y el tamaño según tu necesidad
      doc.addImage(img, 'PNG', 0, 0, imgWidth, 30);
      doc.setFontSize(12)
      doc.setTextColor(255, 255, 255);
      doc.text(text, 110, (y - 4));

      doc.setFontSize(12)
      doc.setTextColor(0, 0, 0);

      const product = 'Producto: ' + ((this.solicitud.producto == 'Credi Trabajo 2' ? 'Creditrabajo' : this.solicitud.producto))
      const date = 'Fecha ' + new Date().toLocaleDateString('en-GB')

      // doc.text(product, 10, 20)
      doc.setFontSize(10)
      doc.text(product, 10, 35, { align: 'left' });

      doc.text(date, doc.internal.pageSize.width - 10, 35, { align: 'right' });
      doc.setFontSize(12)
      doc.autoTable({
        body: [
          [{ content: 'DATOS PERSONALES DEL SOLICITANTE', colSpan: 6, cellStyles: { lineWidth: [0, 0, 0, 0] }, styles: { fontStyle: 'bold' } }, { content: `Nombre del Grupo: ${this.solicitud?.nombreGrupoSolidario}`, colSpan: 6 }],
          [{ content: `Nombre Completo: ${this.cliente?.nombres ? this.cliente?.nombres : '-'} ${this.cliente?.apellidos ? this.cliente?.apellidos : ''}`, colSpan: 12, alignment: 'left', fontStyle: 'bold', halign: 'left' }],
          [{ content: `Número de Identidad: ${this.cliente?.dni ? this.cliente?.dni : ''}`, colSpan: 6 }, { content: `Lugar de Nacimiento: ${this.cliente?.lugarNacimiento ? this.cliente?.lugarNacimiento : ''}`, colSpan: 3 }, { content: `Sexo: ${this.cliente?.sexo ? this.cliente?.sexo : ''}`, colSpan: 3 }],

          [{ content: `Estado Civil: ${this.cliente?.estadoCivil ? this.cliente?.estadoCivil : '-'}`, colSpan: 5 }, { content: `Fecha de Nacimiento: ${this.cliente?.fechaNacimiento ? this.cliente?.fechaNacimiento : '-'}`, colSpan: 4 }, { content: `Edad: ${this.cliente.edad ? this.cliente.edad : '-'}`, colSpan: 3 }],
          [{ content: `Correo Electronico: ${this.cliente?.email ? this.cliente?.email : '-'}`, colSpan: 6 }, { content: `Telefono: ${this.cliente.telefono ? this.cliente.telefono : ''}`, colSpan: 3 }, { content: `Celular: ${this.cliente?.celular ? this.cliente?.celular : "-"}`, colSpan: 3 }],
          [{ content: `Nombre del Banco: ${this.cliente?.nombreBanco ? this.cliente?.nombreBanco : '-'}`, colSpan: 6 }, { content: `Número de cuenta del Banco: ${this.cliente?.noCuentaBanco ? this.cliente?.noCuentaBanco : '-'}`, colSpan: 6 }]
        ],
        startY: 40,
        theme: 'grid',
        styles: {
          halign: 'left',
        },
        border: [{ top: 1, right: 1, bottom: 1, left: 1 }],
        didDrawPage: function (data) {
          // Guardar la altura de la tabla
          tableHeight = data.cursor.y;
        }
      })


      tableHeight += 10
      const text2 = 'DATOS DOMICILIARES DEL SOLICITANTE';
      doc.text(text2, 15, tableHeight);
      tableHeight += 5
      doc.autoTable({
        body: [
          [
            { content: `Depto.: ${this.cliente?.departamento ? this.cliente.departamento : '-'}`, colSpan: 4 },
            { content: `Municipio: ${this.cliente?.municipio ? this.cliente.municipio : '-'}`, colSpan: 4 },
            { content: `Col/ Bar/ Ald: ${this.cliente?.colonia ? this.cliente.colonia : '-'}`, colSpan: 4 },
            { content: `Calle: ${this.cliente?.calle ? this.cliente.calle : '-'}`, colSpan: 2 },
            { content: `Avenida: ${this.cliente?.avenida ? this.cliente.avenida : '-'}`, colSpan: 2 },
            { content: `Bloque: ${this.cliente?.bloque ? this.cliente.bloque : '-'}`, colSpan: 2 },
            { content: `Casa No. ${this.cliente?.noCasa ? this.cliente.noCasa : '-'}`, colSpan: 2 },
          ],
          [
            { content: `Punto de Referencia: ${this.cliente.puntoReferencia ? this.cliente.puntoReferencia : '-'}`, colSpan: 12 },
            { content: `Tipo de vivienda: ${this.cliente.tipoVivienda ? this.cliente.tipoVivienda : '-'}`, colSpan: 4 },
            { content: `Cuota de Vivienda: ${this.cliente?.cuotaVivienda ? this.cliente.cuotaVivienda : '-'}`, colSpan: 4 },
          ],
          [
            { content: `Si Alquila (Nombre y Telefono del propietario): ${this.cliente?.propietarioAlquila ? this.cliente?.propietarioAlquila : '-'}`, colSpan: 20 },
          ],
        ],
        startY: tableHeight,
        theme: 'grid',
        styles: {
          halign: 'left',
        },
        didDrawPage: function (data) {
          // Guardar la altura de la tabla
          tableHeight = data.cursor.y;
        }
      });

      tableHeight += 10
      doc.text('DATOS DEL NEGOCIO DEL SOLICITANTE', 15, tableHeight)
      tableHeight += 5
      doc.autoTable({
        body: [
          [
            { content: `Destino: ${this.cliente?.destino ? this.cliente.destino : '-'}`, colSpan: 4 }, { content: `Tipo del Cliente: ${this.cliente?.tipoCliente ? this.cliente.tipoCliente : '-'}`, colSpan: 4 }, { content: `Actividad Económica: ${this.cliente?.actividadEconomica ? this.cliente.actividadEconomica : '-'}`, colSpan: 4 }, { content: `Tiempo de tener el negocio: ${this.cliente?.tiempoNegocio ? this.cliente.tiempoNegocio : '-'}`, colSpan: 4 },
          ],
          [
            { content: `Tipo de Local: ${this.cliente?.tipoLocal ? this.cliente.tipoLocal : '-'}`, colSpan: 4 }, { content: `Cuota de Alquiler: ${this.cliente?.cuotaAlquilerNegocio ? this.cliente?.cuotaAlquilerNegocio : ''}`, colSpan: 4 }, { content: `Ingreso Bruto del Negocio: ${this.cliente?.ingresoBrutoNegocio ? this.cliente?.ingresoBrutoNegocio : '-'}`, colSpan: 4 }, { content: `Teléfono: ${this.cliente?.telefono}`, colSpan: 4 },
          ],
          [
            { content: `Col/ Bar/ Ald: ${this.cliente.coloniaNegocio ? this.cliente.coloniaNegocio : '-'}`, colSpan: 3 },
            { content: `Zona / Sector: ${this.cliente.sectorNegocio ? this.cliente.sectorNegocio : '-'}`, colSpan: 3 },
            { content: `Calle: ${this.cliente.calleNegocio ? this.cliente.calleNegocio : '-'}`, colSpan: 3 },
            { content: `Avenida: ${this.cliente.avenidaNegocio ? this.cliente.avenidaNegocio : '-'}`, colSpan: 3 },
            { content: `Bloque: ${this.cliente.bloqueNegocio ? this.cliente.bloqueNegocio : '-'}`, colSpan: 2 },
            { content: `Casa No. ${this.cliente.noCasaNegocio ? this.cliente.noCasaNegocio : '-'}`, colSpan: 2 },
          ],
          [
            { content: `Punto de Referencia: ${this.cliente.puntoReferenciaNegocio}`, colSpan: 16 },
          ],
        ],
        startY: tableHeight,
        theme: 'grid',
        styles: {
          halign: 'left',
        },
        border: [{ top: 1, right: 1, bottom: 1, left: 1 }],
        didDrawPage: function (data) {
          // Guardar la altura de la tabla
          tableHeight = data.cursor.y;
        }
      })


      if (this.cliente.nombresConyugue != undefined) {
        tableHeight += 10
        doc.text('DATOS CONYUGUE', 15, tableHeight)
        tableHeight += 5
        doc.autoTable({
          body: [
            [
              { content: `Nombre Completo: ${this.cliente.nombresConyugue ? this.cliente.nombresConyugue : ''} ${this.cliente.apellidosConyugue ? this.cliente.apellidosConyugue : ''}`, colSpan: 5 },
              { content: `Número de Identidad: ${this.cliente.dniConyugue ? this.cliente.dniConyugue : '-'} `, colSpan: 5 },
            ],
            [
              { content: `Correo ELectrónico: ${this.cliente.emailConyugue ? this.cliente.emailConyugue : '-'}`, colSpan: 5 },
              { content: `Celular: ${this.cliente.celularConyugue ? this.cliente.celularConyugue : '-'}`, colSpan: 5 },
            ],
          ],
          startY: tableHeight,
          theme: 'grid',
          styles: {
            halign: 'left',
          },
          didDrawPage: function (data) {
            // Guardar la altura de la tabla
            tableHeight = data.cursor.y;
          }

        })
        doc.addPage()
        tableHeight = 20

      } else {

        tableHeight += 10
      }




      doc.text('REFERENCIAS', 15, tableHeight)
      tableHeight += 5

      doc.autoTable({
        head: [['Nombre', 'Parentesco', 'Dirección', 'Celular']],
        body: [
          [
            { content: this.solicitud.referencias.nom1 },
            { content: this.solicitud.referencias.par1 },
            { content: this.solicitud.referencias.dir1 },
            { content: this.solicitud.referencias.cel1 === 0 ? '' : this.solicitud.referencias.cel1 },
          ],
          [
            { content: this.solicitud.referencias.nom2 },
            { content: this.solicitud.referencias.par2 },
            { content: this.solicitud.referencias.dir2 },
            { content: this.solicitud.referencias.cel2 === 0 ? '' : this.solicitud.referencias.cel2 },
          ],
          [
            { content: this.solicitud.referencias.nom3 },
            { content: this.solicitud.referencias.par3 },
            { content: this.solicitud.referencias.dir3 },
            { content: this.solicitud.referencias.cel3 === 0 ? '' : this.solicitud.referencias.cel3 },
          ],
          [
            { content: this.solicitud.referencias.nom4 },
            { content: this.solicitud.referencias.par4 },
            { content: this.solicitud.referencias.dir4 },
            { content: this.solicitud.referencias.cel4 === 0 ? '' : this.solicitud.referencias.cel4 },
          ],
        ],
        startY: tableHeight,
        headStyles: { fillColor: [41, 128, 185], halign: 'center' },
        theme: 'grid',
        styles: {
          halign: 'left',
        },
        border: [{ top: 1, right: 1, bottom: 1, left: 1 }],
        didDrawPage: function (data) {
          // Guardar la altura de la tabla
          tableHeight = data.cursor.y;
        }
      })

      if ((this.cliente.nombresConyugue == undefined)) {
        doc.addPage()
        tableHeight = 30
      } else {
        tableHeight += 10
      }

      doc.text('DESTINO DEL CRÉDITO:', 15, tableHeight)

      tableHeight += 5

      doc.autoTable({
        body: [
          [{ content: ` Emprender un Negocio  [ ${this.solicitud.destinoCreditos.includes('Emprender un Negocio') ? ' X ' : ''} ]   Comprar maquinaria y equipo  [ ${this.solicitud.destinoCreditos.includes('Comprar maquinaria y equipo') ? ' X ' : ''} ]   Reabastecer el negocio  [ ${this.solicitud.destinoCreditos.includes('Reabastecer el negocio') ? ' X ' : ''} ]   Otras  [ ${this.solicitud.destinoCreditos.includes('Otras') ? ' X ' : ''} ]` }],
        ],
        startY: tableHeight,
        theme: 'plain',
        didDrawPage: function (data) {
          // Guardar la altura de la tabla
          tableHeight = data.cursor.y;
        }
      })
      tableHeight += 5
      doc.setFontSize(10)
      doc.text('1. Certifico que la información arriba descrita es verídica y autorizo para que sea confirmada si así fuera el caso \ncualquier dato falso sea motivo para la no aprobación del préstamo.', 15, tableHeight)
      tableHeight += 20
      doc.setFontSize(12)
      doc.text('PLAN DE INVERSION:', 15, tableHeight)
      doc.setFontSize(10)
      tableHeight += 8
      doc.text('Inventario de producto, materia prima, mano de obra, mobiliario, equipo de producción y equipo de transporte \nque requiere:', 15, tableHeight)
      tableHeight += 8
      doc.autoTable({
        head: [['Requerimiento', 'Descripción', 'Valor (Monto L.)']],
        body: [
          [
            { content: this.solicitud.planInversion.req1 },
            { content: this.solicitud.planInversion.desc1 },
            { content: this.solicitud.planInversion.val1 === 0 ? '' : this.solicitud.planInversion.val1 },
          ],
          [
            { content: this.solicitud.planInversion.req2 },
            { content: this.solicitud.planInversion.desc2 },
            { content: this.solicitud.planInversion.val2 === 0 ? '' : this.solicitud.planInversion.val2 },
          ],
          [
            { content: this.solicitud.planInversion.req3 },
            { content: this.solicitud.planInversion.desc3 },
            { content: this.solicitud.planInversion.val3 === 0 ? '' : this.solicitud.planInversion.val3 },
          ],
          [
            { content: this.solicitud.planInversion.req4 },
            { content: this.solicitud.planInversion.desc4 },
            { content: this.solicitud.planInversion.val4 === 0 ? '' : this.solicitud.planInversion.val4 },
          ],
          [
            { content: this.solicitud.planInversion.req5 },
            { content: this.solicitud.planInversion.desc5 },
            { content: this.solicitud.planInversion.val5 === 0 ? '' : this.solicitud.planInversion.val5 },
          ],
        ],
        startY: tableHeight,
        headStyles: { fillColor: [41, 128, 185], halign: 'center' },
        theme: 'grid',
        styles: {
          halign: 'left',
        },
        border: [{ top: 1, right: 1, bottom: 1, left: 1 }],
      })

      doc.addPage()
      let text3 = 'Sectores Y Grupos Especiales';
      const textWidth = doc.getTextWidth(text3);
      const centerX = (doc.internal.pageSize.width - textWidth) / 2;
      let y2 = 25;

      // doc.addImage(img, 'PNG', 10, 10, 300, 200); // Ajusta las coordenadas y el tamaño según tu necesidad
      doc.setFontSize(12)

      doc.text(text3, centerX, (y2));
      doc.setFontSize(10)
      doc.autoTable({
        head: [[{ content: 'Sector', colSpan: 8, styles: { fontStyle: 'bold' } }]],
        body: [
          [{ content: 'Adulto Mayor', colSpan: 6 }, { content: this.solicitud.sector.includes('Adulto Mayor') ? 'X' : '', colSpan: 2, styles: { halign: 'center' } }],
          [{ content: 'Afrohondureños', colSpan: 6 }, { content: this.solicitud.sector.includes('Afrohondureños') ? 'X' : '', colSpan: 2, styles: { halign: 'center' } }],
          [{ content: 'Discapacitados', colSpan: 6 }, { content: this.solicitud.sector.includes('Discapacitados') ? 'X' : '', colSpan: 2, styles: { halign: 'center' } }],
          [{ content: 'Extema Pobreza', colSpan: 6 }, { content: this.solicitud.sector.includes('Extema Pobreza') ? 'X' : '', colSpan: 2, styles: { halign: 'center' } }],
          [{ content: 'Jóvenes', colSpan: 6 }, { content: this.solicitud.sector.includes('Jóvenes') ? 'X' : '', colSpan: 2, styles: { halign: 'center' } }],
          [{ content: 'Migrante Retornado', colSpan: 6 }, { content: this.solicitud.sector.includes('Migrante Retornado') ? 'X' : '', colSpan: 2, styles: { halign: 'center' } }],
          [{ content: 'Mujer Campesina', colSpan: 6 }, { content: this.solicitud.sector.includes('Mujer Campesina') ? 'X' : '', colSpan: 2, styles: { halign: 'center' } }],
          [{ content: 'Mujeres en Situación de Vulnerabilidad', colSpan: 6 }, { content: this.solicitud.sector.includes('Mujeres en Situación de Vulnerabilidad') ? 'X' : '', colSpan: 2, styles: { halign: 'center' } }],
          [{ content: 'Pobreza', colSpan: 6 }, { content: this.solicitud.sector.includes('Pobreza') ? 'X' : '', colSpan: 2, styles: { halign: 'center' } }],
        ],
        startY: 35,
        headStyles: { fillColor: [41, 128, 185], halign: 'center' },
        theme: 'grid',
        styles: {
          halign: 'left',
        },

      })

      doc.autoTable({
        head: [[{ content: 'Grupos Especiales', colSpan: 16, styles: { fontStyle: 'bold' } }]],
        body: [
          [
            { content: 'Pueblos Indígenas', colSpan: 4 }, { content: this.solicitud.gruposEspeciales.includes('Pueblos Indígenas') ? 'X' : '', colSpan: 4, styles: { halign: 'center' } },
            { content: 'DINAFROH', colSpan: 4 }, { content: this.solicitud.gruposEspeciales.includes('DINAFROH') ? 'X' : '', colSpan: 4, styles: { halign: 'center' } },

          ],
          [
            { content: 'Credi-Feria', colSpan: 4 }, { content: this.solicitud.gruposEspeciales.includes('Credi-Feria') ? 'X' : '', colSpan: 4, styles: { halign: 'center' } },
            { content: 'DINIS', colSpan: 4 }, { content: this.solicitud.gruposEspeciales.includes('DINIS') ? 'X' : '', colSpan: 4, styles: { halign: 'center' } },

          ],
          [
            { content: 'Crédito del SSE', colSpan: 4 }, { content: this.solicitud.gruposEspeciales.includes('Crédito del SSE') ? 'X' : '', colSpan: 4, styles: { halign: 'center' } },
            { content: 'Progresa', colSpan: 4 }, { content: this.solicitud.gruposEspeciales.includes('Progresa') ? 'X' : '', colSpan: 4, styles: { halign: 'center' } },

          ],
          [
            { content: 'Reservistas', colSpan: 4 }, { content: this.solicitud.gruposEspeciales.includes('Reservistas') ? 'X' : '', colSpan: 4, styles: { halign: 'center' } },
            { content: 'Tu Banca Joven', colSpan: 4 }, { content: this.solicitud.gruposEspeciales.includes('Tu Banca Joven') ? 'X' : '', colSpan: 4, styles: { halign: 'center' } },
          ],
          [
            { content: 'Fundeimh', colSpan: 4 }, { content: this.solicitud.gruposEspeciales.includes('Fundeimh') ? 'X' : '', colSpan: 4, styles: { halign: 'center' } },
            { content: 'Caja Rural', colSpan: 4 }, { content: this.solicitud.gruposEspeciales.includes('Caja Rural') ? 'X' : '', colSpan: 4, styles: { halign: 'center' } },
          ],
          [
            { content: 'Projoven', colSpan: 4 }, { content: this.solicitud.gruposEspeciales.includes('Projoven') ? 'X' : '', colSpan: 4, styles: { halign: 'center' } },
            { content: 'Bici Solidaria', colSpan: 4 }, { content: this.solicitud.gruposEspeciales.includes('Bici Solidaria') ? 'X' : '', colSpan: 4, styles: { halign: 'center' } },
          ],
          [
            { content: 'Anmpih', colSpan: 4 }, { content: this.solicitud.gruposEspeciales.includes('Anmpih') ? 'X' : '', colSpan: 4, styles: { halign: 'center' } },
            { content: 'CICESCT', colSpan: 4 }, { content: this.solicitud.gruposEspeciales.includes('CICESCT') ? 'X' : '', colSpan: 4, styles: { halign: 'center' } },
          ],
          [
            { content: 'Ayuda Solidaria', colSpan: 4 }, { content: this.solicitud.gruposEspeciales.includes('Ayuda Solidaria') ? 'X' : '', colSpan: 4, styles: { halign: 'center' } },
            { content: 'Credi-Taxi', colSpan: 4 }, { content: this.solicitud.gruposEspeciales.includes('Credi-Taxi') ? 'X' : '', colSpan: 4, styles: { halign: 'center' } },
          ],
          [
            { content: 'Credi-Salón', colSpan: 4 }, { content: this.solicitud.gruposEspeciales.includes('Credi-Salón') ? 'X' : '', colSpan: 4, styles: { halign: 'center' } },
            { content: 'Credi-Babería', colSpan: 4 }, { content: this.solicitud.gruposEspeciales.includes('Credi-Babería') ? 'X' : '', colSpan: 4, styles: { halign: 'center' } },
          ],
          [
            { content: 'Credi-Pulpería', colSpan: 4 }, { content: this.solicitud.gruposEspeciales.includes('Credi-Pulpería') ? 'X' : '', colSpan: 4, styles: { halign: 'center' } },
            { content: 'Senaeh', colSpan: 4 }, { content: this.solicitud.gruposEspeciales.includes('Senaeh') ? 'X' : '', colSpan: 4, styles: { halign: 'center' } },
          ],
          [
            { content: 'Ciudad Mujer', colSpan: 4 }, { content: this.solicitud.gruposEspeciales.includes('Ciudad Mujer') ? 'X' : '', colSpan: 4, styles: { halign: 'center' } },
            { content: 'Asonapvsidah', colSpan: 4 }, { content: this.solicitud.gruposEspeciales.includes('Asonapvsidah') ? 'X' : '', colSpan: 4, styles: { halign: 'center' } },
          ]
          // Add more rows here...
        ],
        startY: 125,
        headStyles: { fillColor: [41, 128, 185], halign: 'center' },
        theme: 'grid',

        columnStyle: {
          0: { halign: 'left' },
          4: { halifn: 'center' },
          8: { halign: 'left' },
          12: { halifn: 'center' },
        }
      })

      doc.addPage()

      doc.text(`NOSOTROS, los bajo firmantes constituidos en el Grupo Solidario:   ${this.solicitud.nombreGrupoSolidario}`, 15, 35)
      doc.text('_____________________________________', 122, 35);
      doc.text(`Hemos designado a: ${this.obtenerCoordinador()}`, 15, 45)
      doc.text('_____________________________________', 47, 45);
      doc.text('como cordinador del Grupo Solidario, asímismo, garantizamos solidariamente los compromisos atraidos.', 15, 55)

      this.gruposSolidariosArray = [
        {
          nombre: this.nomInt1,
          monto: (this.nomInt1 ? (this.formatoNumero(this.solicitud.integrantesGruposSolidario.monto1) + " lps") : "0 lps"),
          cuota: this.solicitud.integrantesGruposSolidario.cuota1 + " lps",
        },
        {
          nombre: this.nomInt2,
          monto: (this.nomInt2 ? (this.formatoNumero(this.solicitud.integrantesGruposSolidario.monto2) + " lps") : "0 lps"),
          cuota: this.solicitud.integrantesGruposSolidario.cuota2 + " lps",
        },
        {
          nombre: this.nomInt3,
          monto: (this.nomInt3 ? (this.formatoNumero(this.solicitud.integrantesGruposSolidario.monto3) + " lps") : "0 lps"),
          cuota: this.solicitud.integrantesGruposSolidario.cuota3 + " lps",
        },
        {
          nombre: this.nomInt4,
          monto: (this.nomInt4 ? (this.formatoNumero(this.solicitud.integrantesGruposSolidario.monto4) + " lps") : "0 lps"),
          cuota: this.solicitud.integrantesGruposSolidario.cuota4 + " lps",
        },
        {
          nombre: this.nomInt5,
          monto: (this.nomInt5 ? (this.formatoNumero(this.solicitud.integrantesGruposSolidario.monto5) + " lps") : "0 lps"),
          cuota: this.solicitud.integrantesGruposSolidario.cuota5 + " lps",
        }
      ];

      doc.autoTable({
        head: [['No.', 'Nombre Completo', 'Monto', 'Valor Cuota', 'Firma']],
        body:
          this.gruposSolidariosArray.map((integrante, index) => {
            return ([{ content: `${index + 1}`, colSpan: 1 },
            { content: integrante.nombre, colSpan: 1 },
            { content: integrante.monto, colSpan: 1 },
            { content: integrante.cuota, colSpan: 1 },
            { content: '', colSpan: 1 }]
            )
          })
        ,
        startY: 60,
        headStyles: { fillColor: [41, 128, 185], halign: 'center' },
        theme: 'grid',
        styles: {
          halign: 'center',
        },
      })

      doc.setFontSize(12)
      doc.setFont('helvetica', 'bold');

      doc.text('LÍNEA BASE: EVALUACIÓN DE CALIDAD Y CONDICIONES DE VIDA', 15, 115)
      doc.setFont('helvetica', 'normal');

      doc.setFontSize(11)
      doc.text('Información sobre la vivienda.', 15, 123)



      doc.autoTable({
        body: [
          [
            { content: `Material que predomina en vivienda: ${this.solicitud.materialVivienda}`, colSpan: 6 },
            { content: `Tiempo de vivir en la vivienda: ${this.solicitud.tiempoVivienda}`, colSpan: 6 },
          ],
          // [
          //   {
          //     content: `Marque con una x los servicios públicos que tiene en su vivienda: 
          //     \n\n energia electrica ( ${this.solicitud.serviciosPublico.includes('energia electrica') ? 'X' : ' '} )   red de agua potable ( ${this.solicitud.serviciosPublico.includes('red de agua potable') ? 'X' : ' '} )   red de aguas negras ( ${this.solicitud.serviciosPublico.includes('red de aguas negras') ? 'X' : ' '} )   pozo septico ( ${this.solicitud.serviciosPublico.includes('pozo septico') ? 'X' : ' '} )   telefono fijo ( ${this.solicitud.serviciosPublico.includes('telefono fijo') ? 'X' : ' '} )
          //     `, colSpan: 12
          //   },
          // ],
          // [
          //   { content: `No. de personas que viven en la vivienda: ${this.solicitud.noPersonasVivivenda} \n`, colSpan: 6 },
          //   { content: `No. de familias que viven en la vivienda: ${this.solicitud.noFamilias}\n`, colSpan: 6 },
          // ],
          // [
          //   { content: `No. de personas que trabajan en la vivienda: ${this.solicitud.noTrabajan} \n`, colSpan: 6 },
          //   { content: `No. de dependientes económicos: ${this.solicitud.noDependientes} \n`, colSpan: 6 },
          // ],
          // [
          //   { content: `No. de personas que buscan empleo: ${this.solicitud.noBuscanEmpleo} \n`, colSpan: 12 },
          // ],
        ],
        startY: 126,
        theme: 'plain',
        styles: {
          halign: 'left',
        },
        didDrawPage: function (data) {
          // Guardar la altura de la tabla
          tableHeight = data.cursor.y;
        }
      })
      tableHeight += 8
      doc.setFont('helvetica', 'bold');

      doc.text('Marque con una x los servicios públicos que tiene en su vivienda: ', 15, tableHeight)
      doc.setFont('helvetica', 'normal');

      tableHeight += 6
      doc.setFontSize(10)


      doc.text(`Energia electrica ( ${this.solicitud.serviciosPublico.includes('energia electrica') ? 'X' : ' '} )   Red de agua potable ( ${this.solicitud.serviciosPublico.includes('red de agua potable') ? 'X' : ' '} )   Red de aguas negras ( ${this.solicitud.serviciosPublico.includes('red de aguas negras') ? 'X' : ' '} )   Pozo septico ( ${this.solicitud.serviciosPublico.includes('pozo septico') ? 'X' : ' '} )   telefono fijo ( ${this.solicitud.serviciosPublico.includes('telefono fijo') ? 'X' : ' '} )`, 15, tableHeight)


      tableHeight += 8

      doc.text(`No. de personas que viven en la vivienda: ${this.solicitud.noPersonasVivivenda}`, 15, tableHeight)
      doc.text(`No. de familias que viven en la vivienda: ${this.solicitud.noFamilias}`, 110, tableHeight)
      tableHeight += 8
      doc.text(`No. de personas que trabajan en la vivienda: ${this.solicitud.noTrabajan}`, 15, tableHeight)
      doc.text(`No. de dependientes económicos: ${this.solicitud.noDependientes} `, 110, tableHeight)
      tableHeight += 8
      doc.text(`No. de personas que buscan empleo: ${this.solicitud.noBuscanEmpleo} `, 15, tableHeight)




      doc.text('_____________________________________', 65, 195);
      doc.autoTable({
        body: [
          [
            { content: '(f) Solicitante (Firma o Huella)', colSpan: 6 },
          ],
          [
            { content: 'Nosotros los abajo firmantes damos fé de haber validado en campo la información brindada por el solicitante, el cual es verídica.', colSpan: 6 },
          ]
        ],
        startY: 197,
        theme: 'plain',
        styles: {
          halign: 'center',
        },
      })

      if(tipoExportar === 'FIRMA'){
  // Coordenadas donde debe firmar el asesor:
        doc.setFontSize(30)

doc.text('{{FirmaAsesor_es_:signer1:signature}}', 35, 225);
// Fecha de firma:
doc.setFontSize(11)
doc.text('{{FechaAsesor_es_:signer1:date}}', 29, 243);
    }
      

      doc.text('_________________________________', 25, 230);
      doc.text('_________________________________', 115, 230);
      doc.autoTable({
        body: [
          [
            { content: 'Oficial de Microcrédito', colSpan: 6 },
            { content: 'Jefe Departamental', colSpan: 6 },
          ]
        ],
        startY: 232,
        theme: 'plain',
        styles: {
          halign: 'center',
        },
      })



      doc.text('__________________', 27, 262);
      doc.text('____________', 40, 270);
      doc.text('____________', 101, 270);
      doc.setFont('helvetica', 'bold');

      doc.text('CONDICIONES DEL CRÉDITO', 15, 255)
      doc.setFont('helvetica', 'normal');

      doc.autoTable({
        body: [
          [
            { content: `Monto:           ${this.solicitud.monto}`, colSpan: 6 },
          ],
          [
            { content: `Plazo de Pago:            ${this.solicitud.plazoPago}              Frecuencia de Pago:     ${this.solicitud.frecuenciaPago}`, colSpan: 6 }
          ]
        ],
        startY: 257,
        theme: 'plain',
        styles: {
          halign: 'left',
        },
      })





  //   if (tipoExportar === 'FIRMA') {
  //     // 1) Genera el PDF como Blob
  //       const blob = doc.output('blob'); // <- en lugar de save()

  //       // 2) Enviar al backend
  //       const form = new FormData();
  //       form.append('file', blob, 'Solicitud.pdf');
  //       form.append('signer_email', "andres15mol@gmail.com"); // correo del asesor
  //       form.append('sender_email', "andres15mol@gmail.com"); 
  //       form.append('name', `Solicitud ${this.solicitud?.codigo || ''}`);
        
  //       const headers = new Headers();
  //       headers.append("Authorization", "Bearer " + this.store.token);
        
  //       const res = await fetch(`${process.env.VUE_APP_API_URL}/admin/init-sign-process`, { method: 'POST', body: form, headers: headers });
  //       const { signing_url } = await res.json();

  // console.log(signing_url);
  //       // 3) Mostrar la firma embebida (iframe o nueva pestaña)
  //       window.open(signing_url, '_blank'); // o bien: <iframe :src="signing_url">

  //   }else{
  //     doc.save('Solicitud.pdf')

  //   }
if (tipoExportar === 'FIRMA') {
  // 1) Genera el PDF como Blob
  const blob = doc.output('blob'); // application/pdf

  // 2) Arma el form-data (NO pongas Content-Type)
  const form = new FormData();
  form.append('file', blob, 'Solicitud.pdf');
  form.append('signer_email', "andres15mol@gmai.com");                // quien firma
  form.append('sender_email', "andres15mol@gmai.com");                // remitente (en DEV: mismo del Integration Key)
  form.append('name', `Solicitud ${this.solicitud?.codigo || ''}`);

  // 3) Enviar al backend
  const res = await fetch(`${process.env.VUE_APP_API_URL}/admin/init-sign-process`, {
    method: 'POST',
    body: form,
    headers: {
      Authorization: `Bearer ${this.store.token}` // si tu backend lo requiere
    },
    // credentials: 'include', // usa esto si tu backend autentica con cookie/sesión
  });

  if (!res.ok) {
    // imprime el texto de error del backend para depurar
    const errText = await res.text();
    console.error('InitSignProcess error:', errText);
    this.$toast?.error?.('No se pudo iniciar la firma');
    return;
  }

  const { signing_url } = await res.json();
  if (!signing_url) {
    console.error('Respuesta sin signing_url');
    this.$toast?.error?.('No se obtuvo el enlace de firma');
    return;
  }

  // 4) Abrir la firma (embebida o pestaña nueva)
  window.open(signing_url, '_blank'); // o <iframe :src="signing_url">
} else {
  doc.save('Solicitud.pdf');
}


    }
    ,
      // =========================
  // HELPERS (como la 2da función)
  // =========================
  _pdfAddHeader(doc) {
    const img = new Image();
    doc.addImage(
      (img.src = require("@/assets/header.png")), // o header.png
      "png",
      0,
      0,
      doc.internal.pageSize.width,
      30
    );
  },

  _pdfAddFooter(doc, footerText) {
    doc.setFont("helvetica", "normal");
    doc.setFontSize(8);
    doc.text(footerText, 108, 260, {
      maxWidth: 180,
      align: "center",
      lineHeight: 2.5,
      fontWeight: "bold",
    });
    doc.setFontSize(11);
  },

  _pdfEnsureSpace(doc, y, needed, footerY = 265) {
    if (y + needed >= footerY) {
      doc.addPage();
      return 35; // arranca debajo del header
    }
    return y;
  },

  _pdfWriteJustified(doc, text, x, y, maxWidth, extraSpaceAfter = 0) {
    doc.text(text, x, y, { maxWidth, align: "justify" });
    const dim = doc.getTextDimensions(text, { maxWidth });
    return y + dim.h + extraSpaceAfter;
  },

  // =========================
  // FUNCIÓN PRINCIPAL (misma estética que exportacionFianza)
  // =========================
  async exportarNotificacionCambioTasaPDF(payload, tipoExportar = "DESCARGAR") {
    const doc = new jsPDF("p", "mm", "letter");

    // estilo base igual a exportacionFianza
    doc.lineHeightProportion = 2;
    doc.setFont("helvetica", "normal");
    doc.setFontSize(10);
    doc.setLineHeightFactor(1.7);

    // header
    this._pdfAddHeader(doc);

    const safe = (v, fb = "") =>
      v === null || v === undefined ? fb : String(v);

    const footer = `Col. Rubén Darío, Casa 0592 Tegucigalpa, Honduras
RTN:08269016867779
Email: info@ahdecohn.org
Telefono:2242-5780
`;

    // márgenes tipo 2da función
    let y = 35;
    const margenIzq = 25;
    const anchoParrafo = 163;

    // Depto + Fecha
    doc.setFont("helvetica", "bold");
    y = this._pdfEnsureSpace(doc, y, 10);
    doc.text(safe(payload.departamento, "Departamento de ________"), margenIzq, y);
    y += 7;

    doc.setFont("helvetica", "normal");
    y = this._pdfEnsureSpace(doc, y, 10);
    doc.text(safe(payload.fecha, "___ de ______ de ____"), margenIzq, y);
    y += 14;

    // Saludo
    y = this._pdfEnsureSpace(doc, y, 10);
    doc.text(safe(payload.destinatario, "Estimado(a) Señor(a):"), margenIzq, y);
    y += 12;

    // Párrafo 1
    const p1 =
      `En el marco del Convenio vigente suscrito con el ${safe(payload.ppcs, "Programa Presidencial Crédito Solidario (PPCS)")}, ` +
      `me dirijo a usted en representación de la ${safe(payload.institucion, "Asociación Hondureña para el Desarrollo Integral Comunitario (AHDECO)")}, ` +
      `con el objeto de notificar formalmente la modificación de la tasa de interés moratorio aplicable a su préstamo, ` +
      `la cual entrará en vigor a partir del ${safe(payload.fechaVigencia, "____ de ______ de ____")}.`;

    y = this._pdfEnsureSpace(doc, y, 35);
    y = this._pdfWriteJustified(doc, p1, margenIzq, y, anchoParrafo, 6);

    // Párrafo 2
    const p2 =
      `Dicha modificación responde a las condiciones actuales del mercado crediticio y se fundamenta en la cláusula séptima del Contrato de Préstamo ` +
      `que usted suscribió, la cual establece textualmente: «${safe(payload.clausulaTexto, "")}».`;

    y = this._pdfEnsureSpace(doc, y, 35);
    y = this._pdfWriteJustified(doc, p2, margenIzq, y, anchoParrafo, 6);

    // En consecuencia...
    y = this._pdfEnsureSpace(doc, y, 10);
    doc.text(
      "En consecuencia, la tasa de interés moratorio se ajustará de la siguiente manera:",
      margenIzq,
      y
    );
    y += 8;

    // Viñetas
    const b1 = `• Los créditos con mora menor a 30 días, mantendrán una tasa del ${safe(payload.tasaMenor30, "2% anual")}.`;
    const b2 =
      `• Los créditos con mora mayor o igual a 30 días, se ajustará a una tasa de morosidad del ${safe(payload.tasaMayorIgual30, "1% mensual o 12% anual")} ` +
      `sobre los saldos vencidos e impagos a partir de la fecha indicada.`;

    y = this._pdfEnsureSpace(doc, y, 25);
    y = this._pdfWriteJustified(doc, b1, margenIzq, y, anchoParrafo, 2);

    y = this._pdfEnsureSpace(doc, y, 35);
    y = this._pdfWriteJustified(doc, b2, margenIzq, y, anchoParrafo, 8);

    // Párrafo mora
    const p3 =
      "Cabe señalar que, a la fecha, su cuenta registra incumplimiento en los pagos pactados, por lo que el nuevo porcentaje " +
      "será aplicable una vez producida la mora.";

    y = this._pdfEnsureSpace(doc, y, 25);
    y = this._pdfWriteJustified(doc, p3, margenIzq, y, anchoParrafo, 8);

    // Invitación
    const p4 =
      "Con el propósito de facilitar una solución viable, le invitamos a presentarse en nuestras oficinas a fin de concertar " +
      "un plan de pago razonable y documentado. Para coordinar una cita, puede comunicarse con su asesor de crédito:";

    y = this._pdfEnsureSpace(doc, y, 30);
    y = this._pdfWriteJustified(doc, p4, margenIzq, y, anchoParrafo, 10);

    // Campos asesor
    y = this._pdfEnsureSpace(doc, y-5, 20);
    doc.text("Nombre del asesor: _________________________________________", margenIzq, y);
    if (safe(payload.asesorNombre).trim()) doc.text(safe(payload.asesorNombre), margenIzq + 40, y);
    y += 10;

    y = this._pdfEnsureSpace(doc, y, 20);
    doc.text("Teléfono: _________________________________________", margenIzq, y);
    if (safe(payload.asesorTelefono).trim()) doc.text(safe(payload.asesorTelefono), margenIzq + 18, y);
    y += 9;

    // Párrafo final
    const p5 =
      "Sin otro particular por el momento, y en el ánimo de agotar la vía conciliatoria antes de proceder con acciones legales, " +
      "le exhortamos a regularizar su situación crediticia a la brevedad, evitando así el agravamiento de su deuda por concepto " +
      "de intereses moratorios y posibles consecuencias jurídicas.";

    y = this._pdfEnsureSpace(doc, y, 40);
    y = this._pdfWriteJustified(doc, p5, margenIzq, y, anchoParrafo, 12);

    // Firma
    y = this._pdfEnsureSpace(doc, y, 30);
    doc.text("Atentamente,", margenIzq, y-8);
    y += 3;

   const pageWidth = doc.internal.pageSize.getWidth();
const centerX = pageWidth / 2;

doc.setFont("helvetica", "bold");
doc.text(safe(payload.firmanteNombre, ""), centerX, y, { align: "center" });
y += 4;

doc.setFont("helvetica", "normal");
doc.text(safe(payload.firmanteCargo1, ""), centerX, y, { align: "center" });
y += 4;

doc.text(safe(payload.firmanteCargo2, ""), centerX, y, { align: "center" });
y += 4;

doc.text(safe(payload.firmanteCargo3, ""), centerX, y, { align: "center" });
y += 4;

    // Footer (siempre)
    this._pdfAddFooter(doc, footer);

    // Export (igual lógica tuya)
    if (tipoExportar === "FIRMA") {
      const blob = doc.output("blob");
      const form = new FormData();
      form.append("file", blob, "NotificacionCambioTasa.pdf");
      form.append("name", "Notificación cambio de tasa");
      form.append("signer_email", safe(payload.signerEmail, ""));
      form.append("sender_email", safe(payload.senderEmail, ""));

      const res = await fetch(`${process.env.VUE_APP_API_URL}/admin/init-sign-process`, {
        method: "POST",
        body: form,
        headers: { Authorization: `Bearer ${this.store.token}` },
      });

      if (!res.ok) {
        const errText = await res.text();
        console.error("InitSignProcess error:", errText);
        this.$toast?.error?.("No se pudo iniciar la firma");
        return;
      }

      const { signing_url } = await res.json();
      if (!signing_url) {
        this.$toast?.error?.("No se obtuvo el enlace de firma");
        return;
      }

      window.open(signing_url, "_blank");
    } else {
      doc.save("NotificacionCambioTasa.pdf");
    }
  },
 

/**
 * Escribe un párrafo con salto de línea automático y devuelve el nuevo "y".
 * (Ponela como método dentro de tu componente para reutilizarla)
 */
_pdfWriteParagraph(doc, text, x, y, maxWidth, lineHeight = 6) {
  const lines = doc.splitTextToSize(text, maxWidth);
  doc.text(lines, x, y);
  return y + lines.length * lineHeight;
},



    //Convertir string a minuscula y sin espacios
    limpiarYMinusc(string) {
      // Eliminar espacios en blanco y convertir a minúsculas
      return string.replace(/\s/g, '').toLowerCase();
    },
    //Convertir numero negativo a 0
    convertirANoNegativo(numero) {
      // Si el número es negativo, convertirlo a cero
      if (numero < 0) {
        return 0;
      } else {
        return numero;
      }
    },

    generarPlanPago(
      fechaApertura,
      monto,
      periodoPago,
      interesAnual,
      plazo,
      pagosInteres,
    ) {

      this.sumaTotalesCero();

      console.log(fechaApertura)
      let fechaInicial = fechaApertura
      // Calcular la tasa de interés mensual
      let tasaAnual = interesAnual / 100;

      // Calcular el intervalo de tiempo entre pagos
      let duracionPago, periodo, noCuotas, interes, diasPeriodo, capital, saldo;

      // Imprimir la cabecera de la tabla

      // Generar el plan de pago
      saldo = monto;


      switch (this.limpiarYMinusc(periodoPago)) {
        case "mensual":
          duracionPago = 30 * 24 * 60 * 60 * 1000;
          fechaApertura = new Date(
            fechaApertura.getTime() + 30 * 24 * 60 * 60 * 1000
          );
          noCuotas = plazo;
          periodo = 12;
          diasPeriodo = 30.0;
          break;

        case "quincenal":
          duracionPago = 14 * 24 * 60 * 60 * 1000;
          fechaApertura = new Date(
            fechaApertura.getTime() + 15 * 24 * 60 * 60 * 1000
          );
          noCuotas = plazo * 2;
          periodo = 24;
          diasPeriodo = 15.0;
          break;

        case "semanal":

          duracionPago = 7 * 24 * 60 * 60 * 1000;
          fechaApertura = new Date(
            fechaApertura.getTime() + 7 * 24 * 60 * 60 * 1000
          );

          if (this.esCrediTrabajo(this.solicitudCompleta.producto)) {
            noCuotas = plazo * 4;
          } else {
            noCuotas = plazo * (4.3333333333);
          }

          periodo = 52.1;
          diasPeriodo = 7.0;
          break;

        case "alvencimiento":
          duracionPago = 1;
          fechaApertura = new Date(
            fechaApertura.getTime() + (plazo * 30) * 24 * 60 * 60 * 1000
          );
          noCuotas = 1;
          periodo = (30 / (plazo * 30)) * 12;
          diasPeriodo = plazo * 30;
          break;
        case "trimestral":
          duracionPago = 90 * 24 * 60 * 60 * 1000;
          fechaApertura = new Date(
            fechaApertura.getTime() + 90 * 24 * 60 * 60 * 1000
          );
          noCuotas = plazo / 3;
          periodo = 4;
          diasPeriodo = 90.0;
          break;
        case "semestral":
          duracionPago = 180 * 24 * 60 * 60 * 1000;
          fechaApertura = new Date(
            fechaApertura.getTime() + 180 * 24 * 60 * 60 * 1000
          );
          noCuotas = plazo / 6;
          periodo = 2;
          diasPeriodo = 180.0;
          break;
        case "anual":
          duracionPago = 360 * 24 * 60 * 60 * 1000;
          fechaApertura = new Date(
            fechaApertura.getTime() + 360 * 24 * 60 * 60 * 1000
          );
          noCuotas = plazo / 12;
          periodo = 1;
          diasPeriodo = 360.0;
          break;



        default:
          return;
      }

      // Generar el plan de pago
      let cuotaTotal

      if (this.creaFuturo() && this.limpiarYMinusc(periodoPago) !== "semanal") {
        cuotaTotal = this.CalcularCuotaInteresCompuesto(
          monto,
          tasaAnual,
          Math.round(noCuotas),
          periodo,
          diasPeriodo
        );
      } else {
        cuotaTotal = this.CalculaCuotaNivelada(
          monto,
          tasaAnual,
          plazo,
          periodo,
          diasPeriodo
        );
      }
      this.planPagoToPrint = []
      const tablaBody = document.getElementById('tablaPlanPagos')
      tablaBody.innerHTML = ''
      tablaBody.innerHTML = `
        <tr>
          <th class="text-center align-middle" scope="row">0</td>
          <td class="text-center align-middle">${this.dateFormat(fechaInicial.toISOString().slice(0, 10))}</td>
          <td class="text-center align-middle"></td>
          <td class="text-center align-middle"></td>
          <td class="text-center align-middle"></td>
          <td class="text-center align-middle">${this.formatoNumero(saldo)} ${this.moneda}</td>
        </tr>
      `
      this.planPagoToPrint.push({
        noCuota: 0,
        fechaPago: this.dateFormat(fechaInicial.toISOString().slice(0, 10)),
        cuotaTotal: '',
        interes: '',
        capital: '',
        saldo: saldo.toFixed(2) + " " + this.moneda
      })
      
      if (this.solicitudCompleta.producto !== 'Credi Trabajo' && this.solicitudCompleta.producto !== 'Credi Trabajo 2') {
        this.cuotaSolicitud = cuotaTotal
        console.log("La Cuota es: ", this.cuotaSolicitud);

        console.log(diasPeriodo, "Dias del periodo");

        let contador = 0
        for (let i = 1; i <= Math.round(noCuotas); i++) {



          if (this.creaFuturo() && this.limpiarYMinusc(periodoPago) !== "semanal") {
            interes = saldo * (tasaAnual / 12)
          } else {
            interes = ((saldo * tasaAnual) / 360) * diasPeriodo;
          }
          capital = cuotaTotal - interes;
          saldo = saldo - capital;
          saldo = this.convertirANoNegativo(saldo)
          // Imprimir la fila de la tabla
          tablaBody.innerHTML += `
          <tr>
            <th class="text-center align-middle" scope="row">${i}</th>
            <td class="text-center align-middle">${this.dateFormat(fechaApertura.toISOString().slice(0, 10))}</td>
            <td class="text-center align-middle">${Number(cuotaTotal).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ${this.moneda}</td>
            <td class="text-center align-middle">${Number(interes).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ${this.moneda}</td>
            <td class="text-center align-middle">${Number(capital).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ${this.moneda}</td>
            <td class="text-center align-middle">${Number(saldo).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ${this.moneda}</td>
            </tr>
          `


          // console.log("Pagos de Interes O.o", pagosInteres[i]);
          // console.log("Pagos de Interes O.o", this.buscarPagosEntreFechas(pagosInteres, fechaApertura, new Date(fechaApertura.getTime() + duracionPago)));

          if (contador < this.pagosInteres.length) {

            if (new Date(this.pagosInteres[contador].fecha) >= fechaApertura && new Date(this.pagosInteres[contador].fecha) <= new Date(fechaApertura.getTime() + duracionPago)) {
              console.log("Pagos de Interes O.o", this.pagosInteres[contador]);

              tablaBody.innerHTML += `
          <tr>
            <th class="text-center align-middle" scope="row">${i}</th>
            <td class="text-center align-middle">${this.dateFormat(pagosInteres[contador].fecha)}</td>
            <td class="text-center align-middle"></td>
            <td class="text-center align-middle">${Number(pagosInteres[contador].monto).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ${this.moneda}</td>
            <td class="text-center align-middle"></td>
            <td class="text-center align-middle"></td>
            <td class="text-center align-middle"></td>
            </tr>
          `
              contador++

            }
          }

          console.log("fecha plan Pago: ", fechaApertura);
          console.log("fecha plan Pago proxima: ", new Date(fechaApertura.getTime() + duracionPago));


          this.planPagoToPrint.push({
            noCuota: i,
            fechaPago: this.dateFormat(fechaApertura.toISOString().slice(0, 10)),
            cuotaTotal: Number(cuotaTotal).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " " + this.moneda,
            interes: Number(interes).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " " + this.moneda,
            capital: Number(capital).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " " + this.moneda,
            saldo: Number(saldo).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " " + this.moneda
          })
          this.fechaVencimiento = fechaApertura
          fechaApertura = new Date(fechaApertura.getTime() + duracionPago);



        }
      } else {
        //Creditrabajo
        if (this.creditrabajo2) {
          noCuotas = Math.round(noCuotas)
        }

        console.log("El numero de Cuotas es: ", noCuotas);
        cuotaTotal = monto / noCuotas;
        this.cuotaSolicitud = cuotaTotal
        console.log("La Cuota es: ", this.cuotaSolicitud);
        for (let i = 1; i <= Math.round(noCuotas); i++) {
          interes = ((saldo * tasaAnual) / 360) * diasPeriodo;
          capital = cuotaTotal;
          saldo = this.convertirANoNegativo(saldo - capital);
          // Imprimir la fila de la tabla
          tablaBody.innerHTML += `
          <tr>
            <th class="text-center align-middle" scope="row">${i}</th>
            <td class="text-center align-middle">${this.dateFormat(fechaApertura.toISOString().slice(0, 10))}</td>
            <td class="text-center align-middle">${cuotaTotal.toFixed(2)} ${this.moneda}</td>
            <td class="text-center align-middle"></td>
            <td class="text-center align-middle">${capital.toFixed(2)} ${this.moneda}</td>
            <td class="text-center align-middle">${Number(saldo).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ${this.moneda}</td>
            </tr>
            `
          this.planPagoToPrint.push({
            noCuota: i,
            fechaPago: this.dateFormat(fechaApertura.toISOString().slice(0, 10)),
            cuotaTotal: Number(cuotaTotal).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " " + this.moneda,
            interes: '',
            capital: Number(capital).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " " + this.moneda,
            saldo: Number(saldo).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " " + this.moneda
          })
          this.fechaVencimiento = fechaApertura
          fechaApertura = new Date(fechaApertura.getTime() + duracionPago);


          this.SumaCuotaTotal += cuotaTotal
          this.SumaInteres += interes
          this.SumaCapital += capital
          this.SumaSaldo += saldo
        }
      }

      tablaBody.innerHTML += `
          <tr class="table-success">
            <th class="text-center align-middle" scope="row"></th>
            <td class="text-center align-middle"> <strong> Total </strong></td>
            <td class="text-center align-middle"><strong>${Number(this.SumaCuotaTotal).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ${this.moneda}</strong></td>
            <td class="text-center align-middle"><strong>${Number(this.SumaInteres).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ${this.moneda}</strong></td>
            <td class="text-center align-middle"><strong>${Number(this.SumaCapital).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ${this.moneda}</strong></td>
            <td class="text-center align-middle"><strong></strong></td>
            </tr>
          `

      this.planPagoToPrint.push({
        noCuota: 0,
        fechaPago: this.dateFormat(fechaApertura.toISOString().slice(0, 10)),
        cuotaTotal: Number(cuotaTotal).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " " + this.moneda,
        interes: Number(interes).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " " + this.moneda,
        capital: Number(capital).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " " + this.moneda,
        saldo: Number(saldo).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " " + this.moneda
      })
    }
    ,
    esCrediTrabajo(producto) {
      // Convertir producto a minúsculas para normalizar
      producto = producto.trim().toLowerCase();

      // Lista de valores normalizados
      const creditrabajo = [
        "creditrabajo",
        "credi trabajo",
        "credi trabajo ",
        "credi trabajo",
        "Credi Trabajo",
        "creditrabajo ",
        "creditrabajo ",
        "credi trabajo",
        "creditrabajo",
      ];

      // Verificar si el producto está en la lista de valores normalizados
      return creditrabajo.includes(producto);
    },
    sumaTotalesCero() {
      this.SumaCuotaTotal = 0
      this.SumaInteres = 0
      this.SumaCapital = 0
      this.SumaSaldo = 0
    },

    // CalculaCuotaNivelada calcula la cuota nivelada de un préstamo
    CalculaCuotaNivelada(
      montoPrestamo,
      tasaInteres,
      periodos,
      periodo,
      diasPeriodo
    ) {
      if (periodo === 24) {
        periodos *= 2;
      } else if (periodo === 52.1) {
        periodos *= 4.33;
        periodos = Math.round(periodos);
      } else if (periodo === (30 / (periodos * 30)) * 12) {
        periodos = 1
      } else if (periodo === 4) {
        periodos /= 3;
        // periodos = Math.round(periodos);
      } else if (periodo === 2) {
        periodos /= 6;
        // periodos = Math.round(periodos);
      } else if (periodo === 1) {
        periodos /= 12;
        // periodos = Math.round(periodos);
      }

      let tasaMensual = (tasaInteres / 360) * diasPeriodo;
      tasaMensual = Math.round(tasaMensual * 10000000000) / 10000000000;

      let cuota =
        (montoPrestamo * tasaMensual) / (1 - Math.pow(1 + tasaMensual, -periodos));
      return cuota;
    },
    // CalculaCuotaNivelada calcula la cuota nivelada de un préstamo
    CalcularCuotaInteresCompuesto(
      montoPrestamo,
      tasaInteres,
      periodos,
      periodo,
      diasPeriodo
    ) {

      console.log("periodos: ", periodos, "periodo: ", periodo, " diasPeriod: ", diasPeriodo);
      console.log("montoPrestamo: ", montoPrestamo, "tasaInteres: ", tasaInteres);
      let cuota = (montoPrestamo * tasaInteres / 12) / (1 - Math.pow(1 + tasaInteres / 12, -periodos));
      return cuota;
    },

    stringToDate(dateString) {
      // Cadena con formato mm/dd/yyyy
      // Diseño que coincide con el formato de la cadena
      let date = new Date(dateString.split("/").reverse().join("-"));
      return date;
    },

    //Enviar Datos
    submitHandler() {
      //
      const esEdicion = this.esEdicionSolicitudActual();

      if(!this.store.aprobacion.validacion ){
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Debe aprobar la validación de datos antes de continuar.',
        });
        return;
      }

      if(!this.validarPagosInteres && this.arregloPagoIntereses){
        
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'Debe agregar al menos un pago de interés.',
          });
          return;
        
      }

      if (!esEdicion) {
        this.solicitudCompleta.integranteSolicitud++;
      }

      this.solicitud.montoDesembolsar = parseFloat(this.montoDesembolsar)

      if (!esEdicion && this.solicitudCompleta.solicitudesObject.length >= this.solicitudCompleta.integranteSolicitud)  {
        //Se aumenta el no de integrante que se encuentra por segunda vez

        this.solicitud = this.restaurarSolicitud()
        this.cliente = this.solicitudCompleta.integrantes[this.solicitudCompleta.integranteSolicitud];

      } else {

        //Se aumenta el no de integrante que se encuentra por segunda vez
        // this.solicitudCompleta.integranteSolicitud++;
        //Agregamos El producto a la solicitud
        this.solicitud.producto = this.solicitudCompleta.producto
        //Agregamos el Id del cliente a la solicitud
        this.solicitud.clienteId = this.cliente.id;
        //Agregamos el id del Grupo solidario a la solicitud 
        this.solicitud.idGrupoSolidario = this.solicitudCompleta.idGrupoSolidario
        //Convertimos en Enteros y en Float
        this.solicitud.plazoPago = parseFloat(this.solicitud.plazoPago, 10)
        this.solicitud.monto = parseFloat(this.solicitud.monto, 10)

        this.solicitud.integrantesGruposSolidario.monto1 = parseFloat(this.solicitud.integrantesGruposSolidario.monto1, 10)
        this.solicitud.integrantesGruposSolidario.monto2 = parseFloat(this.solicitud.integrantesGruposSolidario.monto2, 10)
        this.solicitud.integrantesGruposSolidario.monto3 = parseFloat(this.solicitud.integrantesGruposSolidario.monto3, 10)
        this.solicitud.integrantesGruposSolidario.monto4 = parseFloat(this.solicitud.integrantesGruposSolidario.monto4, 10)
        this.solicitud.integrantesGruposSolidario.monto5 = parseFloat(this.solicitud.integrantesGruposSolidario.monto5, 10)
        this.solicitud.integrantesGruposSolidario.cuota1 = parseFloat(this.solicitud.integrantesGruposSolidario.cuota1, 10)
        this.solicitud.integrantesGruposSolidario.cuota2 = parseFloat(this.solicitud.integrantesGruposSolidario.cuota2, 10)
        this.solicitud.integrantesGruposSolidario.cuota3 = parseFloat(this.solicitud.integrantesGruposSolidario.cuota3, 10)
        this.solicitud.integrantesGruposSolidario.cuota4 = parseFloat(this.solicitud.integrantesGruposSolidario.cuota4, 10)
        this.solicitud.integrantesGruposSolidario.cuota5 = parseFloat(this.solicitud.integrantesGruposSolidario.cuota5, 10)
        // this.solicitud.interes = parseInt(this.solicitud.interes, 10)

        this.solicitud.planInversion.val1 = parseFloat(this.solicitud.planInversion.val1, 10)
        this.solicitud.planInversion.val2 = parseFloat(this.solicitud.planInversion.val2, 10)
        this.solicitud.planInversion.val3 = parseFloat(this.solicitud.planInversion.val3, 10)
        this.solicitud.planInversion.val4 = parseFloat(this.solicitud.planInversion.val4, 10)
        this.solicitud.planInversion.val5 = parseFloat(this.solicitud.planInversion.val5, 10)

        this.solicitud.periodoGracia = parseFloat(this.solicitud.periodoGracia, 10)

        for (let i = 0; i < this.solicitud.filas.length; i++) {
          this.solicitud.filas[i].valor = parseFloat(this.solicitud.filas[i].valor);

        }

        for (let i = 0; i < this.pagosInteres.length; i++) {
          this.pagosInteres[i].fecha = this.convertirFechaAISO(this.pagosInteres[i].fecha);
          if (this.solicitud.id > 0) {
            this.pagosInteres[i].solicitudId = this.solicitud.id;
          }
        }
        this.solicitud.pagosInteres = this.pagosInteres
        const referenciasExtraPayload = this.normalizarReferenciasExtra()

        this.solicitud.coordinador = this.solicitudCompleta.coordinador

        //Agrego solicitud a Payload y la solicitud a solicitudes
        let payload = {
          ...this.solicitud,
          referenciasExtra: referenciasExtraPayload,
          idUsuario: Security.getUser()[0].user.id,
        }
        if (!esEdicion) {
          this.solicitudCompleta.solicitudesObject.push(payload)
        }

        ////////////////////////////
        //Si el integrante por el que va es igual total de integrantes del grupo solidario
        if (
          (!esEdicion &&
          this.solicitudCompleta.integranteSolicitud ===
          this.solicitudCompleta.integrantes.length ) 
        ) {
          this.solicitudCompleta.integranteSolicitud--;

          console.log("Datos que se envian", payload);

          Swal.fire({
            title: '¿Estás Seguro de que deseas agregar la solicitud?',
            icon: 'success',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sí, Creala!'
          }).then((result) => {
            if (result.isConfirmed) {

              //Agregar Solicitudes
              this.solicitudCompleta.integranteSolicitud = 0;

              console.log("Tasa Mora ", this.tasaMora);
              fetch(`${process.env.VUE_APP_API_URL}/admin/solicitudes/save`, Security.requestOptions(payload))
                .then((response) => response.json())
                .then((data) => {
                  if (data.error) {
                    this.$emit('error', data.message)
                    Swal.fire({
                      // position: 'top-end',
                      icon: "error",
                      title: data.message,
                      showConfirmButton: false,
                      timer: 1500,
                    });
                  } else {
                    //Agregar id de solicitud
                    solicitudCompleta.solicitudes.push(data.data.id)
                    //Info Correcta
                    Swal.fire({
                      // position: 'top-end',
                      icon: "success",
                      title: "Se ha Guardado Correctamente la Solicitud",
                      showConfirmButton: false,
                      timer: 1500,
                    });
                    this.solicitudCompleta.integrantes = []
                    this.solicitudCompleta.producto = ""
                    this.solicitudCompleta.idGrupoSolidario = 0
                    this.solicitudCompleta.dniIntegrantes = 0
                    this.solicitudCompleta.nombreGrupoSolidario = ""
                    this.solicitudCompleta.integranteSolicitud = 0
                    this.solicitudCompleta.solicitudes = []
                    this.solicitudCompleta.solicitudesObject = []
                    Swal.fire({
                      // position: 'top-end',
                      icon: "success",
                      title: "Se ha terminado de crear solicitud",
                      showConfirmButton: false,
                      timer: 1500,
                    });
                    //Reestablecer Página
                    window.onbeforeunload = null; // Desactiva la confirmación de navegación
                    this.final = true;
                    // router.push("/solicitud");
                    // location.reload();
                    // window.location.href = "/solicitud";


                    if(data.data?.id){
                      router.push("/archivos/"+data.data.id);
                    }else{
                      location.reload()
                    }

                  }
                })
                .catch((error) => {
                  this.$emit('error', error);
                })






            }
          })

          /////////////////////////////////////
          //Else Caso contrario que el numero no sea igual al total de intergrantes
        } else {

          //Se guardan los datos del integrate por el que va segun el index que es integranteSolicitud
          if (!esEdicion) {
            this.cliente = this.solicitudCompleta.integrantes[this.solicitudCompleta.integranteSolicitud];
          }
                  console.log("Datos que se envian", payload);

          //Peticion Fetch
          Swal.fire({
            title: '¿Estás Seguro de que deseas modificar la solicitud?',
            icon: 'success',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Guardar Cambios!'
          }).then((result) => {
            if (result.isConfirmed) {
              fetch(`${process.env.VUE_APP_API_URL}/admin/solicitudes/save`, Security.requestOptions(payload))
                .then((response) => response.json())
                .then((data) => {
                  if (data.error) {
                    //Mensaje Alerta Error
                    Swal.fire({
                      icon: "error",
                      title: data.message,
                      showConfirmButton: false,
                      timer: 1500,
                    });

                  } else {

                    // //Agregar id de solicitud
                    // solicitudCompleta.solicitudes.push(data.data.id)

                    //Alerta de que guardo correctamente
                    Swal.fire({
                      icon: "success",
                      title: "Se ha Guardado Correctamente la Solicitud",
                      showConfirmButton: false,
                      timer: 1500,
                    });

                    console.log(data.data?.id, "ID DE LA SOLICITUD");
                    if(esEdicion){
                      this.sincronizarSolicitudGuardada(data, payload);
                      this.quitarValidacion()
                    }else if(data.data?.id){
                      router.push("/archivos/"+data.data.id);
                    }else{
                      location.reload()
                    }
               

                  }
                })
                .catch((error) => {
                  this.$emit('error', error);
                })

              // if (this.solicitudCompleta.producto !== "Escalonado") {
              //   router.push("/solicitud");

              // }

            } 

            
          })
        }
      }
    },
    FotoBenficiario(dni){
      let payload = {
        dni: dni,
        id: this.$route.params.solicitudId,
      }
      //editing a solicitante
      fetch(
        process.env.VUE_APP_API_URL +
        "/admin/foto-clientes" ,
        Security.requestOptions(payload)
      )
        .then((response) => response.json())
        .then((data) => {
          if (data.error) {
            this.$emit("error", data.message);
          } else {
            // this.Grupo = data.data;
            console.log("Fotos Clientes:", data);  
            this.FotoCliente = data.data.foto_beneficiario;

          }
        });

    },

    //Recibir Datos de Otros componentes
    recibirDatosDelHijo(datos) {
      this.cliente = datos; // Manejar los datos recibidos del hijo
      //No funciona
    },


    //Navegar entre Páginas

    //NextPage: Funcion siguiente pagina NO FUNCIONAL POSIBLE BORRAR
    nextPage() {

      if (this.solicitudCompleta.solicitudes[this.solicitudCompleta.integranteSolicitud]) {
        console.log();
      } else {
        this.submitHandler();
      }
      //Se llama la funcion Submit Handler para subir la solicitud



      //Este es cuando es uno que no sea mipyme
      if (
        this.solicitudCompleta.integrantes.length >
        this.solicitudCompleta.integranteSolicitud + 1
      ) {
        this.solicitudCompleta.integranteSolicitud++;

        //Guardar solicitud de integrante

        //Validar Solicitud
      }
    },
    convertirFechaAISO(fechaStr) {
      const fecha = new Date(fechaStr);
      return fecha.toISOString(); // ejemplo: "2025-06-12T00:00:00.000Z"
    },
    // buscarIntegrantePorDni(dni, integrante) {
    //   if (Array.from(dni).length == 13) {
    //     const dniFormatToFetch = dni.replace(/-/g, "");
    //     fetch(
    //       `${process.env.VUE_APP_API_URL}/admin/clientes/dni/${dniFormatToFetch}`,
    //       Security.requestOptions("")
    //     )
    //       .then((response) => response.json())
    //       .then((data) => {
    //         if (data.error) {
    //           this.$emit("error", data.message);
    //           switch (integrante) {
    //             case 1:
    //               this.nomInt1 = "El Integrante no se encuentra en nuestra base de datos, quita los guiones o agrega al beneficiario"
    //               break;
    //             case 2:
    //               this.nomInt2 = "El Integrante no se encuentra en nuestra base de datos, quita los guiones o agrega al beneficiario"
    //               break;
    //             case 3:
    //               this.nomInt3 = "El Integrante no se encuentra en nuestra base de datos, quita los guiones o agrega al beneficiario"
    //               break;
    //             case 4:
    //               this.nomInt4 = "El Integrante no se encuentra en nuestra base de datos, quita los guiones o agrega al beneficiario"
    //               break;
    //             case 5:
    //               this.nomInt5 = "El Integrante no se encuentra en nuestra base de datos, quita los guiones o agrega al beneficiario"
    //               break;

    //           }
    //         } else {
    //           // this.cliente = data.data;
    //           // this.solicitudCompleta.integrantes.push(data.data)
    //           switch (integrante) {
    //             case 1:
    //               this.nomInt1 = data.data.nombres + (data.data.apellidos ? (" " + data.data.apellidos) : "")
    //               this.solicitud.integrantesGruposSolidario.nombre1 = this.nomInt1
    //               this.solicitud.integrantesGruposSolidario.rtn1 = data.data.rtn
    //               this.solicitud.integrantesGruposSolidario.infoBeneficiario1 = data.data

    //               break;
    //             case 2:
    //               this.nomInt2 = data.data.nombres + (data.data.apellidos ? (" " + data.data.apellidos) : "")
    //               this.solicitud.integrantesGruposSolidario.nombre2 = this.nomInt2
    //               this.solicitud.integrantesGruposSolidario.rtn2 = data.data.rtn
    //               this.solicitud.integrantesGruposSolidario.infoBeneficiario2 = data.data
    //               break;
    //             case 3:
    //               this.nomInt3 = data.data.nombres + (data.data.apellidos ? (" " + data.data.apellidos) : "")
    //               this.solicitud.integrantesGruposSolidario.nombre3 = this.nomInt3
    //               this.solicitud.integrantesGruposSolidario.rtn3 = data.data.rtn
    //               this.solicitud.integrantesGruposSolidario.infoBeneficiario3 = data.data
    //               break;
    //             case 4:
    //               this.nomInt4 = data.data.nombres + (data.data.apellidos ? (" " + data.data.apellidos) : "")
    //               this.solicitud.integrantesGruposSolidario.nombre4 = this.nomInt4
    //               this.solicitud.integrantesGruposSolidario.rtn4 = data.data.rtn
    //               this.solicitud.integrantesGruposSolidario.infoBeneficiario4 = data.data
    //               break;
    //             case 5:
    //               this.nomInt5 = data.data.nombres + (data.data.apellidos ? (" " + data.data.apellidos) : "")
    //               this.solicitud.integrantesGruposSolidario.nombre5 = this.nomInt5
    //               this.solicitud.integrantesGruposSolidario.rtn5 = data.data.rtn
    //               this.solicitud.integrantesGruposSolidario.infoBeneficiario5 = data.data
    //               break;

    //           }


    //           console.log(data.data);
    //           this.$emit("datos-hijo-al-padre", data.data);
    //         }
    //       })
    //       .catch((error) => {
    //         this.$emit("error", error);

    //       });
    //   } else {
    //     // this.cliente = "";
    //     // this.solicitudCompleta.integrantes.pop()
    //     // this.mensajeDni = ""
    //     // dni = document.getElementById('dni');
    //     // dni.classList.remove('is-invalid')
    //     // dni.classList.add('was-validated')
    //   }
    // },
    buscarIntegrantePorDni(dni, integrante) {
  // 1) Coerción segura y validación (13 dígitos sin guiones)
  const dniStr = (dni ?? "").toString().trim();
  const dniSoloDigitos = dniStr.replace(/\D/g, ""); // elimina todo menos dígitos
  if (dniSoloDigitos.length !== 13) return;

  // 2) Asegura la ruta destino
  this.solicitud = this.solicitud || {};
  this.solicitud.integrantesGruposSolidario = this.solicitud.integrantesGruposSolidario || {};

  // 3) Fetch
  fetch(
    `${process.env.VUE_APP_API_URL}/admin/clientes/dni/${dniSoloDigitos}`,
    Security.requestOptions("")
  )
    .then((response) => response.json())
    .then((data) => {
      const ok = data && !data.error && data.data;
      const idx = Number(integrante);

      if (!ok) {
        const msg = "El Integrante no se encuentra en nuestra base de datos, quita los guiones o agrega al beneficiario";
        this[`nomInt${idx}`] = msg;
        this.$emit("error", data?.message ?? "No encontrado");
        return;
      }

      const cli = data.data;
      const nombreCompleto = `${cli?.nombres ?? ""}${cli?.apellidos ? (" " + cli.apellidos) : ""}`.trim();

      // 4) Seteo seguro usando keys dinámicas
      this[`nomInt${idx}`] = nombreCompleto;

      const tgt = this.solicitud.integrantesGruposSolidario;
      tgt[`nombre${idx}`] = nombreCompleto;
      tgt[`rtn${idx}`] = cli?.rtn ?? "";
      tgt[`infoBeneficiario${idx}`] = cli;

      console.log(cli);
      this.$emit("datos-hijo-al-padre", cli);
    })
    .catch((error) => {
      this.$emit("error", error);
    });
},

    previousPage() {

      if (this.solicitudCompleta.integranteSolicitud > 0) {
        //Ir para atras en las solicitudes

        this.solicitudCompleta.integranteSolicitud--;
        this.cliente =
          this.solicitudCompleta.integrantes[
          this.solicitudCompleta.integranteSolicitud
          ];
        this.solicitud =
          this.solicitudCompleta.solicitudesObject[
          this.solicitudCompleta.integranteSolicitud
          ]

        // router.push(`/solicitud/integrante/${this.solicitudCompleta.solicitudes[this.solicitudCompleta.integranteSolicitud].id}`);

      } else if (this.solicitudCompleta.producto !== "Escalonado") {
        router.push("/solicitud");
      } else {
        router.push("/solicitud/grupo-solidario/0");
      }
    },
    buscarPagosEntreFechas(pagos, fechaInicio, fechaFin) {
      const inicio = new Date(fechaInicio);
      const fin = new Date(fechaFin);

      return pagos.filter(pago => {
        const fechaPago = new Date(pago.fecha);
        return fechaPago >= inicio && fechaPago <= fin;
      });
    },
    formatDNI(dni) {
      const cleanedValue = dni.replace(/-/g, "");

      // Aplica el formato con guiones
      let formattedValue = "";
      for (let i = 0; i < cleanedValue.length; i++) {
        if (i === 4 || i === 8) {
          formattedValue += "-";
        }
        formattedValue += cleanedValue[i];
      }

      // Actualiza el valor del input
      return formattedValue;
    },
    formatInput() {
      // Elimina todos los guiones existentes en el valor actual
      const cleanedValue = this.dni.replace(/-/g, "");

      // Aplica el formato con guiones
      let formattedValue = "";
      for (let i = 0; i < cleanedValue.length; i++) {
        if (i === 4 || i === 8) {
          formattedValue += "-";
        }
        formattedValue += cleanedValue[i];
      }

      // Actualiza el valor del input
      this.dni = formattedValue;


    },
    async quitarValidacion() {
      await new Promise(resolve => setTimeout(resolve, 2000));
      const inputElement = document.querySelector('.form-control');

      // Elimina la clase CSS que agrega los estilos no deseados
      inputElement.classList.remove('was-validated');
      inputElement.classList.remove('is-invalid');

      // Sobrescribe los estilos en línea para eliminar los estilos no deseados
      inputElement.style.border = 'none';
      inputElement.style.paddingRight = 'initial';
      inputElement.style.backgroundImage = 'none';
      inputElement.style.backgroundRepeat = 'initial';
      inputElement.style.backgroundPosition = 'initial';
      inputElement.style.backgroundSize = 'initial';
    },

    restaurarSolicitud() {
      const solicitud = {
        ID: 0,
        clienteId: 0,
        producto: "",
        destinoCreditos: [],
        actividadEconomica: "",
        tiempoVivienda: "",
        materialVivienda: "",
        noPersonasVivivenda: "",
        noFamilias: "",
        noTrabajan: "",
        serviciosPublico: [],
        noDependientes: "",
        noBuscanEmpleo: "",
        planInversion: {
          req1: "",
          req2: "",
          req3: "",
          req4: "",
          req5: "",
          desc1: "",
          desc2: "",
          desc3: "",
          desc4: "",
          desc5: "",
          val1: 0,
          val2: 0,
          val3: 0,
          val4: 0,
          val5: 0,
        },
        referencias: {
          nom1: "",
          nom2: "",
          nom3: "",
          nom4: "",
          par1: "",
          par2: "",
          par3: "",
          par4: "",
          dir1: "",
          dir2: "",
          dir3: "",
          dir4: "",
          cel1: 0,
          cel2: 0,
          cel3: 0,
          cel4: 0,
        },
        referenciasExtra: [],
        sector: [],
        gruposEspeciales: [],
        idGrupoSolidario: 0,

        fechaPago: "",
        monto: 0,
        frecuenciaPago: "",
        interes: 12,
        tipoPlazo: "",
        plazoPago: 0,
        estado: 'pendiente',
        sucursal: '',
        
      };

      return solicitud;
    },
    getCountArchivos(id) {

            fetch(process.env.VUE_APP_API_URL + `/admin/solicitud/count-tipos-archivos/${id}`, Security.requestOptions({}))
                .then((response) => response.json())
                .then((response) => {
                    if (response.error) {
                        this.$emit('error', response.message);
                        console.error(response.message)


                    } else {

                        console.log('Contador Response:', response.data.data)
                        this.contadorArchivos = response.data.data
                        this.readyArchivos = true
                    }
                })
                .catch(error => {
                    this.$emit('error', error)
                })
        },
    getFirma(id) {

            fetch(process.env.VUE_APP_API_URL + `/admin/firma-digital/get-firma`, Security.requestOptions({solicitudID: id}))
                .then((response) => response.json())
                .then((response) => {
                    if (response.error) {
                        this.$emit('error', response.message);
                        console.error(response.message)


                    } else {

                        console.log('FIRMA DIGITAL:', response)
                        this.firmaBase64 = response.data.firmaDigital.firma_base64
                        if (this.firmaBase64) {
                          this.autorizadofirma = true
                        }
                        // this.contadorArchivos = response.data.data
                        // this.readyArchivos = true
                    }
                })
                .catch(error => {
                    this.$emit('error', error)
                })
        },
        reloadInfoArchivos(id){

          this.getCountArchivos(id);
        }
  },
  computed: {
    referenciasExtraBloqueadas() {
      const estado = this.solicitud?.estado;
      return (estado === 'Aprobado' || estado === 'Desembolsado') && !this.modoThanos;
    },
    noIntegregante() {
      switch (this.solicitudCompleta.integranteSolicitud) {
        case 0:
          return "Primer";
        case 1:
          return "Segundo";
        case 2:
          return "Tercer";
        case 3:
          return "Cuarto";
        case 4:
          return "Quinto";
        default:
          return "Número fuera de rango";
      }
    },
    // sumaTablaInverciones() {



    //   let suma = (parseFloat(this.solicitud.planInversion.val1) +
    //     parseFloat(this.solicitud.planInversion.val2) +
    //     parseFloat(this.solicitud.planInversion.val3) +
    //     parseFloat(this.solicitud.planInversion.val4) + parseFloat(this.solicitud.planInversion.val5))

    //   for (let i = 0; i < this.solicitud.filas.length; i++) {
    //     suma += parseFloat(this.solicitud.filas[i].valor);

    //   }
    //   return suma
    // },
    // validarGrupo() {
    //   if (this.solicitudCompleta.producto === `Escalonado`) {
    //     return true;
    //   } else return false;
    // },
    // validarMiPyme() {
    //   if (this.solicitudCompleta.producto !== `Escalonado`) {
    //     return true;
    //   } else return false;
    // },
    sumaTablaInverciones() {
  // Asegura que planInversion siempre existe
  const plan = this.solicitud?.planInversion || {};

  let suma =
    (parseFloat(plan.val1 ?? 0) || 0) +
    (parseFloat(plan.val2 ?? 0) || 0) +
    (parseFloat(plan.val3 ?? 0) || 0) +
    (parseFloat(plan.val4 ?? 0) || 0) +
    (parseFloat(plan.val5 ?? 0) || 0);

  // Asegura que filas sea un array
  const filas = Array.isArray(this.solicitud?.filas)
    ? this.solicitud.filas
    : [];

  for (let i = 0; i < filas.length; i++) {
    suma += parseFloat(filas[i]?.valor ?? 0) || 0;
  }

  return suma;
},
  },
  watch: {
    claseScore(){
      if (this.microCredito()) {
      this.obtenerTasaInteresMicro();
      }
    },
    reportes(value){
      // console.log(value);
      switch (value) {
        case 'reporte1':
          this.exportarSolicitudPDF('DESCARGA')
          this.reportes = 'Reportes'
          break;
        case 'reporte2':
          if(this.solicitud.estado === 'Aprobado' || this.solicitud.estado === 'Desembolsado'){
            this.exportacionContratos(this.solicitud, this.cuotaSolicitud, this.comisionDesembolso, this.comisionAsistenciaTecnica, this.tasaSeguridad)
          }
          this.reportes = 'Reportes'

          break;
        case 'reporte3':
         if(this.solicitud.estado === 'Aprobado' || this.solicitud.estado === 'Desembolsado'){
            exportacionPagares(this.solicitud, this.fechaVencimiento, this.comisionDesembolso, this.comisionAsistenciaTecnica)
          }
          this.reportes = 'Reportes'
          break;
        case 'reporte4':
         if(this.solicitud.estado === 'Aprobado' || this.solicitud.estado === 'Desembolsado'){
            exportacionFianza(this.solicitud, this.fechaVencimiento, this.comisionDesembolso, this.comisionAsistenciaTecnica)
          }
          this.reportes = 'Reportes'
          break;
        case 'reporte5': {

            let payloadEjemplo = {
          departamento: "Departamento de Francisco Morazán",
          fecha: "04 de febrero de 2026",
          destinatario: "Estimado(a) Señor(a):",

          ppcs: "Programa Presidencial Crédito Solidario (PPCS)",
          institucion: "Asociación Hondureña para el Desarrollo Integral Comunitario (AHDECO)",
          fechaVigencia: "20 de febrero de 2026",

          clausulaTexto:
            "La tasa de interés será fluctuante. El Beneficiario acepta los cambios que el PPCS apruebe.",

          tasaMenor30: "2% anual",
          tasaMayorIgual30: "1% mensual o 12% anual",

          asesorNombre: "Juan Pérez",
          asesorTelefono: "9876-5432",

          firmanteNombre: "ING. KAREN CACERES",
          firmanteCargo1: "ACCESO AL FINANCIAMIENTO",
          firmanteCargo2: "ASOCIACIÓN HONDUREÑA PARA EL DESARROLLO INTEGRAL COMUNITARIO",
          firmanteCargo3: "AHDECO",

          pie1: "Col. Rubén Darío, Casa 0592 Tegucigalpa, Honduras",
          pie2: "RTN:08269016867779",
          pie3: "Email: info@ahdecohn.org",
          pie4: "Telefono:2242-5780 ext. 5782",

          // Solo si vas a modo FIRMA:
          signerEmail: "andres15mol@gmail.com",
          senderEmail: "andres15mol@gmail.com",
        };
        
        this.exportarNotificacionCambioTasaPDF(payloadEjemplo,'DESCARGA')
        this.reportes = 'Reportes'
        break;
      }
      
        default:
          this.mostrarReporte1 = false
          this.mostrarReporte2 = false
          this.mostrarReporte3 = false
          break;
   
}

    },
    firmaBase64(value) {
      console.log(value);
      if (value) {
        this.autorizadofirma = true
      } 
    },
    arregloPagoIntereses(value) {
      console.log(value);
      if (!value) {
        this.pagosInteres = []
        // this.solicitud.pagosInteres = []
      } else if (value && this.solicitud.pagosInteres.length > 0) {
        this.pagosInteres = this.solicitud.pagosInteres
      }
    },
    pagosInteres: {
      handler(value) {
        console.log(value);
        let sumaMonto = 0;
        for (let i = 0; i < value.length; i++) {
          sumaMonto += value[i].monto;
        }
        sumaMonto = Math.round(sumaMonto * 100) / 100
        console.log("Suma de montos: ", sumaMonto, "Monto a pagar: ", this.montoAPInteres);
        this.validarPagosInteres = sumaMonto == this.montoAPInteres;
      },
      deep: true // Esto es lo que hacía falta
    },
    comisionDesembolso: function (comisionDesembolso) {
      if (!this.creditrabajo2() && !this.creaFuturo()) {
        this.totalComisionDesembolso = this.solicitud.monto * (comisionDesembolso / 100)
        this.montoNeto = this.solicitud.monto - this.totalComisionDesembolso - this.totalComisionAsistenciaTecnica - this.totalTasaSeguridad

      }

    },
    comisionAsistenciaTecnica: function (comisionAsistenciaTecnica) {
      if (!this.creditrabajo2() && !this.creaFuturo()) {
        this.totalComisionAsistenciaTecnica = this.solicitud.monto * (comisionAsistenciaTecnica / 100)
        this.montoNeto = this.solicitud.monto - this.totalComisionDesembolso - this.totalComisionAsistenciaTecnica - this.totalTasaSeguridad

      }
    },
    tasaSeguridad: function (tasaSeguridad) {
      if (!this.creditrabajo2() && !this.creaFuturo()) {
        this.totalTasaSeguridad = this.solicitud.monto * (tasaSeguridad / 100)
        this.montoNeto = this.solicitud.monto - this.totalComisionDesembolso - this.totalComisionAsistenciaTecnica - this.totalTasaSeguridad

      }
    },

    montoDesembolsar: function (monto) {
      console.log(monto);
      this.solicitud.montoDesembolsar = parseFloat(monto)
    },
    dni(dni) {
      if (Array.from(dni).length == 15) {
        const dniFormatToFetch = dni.replace(/-/g, "");
        
        console.log("Entre en DNI", dniFormatToFetch, this.dniAnterior);
        if(dniFormatToFetch != this.dniAnterior && this.dniAnterior){
          this.store.aprobacion.validacion = false;
          this.solicitudCompleta.integrantes.pop()
        }
        fetch(
          `${process.env.VUE_APP_API_URL}/admin/clientes/dni/${dniFormatToFetch}`,
          Security.requestOptions("")
        )
          .then((response) => response.json())
          .then((data) => {
            if (data.error) {
              this.$emit("error", data.message);
            } else {
              this.cliente = data.data;
              this.dniAnterior = this.cliente.dni
              this.solicitudCompleta.integrantes.push(data.data)
              this.$emit("datos-hijo-al-padre", data.data);
              console.log(data.data);
            }

            this.FotoBenficiario(this.cliente.dni)

          })
          .catch((error) => {
            this.$emit("error", error);
          });
      } else {
        this.cliente = "";
        this.solicitudCompleta.integrantes.pop()
        // this.mensajeDni = ""
        // dni = document.getElementById('dni');
        // dni.classList.remove('is-invalid')
        // dni.classList.add('was-validated')
      }
      

    },
    'solicitud.integrantesGruposSolidario.int1': function (dni) {
      console.log(dni);
      this.buscarIntegrantePorDni(dni, 1)

    },
    'solicitud.integrantesGruposSolidario.int2': function (dni) {

      this.buscarIntegrantePorDni(dni, 2)

    },
    'solicitud.integrantesGruposSolidario.int3': function (dni) {

      this.buscarIntegrantePorDni(dni, 3)

    },
    'solicitud.integrantesGruposSolidario.int4': function (dni) {

      this.buscarIntegrantePorDni(dni, 4)

    },
    'solicitud.integrantesGruposSolidario.int5': function (dni) {

      this.buscarIntegrantePorDni(dni, 5)

    },




    'solicitud.garantia': function (garantia) {

      const garantiaContent = document.getElementById('info_garantia')
      garantiaContent.innerHTML = ''

      if (garantia === "Garantía Fiduciaria") {
        garantiaContent.innerHTML = `
        <ul class="list-group">
          <li class="list-group-item">a)	Documento Nacional de Identificación DNI (Copia Legible).</li>
          <li class="list-group-item">b)	Registro Tributario Nacional o RTN (Copia Legible).</li>
          <li class="list-group-item">c)	Recibo público legible (con un mes de antigüedad).</li>
          <li class="list-group-item">d)	Constancia de Trabajo con deducciones y/o Váucher de pago de los últimos dos meses.</li>
          <li class="list-group-item">e)	Croquis de ubicación de la vivienda y Trabajo, con al menos cinco puntos de referencia.</li>
          <li class="list-group-item">f)	Fotografías de la Vivienda y del Trabajo.  </li>
          <li class="list-group-item">g)	Autorización Irrevocable de Deducción por Planilla (Si aplica). </li>
        </ul>
        `
      } else if (garantia === "Aval Comerciante") {
        garantiaContent.innerHTML = `
        <ul class="list-group">
          <li class="list-group-item">a)	Documento Nacional de Identificación DNI (Copia Legible)</li>
          <li class="list-group-item">b)	Registro Tributario Nacional o RTN (Copia Legible).</li>
          <li class="list-group-item">c)	Relación de ingresos/egresos.</li>
          <li class="list-group-item">d)	Recibo Publico legible (con un mes de antigüedad).</li>
          <li class="list-group-item">e)	Croquis de ubicación de la vivienda y Negocio, con al menos cinco puntos de referencia.</li>
          <li class="list-group-item">f)	Fotografías de la Vivienda y del Negocio. (Debe aparecer OM responsables del crédito)</li>
          <li class="list-group-item">g)	Constancia de verificación de negocio emitida por el OM responsables del Crédito.</li>
          <li class="list-group-item">h)	Referencias familiares o personales.</li>
        </ul>
        `
      } else if (garantia === "Garantía Mobiliaria") {
        garantiaContent.innerHTML = `
        <ul class="list-group">
          <li class="list-group-item">a)	Cotización Original del Equipo y Mobiliario nuevo a adquirir. (Este equipo debe formar parte de la garantía del crédito, sin menoscabo a las demás garantías solicitadas de acuerdo con el análisis de riesgo que presente el crédito).</li>
          <li class="list-group-item">b)	Presentar Factura original o Declaración Jurada de Propiedad del equipo propuesto   en Garantía.</li>
          <li class="list-group-item">c)	Contrato con Garantía Mobiliario.</li>
          <li class="list-group-item">d)	Contrato de subrogación de pagos (Hasta el 80% del valor del contrato).</li>
          <li class="list-group-item">e)	Declaración de garantías mobiliarias y Maquinaria otorgando hasta un máximo de 70% sobre el valor estimado.</li>
        </ul>
        `
      } else if (garantia === "Garantía Prendaria") {
        garantiaContent.innerHTML = `
        <ul class="list-group">
          <li class="list-group-item">a)	Avalúo del Vehículo, realizado por un taller mecánico autorizado por el Comité de Crédito.</li>
          <li class="list-group-item">b)	Documentos Originales del Vehículo.</li>
          <li class="list-group-item">c)	Traspaso del vehículo a favor de AHDECO.</li>
          <li class="list-group-item">d)	Solo se aceptarán vehículos de hasta 10 años de antigüedad.</li>
          <li class="list-group-item">e)	La relación crédito/garantía será hasta del 70% del valor de avalúo.</li>
        </ul>
        `
      } else if (garantia === "Garantía Hipotecaria") {
        garantiaContent.innerHTML = `
        <ul class="list-group">
          <li class="list-group-item">a)	Fotocopia de escritura del inmueble que dejará en garantía.</li>
          <li class="list-group-item">b)	Información soporte de la investigación registral en el sistema unificado de registro, para validar el estatus del inmueble. En los casos que el inmueble no tiene matricula en el sistema, se solicitará una constancia de liberación de gravamen.</li>
          <li class="list-group-item">c)	El dominio del inmueble debe ser "Dominio Pleno".</li>
          <li class="list-group-item">d)	Recibo de pago de bienes inmueble vigente o estado de cuenta que refleje que el pago está al día (en la Alcaldía Municipal).</li>
          <li class="list-group-item">e)	Constancia Original de valor catastral emitido por la Alcaldía Municipal.<li>
          <li class="list-group-item">f)	Avalúo del bien inmueble (Elaborado por valuador vigente y autorizado por AHDECO e inscrito en la Comisión Nacional de Bancos y Seguros).<li>
          <li class="list-group-item">g)	Recibo de la ENEE y SANAA del inmueble propuesto en garantía.<li>
          <li class="list-group-item">h)	Para inmuebles urbanos la relación préstamo/garantía será hasta un 80% del valor del avalúo y para inmuebles rurales hasta el 70% del valor del avalúo.<li>
          <li class="list-group-item">i)	Copia del Recibo de presentación en el registro de la Propiedad del Testimonio de escritura con la hipoteca del inmueble a favor de AHDECO.<li>
        </ul>
        `
      } else if (garantia === "Grupo Solidario") {
        garantiaContent.innerHTML = `
        <ul class="list-group">
          <li class="list-group-item">a)	Deberá estar conformado por grupos de beneficiarios de 2 a 5 integrantes, formados de manera voluntaria y que sean afines; los cuales deberán avalarse mutuamente y acceder a un crédito.</li>
          <li class="list-group-item">b)	Estar constituidos formalmente por Acta de constitución de Grupo (Ver anexo), debidamente firmada por los integrantes en la cual los integrantes manifiesten tener confianza entre sí y avalarse solidariamente.</li>
          <li class="list-group-item">c)	Los integrantes del grupo solidario deben ser ciudadanos hondureños por nacimiento naturalizados, con domicilio en el territorio nacional y encontrarse en el pleno ejercicio de sus derechos civiles.</li>
          <li class="list-group-item">d)	Se podrá otorgar créditos a jóvenes comprendidos entre los 18 y 21 años en cualquiera de las formas siguientes:
              <ul class="list-group">
                <li class="list-group-item">  a.	Quienes se hayan emancipado, ya sea por constituirse como comerciante o por haber contraído matrimonio. (Presentar constancia extendida por el RNP). </li>
                  <li class="list-group-item">  b.	Con autorización de los padres o representantes legales en instrumento público o interviniendo el mismo expresa y directamente en el acto (firmando el contrato de crédito).</li>
                    <li class="list-group-item">  c.	Tener un Coordinador o Presidente del Grupo Solidario el cual deberá ser elegido democráticamente por los demás integrantes.</li>
              </ul>
            </li>
        </ul>
        `
      }

    },
    'solicitud.estado': function (estado) {
      const userRoles = Security.getUserRoles();
      const formulario = document.getElementById('cliente-form');
      const int1 = document.getElementById('int1gs');
      const int2 = document.getElementById('int2gs');
      const int3 = document.getElementById('int3gs');
      const int4 = document.getElementById('int4gs');
      const int5 = document.getElementById('int5gs');
      const inputs = formulario.querySelectorAll('input')

      const selects = formulario.querySelectorAll('select')
      if (estado === 'Aprobado' || estado === 'Desembolsado') {
        inputs.forEach(input => {
          input.disabled = true;
        })
        selects.forEach(select => {
          select.disabled = true;
        })
        document.getElementById('fecha').disabled = false
      }
      if (estado === 'Aprobado' || estado === 'Desembolsado') {

        selects.forEach(select => {
          select.name === 'garantia' ? select.disabled = false : select.disabled = true;
          select.name === 'reportes' ? select.disabled = false : select.disabled = true;
        })
        document.getElementById('fecha').disabled = false
      }
      if (userRoles[0]?.some(role => role.includes('Modo Thanos')) === true) {
        document.getElementById('fecha').disabled = true
        inputs.forEach(input => {
          input.disabled = false;
        })
        selects.forEach(select => {
          select.disabled = false;
        })
      }
      if ((userRoles[0]?.some(role => role.includes('Asesor')) === true) ) {
        int1.disabled = false;
        int2.disabled = false;
        int3.disabled = false;
        int4.disabled = false;
        int5.disabled = false;

      }
    },
    'solicitud.monto': function () {
      if (this.microCredito()) {
        this.onBlur()
      }
    },
    'solicitud.plazoPago': function (plazo) {
      console.log(plazo);
      this.onBlur()
      if (this.creditrabajo2()) {

        console.log("CRÉDITO DE TRABAJO 2");
        switch (plazo) {
          case 1:
            this.solicitud.interes = 12
            this.comisionDesembolso = 4.27
            this.comisionAsistenciaTecnica = 3.80
            this.tasaSeguridad = 0.40
            break;
          case 2:
            this.solicitud.interes = 8.16
            this.comisionDesembolso = 4.08
            this.comisionAsistenciaTecnica = 3.62
            this.tasaSeguridad = 0.40
            break;
          case 3:
            this.solicitud.interes = 22.56
            this.comisionDesembolso = 3.9
            this.comisionAsistenciaTecnica = 3.47
            this.tasaSeguridad = 0.40
            break;
          case 4:
            this.solicitud.interes = 28.68
            this.comisionDesembolso = 3.74
            this.comisionAsistenciaTecnica = 3.32
            this.tasaSeguridad = 0.40
            break;
          case 5:
            this.solicitud.interes = 31.56
            this.comisionDesembolso = 3.59
            this.comisionAsistenciaTecnica = 3.19
            this.tasaSeguridad = 0.40
            break;
          case 6:
            this.solicitud.interes = 33
            this.comisionDesembolso = 3.9
            this.comisionAsistenciaTecnica = 3.47
            this.tasaSeguridad = 0.40
            break;
          default:
            this.solicitud.interes = 12
            this.comisionDesembolso = 4.27
            this.comisionAsistenciaTecnica = 3.80
            this.tasaSeguridad = 0.40
            break;
        }

      } else if (this.solicitudCompleta.producto === "CREAFUTURO") {
        //Parece que no se usa


        // this.solicitud.interes = 12
        this.comisionDesembolso = 3.5
        this.comisionAsistenciaTecnica = 4.5
        this.tasaSeguridad = 0.2
        this.reservasSeguros = 1.6
        this.consultasBuro = 0.2
        // this.solicitud.interes = 12
        //     this.comisionDesembolso = 2.5
        //     this.comisionAsistenciaTecnica = 3.5
        //     this.tasaSeguridad = 0.2
      } 
      




    },

  },
  
};
</script>

<style scoped>
.custom-table {
  outline: none;
  border: none;
  margin: 0px;
  padding: 0px;
  border-collapse: collapse;

  >tbody>tr>td {
    margin: 0px;
    padding: 0px;
    border: none;
    vertical-align: middle;

    .control {
      text-align: left;
      font-size: 1rem;
    }
  }
}

.btnOptionSolicitud {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  /* flex-wrap: wrap; */
}

.card {


  border-radius: 12px;
  /* border-left-color: #4285f4; */
  border-top: 5px solid #ff910088;
  border-left: 5px solid #4286f467;
}

/* .form-control {
  border-radius: 10px;
  height: 70%;
  
} */

/* .form-control:focus {
  border-color: #ff9100;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.1);
} */

/* Sombra */
.col-form-label {
  margin: 0px !important;
}

.form-group {
  margin-bottom: 0px;
}

.form-group {
  margin-block: 8px;
}

.col-form-label {
  padding-left: 10px;
  padding-right: 5px;
}

.card-description {
  margin-block: 15px;
}


.btnn {
  /* background-color: aqua; */
  border-radius: 50px;
  width: 50px;
  height: 50px;
}

.btnn p {
  margin-bottom: 0px;
  color: white;
}

.plan-inversión {
  /* width: 50%; */
  /* border-collapse: collapse; */
  margin-bottom: 20px;
}

.plan-inversión,
th,
td {
  border: 1px solid black;
  text-align: center;
}

th,
td {
  padding: 10px;
  vertical-align: top;
  /* Alinea el contenido en la parte superior de las celdas */
}

.input-plan {
  width: 100%;
  box-sizing: border-box;
  border: none;
  /* Elimina los bordes de los inputs */
  outline: none;
  /* Elimina el contorno al hacer clic en los inputs */
}

.table-container {
  width: 70%;
}

.custom-table {
  border-collapse: collapse;
  width: 100%;
}

.custom-table th,
.custom-table td {
  border: 1px solid black;
  padding: 10px;
  text-align: center;
  vertical-align: top;
}

.custom-input {
  width: 100%;
  box-sizing: border-box;
  border: none;
  outline: none;
}
</style>

<style>
.carta {
  border-radius: 12px;

  /* border-left-color: #4285f4; */
  /* border-top: 5px solid #00ff0d88; */
  /* border-left: 5px solid #ffea0667; */
  >.row {
    display: flex;
    flex-wrap: nowrap;
    justify-content: center;
    align-items: center;
    gap: 10px;
  }
}

.referencia-extra {
  padding-left: 12px !important;
  padding-right: 12px !important;
}

@media screen and (max-width: 768px) {
  .carta {
    >.row {
      flex-direction: column;

      >div {
        width: 100%;
      }
    }
  }

}

.fm {
  border-radius: 10px;
  height: 70%;
}

.fm:focus {
  border-color: #ff9100;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.1);
  /* Sombra */
}

.pad {
  /* padding-left: 5px; */
  padding-inline: 5px !important;
}

.bounce {
  -webkit-animation-name: bounce;
  animation-name: bounce;
  -webkit-transform-origin: center bottom;
  -ms-transform-origin: center bottom;
  transform-origin: center bottom;
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}

@-webkit-keyframes bounce {

  0%,
  20%,
  53%,
  80%,
  100% {
    -webkit-transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }

  40%,
  43% {
    -webkit-transition-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
    transition-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
    -webkit-transform: translate3d(0, -30px, 0);
    transform: translate3d(0, -30px, 0);
  }

  70% {
    -webkit-transition-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
    transition-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
    -webkit-transform: translate3d(0, -15px, 0);
    transform: translate3d(0, -15px, 0);
  }

  90% {
    -webkit-transform: translate3d(0, -4px, 0);
    transform: translate3d(0, -4px, 0);
  }
}

@keyframes bounce {

  0%,
  20%,
  53%,
  80%,
  100% {
    -webkit-transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }

  40%,
  43% {
    -webkit-transition-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
    transition-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
    -webkit-transform: translate3d(0, -30px, 0);
    transform: translate3d(0, -30px, 0);
  }

  70% {
    -webkit-transition-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
    transition-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
    -webkit-transform: translate3d(0, -15px, 0);
    transform: translate3d(0, -15px, 0);
  }

  90% {
    -webkit-transform: translate3d(0, -4px, 0);
    transform: translate3d(0, -4px, 0);
  }
}
</style>


<!-- Estilos tabla de amortizacion -->

<style>
#contenedor-plan,
#contenedorTabla {
  background-color: #FFF;
  border-radius: 5px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);
  overflow: auto;
  width: 100%;
  max-width: 100%;

  >.header {
    width: 100%;

  }
}

/* #contenedorTabla {
  width: 100%;
  max-height: 80%;
  overflow-y: hidden;
  overflow-x: auto;
} */


.table-plan {
  border: 2px solid royalblue;
  border-collapse: collapse;
  border-radius: 4px;
  width: 100%;
  text-align: center;
  font-family: inherit;
  font-size: 0.9em;
  padding: 10px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);
}

.table-plan thead tr {
  background: royalblue;
  color: white;
  text-align: left;
  font-weight: bold;
}

.table-plan thead,
td {
  padding: 12px 15px;
}

.table-plan tbody tr {
  border-bottom: 1px solid #F0F0F0;
}

.table-plan tbody tr:nth-last-of-type(even) {
  background-color: #F3F3F3;
}

.table-plan tbody tr:last-of-type {
  border-bottom: 2px solid royalblue;
}

.table-plan tbody tr:hover {
  color: white;
  background: rgba(65, 105, 225, 90%);
}

.table-plan tfoot {
  background: royalblue;
  color: white;
}
</style>


<!-- Estilos formularios  -->

<style scoped>
::-webkit-scrollbar {
  width: 12px;
  height: 12px;
}

::-webkit-scrollbar-track {
  border: 1px solid rgba(0, 0, 0, 0.3);
  border-radius: 10px;
}

::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.3);
  border-radius: 10px;
}

::-webkit-scrollbar-thumb:hover {
  background: royalblue;
}

.header,
thead {
  border-bottom: 1px solid #F0F0F0;
  background-color: #F7F7F7;
  padding: 20px 40px;
}

.header h2 {
  margin: 0;
  width: 100%;
}

#frmPrestamo {
  padding: 30px 40px;
}

#frmPrestamo .control,
#amortizaciones .control,
.radios {
  margin-bottom: 10px;
  padding-bottom: 20px;
  position: relative;
}

#frmPrestamo .control label {
  margin-bottom: 5px;
}

#frmPrestamo .control input,
#frmPrestamo .control select {
  border: 2px solid #F0F0F0;
  border-radius: 4px;
  font-family: inherit;
  font-size: 14px;
  padding: 10px;
  width: 100%;
}

#frmPrestamo .control input:focus {
  outline: 0;
  border-color: royalblue;
}

#frmPrestamo button {
  background: rgba(65, 105, 225, 90%);
  border: 2px solid royalblue;
  border-radius: 4px;
  color: #FFF;
  display: block;
  font-family: inherit;
  font-size: medium;
  padding: 10px;
  margin-top: 20px;
  width: 100%;
}

.radios {
  padding: 10px 20px;
}

.radioContenedor {
  display: inline-block;
  position: relative;
  cursor: pointer;
  user-select: none;
  padding-left: 30px;
  margin: 10px;
}

.radioContenedor input {
  display: none;
}

.radioContenedor .circle {
  left: 0;
  top: 0;
  width: 25px;
  height: 25px;
  border-radius: 50px;
  position: absolute;
  display: inline-block;
  background-color: rgba(65, 105, 225, 90%);
  border-bottom: 2px solid royalblue;
}

.radioContenedor:hover .circle {
  background-color: royalblue;
}

.radioContenedor input:checked+.circle {
  background-color: royalblue;
}

.radioContenedor input:checked+.circle:after {
  content: '';
  height: 10px;
  width: 10px;
  background-color: white;
  position: absolute;
  border-radius: 50%;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.fa-star {
  color: #fff200;
}

.form-group {
  background-color: #f5f5f5f5;
  border-radius: 10px;
  margin-left: 10px;
  width: 97%;
}

p {
  margin: 0;
}

.btn {
  color: white;
  /* width: 100px; */
}

.arreglo-pago-interes {

  background-color: #f0f0f0;
  border-radius: 5px;
  padding: 10px;
}


@media (max-width: 768px) {
  .accordion-body{
  padding: 10px;
}
#frmPrestamo{
  padding: 10px;
}
.card-body{
  padding: 10px;
}
.content-wrapper{
  padding: 10px;
}
}

.sin-foto{
  width: 130px;
  height: 170px;
  border-radius: 5px;
  background-color: #e0e0e0;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #757575;
  font-size: 60px;
  text-align: center;
}

.extra-info{
  /* background-color: #ff9100; */
}
.extra-info:hover{
  background-color: #d9d9d9;
}
</style>
